(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[36117,598,42227,68425,53120,59765,99360],{

/***/ 274:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/screener",
      function () {
        return __webpack_require__(87394);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 87394:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages_screener; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/global/Loading/PageLoader.jsx + 2 modules
var PageLoader = __webpack_require__(598);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 17 modules
var es = __webpack_require__(2497);
// EXTERNAL MODULE: ./src/features/screener/slice.ts
var slice = __webpack_require__(15183);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Button.js
var Button = __webpack_require__(20539);
;// CONCATENATED MODULE: ./src/features/screener/components/Header/ScreenerButton/index.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: flex;\n  gap: 10px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  :hover {\n    color: ",
        ";\n    background: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







var SHeaderTopContainerButton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3bfa37a3-0"
})(_templateObject());
var SButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-3bfa37a3-1"
})(_templateObject1(), color/* default.primary */.Z.primary, color/* default.aliceBlue */.Z.aliceBlue);
var ScreenerButton = function() {
    var dispatch = (0,es/* useDispatch */.I0)();
    var _actions = slice/* default.actions */.ZP.actions, setIsFormActive = _actions.setIsFormActive, setIsFormCreateMode = _actions.setIsFormCreateMode, setIsModalPresetScreenerActive = _actions.setIsModalPresetScreenerActive, setIsFormEditMode = _actions.setIsFormEditMode, resetFormState = _actions.resetFormState;
    var createNewScreenerHandler = function() {
        dispatch(resetFormState());
        dispatch(setIsFormActive(true));
        dispatch(setIsFormCreateMode(true));
        dispatch(setIsFormEditMode(false));
    };
    var showPresetScreenerHandler = function() {
        dispatch(setIsModalPresetScreenerActive(true));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SHeaderTopContainerButton, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                type: "primary",
                onClick: createNewScreenerHandler,
                children: "Create New"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SButton, {
                onClick: showPresetScreenerHandler,
                children: "Preset Screener"
            })
        ]
    });
};
/* harmony default export */ var Header_ScreenerButton = (ScreenerButton);

// EXTERNAL MODULE: ./node_modules/antd/es/radio/index.js + 4 modules
var es_radio = __webpack_require__(29924);
;// CONCATENATED MODULE: ./src/@deprecated-ui/screener/Radio.js
/* eslint-disable jsx-a11y/label-has-associated-control */ /* eslint-disable jsx-a11y/label-has-for */ 
function Radio_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .ant-radio-button-wrapper {\n    margin-right: 8px;\n    :last-child {\n      margin: 0;\n    }\n  }\n  overflow: hidden;\n\n  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {\n    border-color: ",
        ";\n    color: ",
        ";\n    background: ",
        ';\n  }\n  .ant-radio-button-wrapper-checked:not([class*=" ant-radio-button-wrapper-disabled"]).ant-radio-button-wrapper {\n    border-color: ',
        ";\n  }\n  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled)::before {\n    background-color: ",
        ";\n  }\n"
    ]);
    Radio_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Radio_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-color: ",
        ";\n  :hover {\n    color: ",
        ";\n    background: ",
        ";\n  }\n"
    ]);
    Radio_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



// helper - styled components
var Group = (0,styled_components_browser_esm/* default */.ZP)(es_radio/* default.Group */.ZP.Group).withConfig({
    componentId: "sc-656c5ae6-0"
})(Radio_templateObject(), color/* default.gainsboro */.Z.gainsboro, color/* default.primary */.Z.primary, color/* default.aliceBlue */.Z.aliceBlue, color/* default.gainsboro */.Z.gainsboro, color/* default.gainsboro */.Z.gainsboro);
var Radio_Button = (0,styled_components_browser_esm/* default */.ZP)(es_radio/* default.Button */.ZP.Button).withConfig({
    componentId: "sc-656c5ae6-1"
})(Radio_templateObject1(), color/* default.gainsboro */.Z.gainsboro, color/* default.primary */.Z.primary, color/* default.aliceBlue */.Z.aliceBlue);
var Radio = es_radio/* default */.ZP;
Radio.Group = Group;
Radio.Button = Radio_Button;
/* harmony default export */ var screener_Radio = (Radio);

;// CONCATENATED MODULE: ./src/features/screener/components/Header/FavoritesBar/index.tsx

function FavoritesBar_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n  max-width: 86%;\n  height: 32px;\n  overflow: hidden;\n\n  label > span:nth-child(2) {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n"
    ]);
    FavoritesBar_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var FavoritesBarContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-82e52741-0"
})(FavoritesBar_templateObject());
var FavoritesBar = function() {
    // prettier-ignore
    var ref = (0,react.useState)([]), listFavorites = ref[0], setListFavorites = ref[1];
    var ref1 = (0,react.useState)(0), activeFavoritesID = ref1[0], setActiveFavoritesID = ref1[1];
    var ref2 = (0,es/* useSelector */.v9)(slice/* screenerSelectors */.p0), screenerFavorites = ref2.screenerFavorites, _screenerResult = ref2.screenerResult, screenerid = _screenerResult.data.screenerid;
    var dispatch = (0,es/* useDispatch */.I0)();
    var _actions = slice/* default.actions */.ZP.actions, setIsFormActive = _actions.setIsFormActive, setIsFormCreateMode = _actions.setIsFormCreateMode, setIsFormEditMode = _actions.setIsFormEditMode;
    var visibleFavoritesScreener = listFavorites;
    var onSelectFavoritesHandler = function(values) {
        var _target = values.target, presetType = _target.presetType, value = _target.value;
        setActiveFavoritesID(value);
        dispatch(slice/* screenerEffects.getScreener */.Ko.getScreener({
            screenerID: value,
            type: presetType
        }));
        dispatch(setIsFormActive(false));
        dispatch(setIsFormCreateMode(false));
        dispatch(setIsFormEditMode(false));
    };
    (0,react.useEffect)(function() {
        var data = screenerFavorites.data;
        setListFavorites(data);
    }, [
        screenerFavorites
    ]);
    (0,react.useEffect)(function() {
        if (listFavorites.length && activeFavoritesID === 0) {
            var ref = listFavorites[0], id = ref.id, type = ref.type;
            dispatch(slice/* screenerEffects.getScreener */.Ko.getScreener({
                screenerID: id,
                type: type
            }));
        }
    }, [
        listFavorites
    ]);
    (0,react.useEffect)(function() {
        if (screenerid) {
            setActiveFavoritesID(screenerid);
        }
    }, [
        screenerid
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FavoritesBarContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(screener_Radio.Group, {
            defaultValue: activeFavoritesID,
            onChange: onSelectFavoritesHandler,
            value: activeFavoritesID,
            children: visibleFavoritesScreener.map(function(param) {
                var name = param.name, id = param.id, type = param.type;
                var showedName = (name === null || name === void 0 ? void 0 : name.length) > 50 ? "".concat(name === null || name === void 0 ? void 0 : name.substring(0, 50), "...") : name;
                return(// @ts-expect-error
                /*#__PURE__*/ (0,jsx_runtime.jsx)(screener_Radio.Button, {
                    value: id,
                    presetType: type,
                    children: showedName
                }, id));
            })
        })
    });
};
/* harmony default export */ var Header_FavoritesBar = (FavoritesBar);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Iconmoon.js
var Iconmoon = __webpack_require__(15807);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Popover.js
var Popover = __webpack_require__(70187);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Modal.js
var Modal = __webpack_require__(16368);
;// CONCATENATED MODULE: ./src/features/screener/components/Modal/DeleteModal/index.tsx

function DeleteModal_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0 16px;\n"
    ]);
    DeleteModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var BlockModalFooter = function(param) {
    var onCancel = param.onCancel, onOk = param.onOk, screenerID = param.screenerID;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                block: true,
                height: "40px",
                type: "borderless",
                radius: "unset",
                onClick: function() {
                    return onCancel();
                },
                style: {
                    borderTop: "1px solid ".concat(color/* default.gainsboro */.Z.gainsboro)
                },
                children: "Cancel"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                type: "primary",
                radius: "unset",
                block: true,
                height: "40px",
                onClick: function() {
                    return onOk(screenerID);
                },
                children: "Confirm"
            })
        ]
    });
};
var ModalContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-dedc6e06-0"
})(DeleteModal_templateObject());
var DeleteModal = function(param) {
    var isVisible = param.isVisible, title = param.title, screenerName = param.screenerName, screenerID = param.screenerID, onCancel = param.onCancel, onOk = param.onOk;
    var ModalContent = // @ts-expect-error
    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
        pb: "15px",
        children: [
            'Are you sure want to remove "',
            screenerName,
            '" ?'
        ]
    });
    var ModalFooter = /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockModalFooter, {
        onOk: onOk,
        onCancel: onCancel,
        screenerID: screenerID
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
        destroyOnClose: true,
        visible: isVisible,
        title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
            // @ts-expect-error
            p: "18px",
            align: "center",
            family: "bold",
            size: "18px",
            children: title
        }),
        footer: ModalFooter,
        maskStyle: {
            backgroundColor: "rgba(0,0,0,0.8)"
        },
        onCancel: onCancel,
        centered: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalContainer, {
            children: ModalContent
        })
    });
};
/* harmony default export */ var Modal_DeleteModal = (DeleteModal);

;// CONCATENATED MODULE: ./src/features/screener/components/Header/FavoritesDropdown/index.tsx
/* eslint-disable no-nested-ternary */ 


function FavoritesDropdown_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n  max-width: 242px;\n  border-radius: 3px !important;\n  min-width: 200px;\n  ::-webkit-scrollbar {\n    width: 4px;\n    height: 5px;\n  }\n\n  @media screen and (min-width: 720px) {\n    ::-webkit-scrollbar-thumb {\n      background: ",
        ";\n      border: 0 ",
        ";\n      border-radius: 0;\n    }\n  }\n"
    ]);
    FavoritesDropdown_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function FavoritesDropdown_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-bottom: 1px solid ",
        ";\n  &:last-child {\n    border-bottom: none;\n  }\n"
    ]);
    FavoritesDropdown_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  :hover {\n    cursor: pointer;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  :hover {\n    p {\n      color: ",
        ";\n    }\n    background: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}












var ContentWrapper = (0,styled_components_browser_esm/* default */.ZP)(Popover/* PopoverContentWrapper */.R_).withConfig({
    componentId: "sc-98eb7ec2-0"
})(FavoritesDropdown_templateObject(), color/* default.gainsboro */.Z.gainsboro, color/* default.aliceBlue */.Z.aliceBlue);
var SFlexItemFavoriteContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-98eb7ec2-1"
})(FavoritesDropdown_templateObject1(), color/* default.gainsboro */.Z.gainsboro);
var SFlexItemFavorite = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-98eb7ec2-2"
})(_templateObject2());
var FavoritesDropdown_SButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-98eb7ec2-3"
})(_templateObject3(), color/* default.primary */.Z.primary, color/* default.aliceBlue */.Z.aliceBlue);
var Menu = function(param) {
    var title = param.title, data = param.data, menuType = param.menuType, onClickStar = param.onClickStar, onClickLabel = param.onClickLabel, onClickCross = param.onClickCross;
    // @ts-expect-error
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(SFlexItemFavoriteContainer, {
        direction: "column",
        p: "8px",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                textTransform: "uppercase",
                color: color/* default.midgray */.Z.midgray,
                size: "12px",
                children: title
            }),
            (data === null || data === void 0 ? void 0 : data.length) === 0 && menuType === "favorite" && // @ts-expect-error
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                mt: "8px",
                weight: "400",
                children: "You dont have any favorite screener"
            }),
            data.map(function(param) {
                var name = param.name, id = param.id, type = param.type, favorite = param.favorite;
                if (favorite === 1 && menuType === "all") {
                    return null;
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SFlexItemFavorite, {
                    justify: "space-between",
                    align: "center",
                    // @ts-expect-error
                    pb: "4px",
                    height: "30px",
                    width: "100%",
                    onClick: function() {
                        onClickLabel(id, type);
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            width: "calc(100% - 48px)",
                            ellipsis: true,
                            children: name
                        }),
                        favorite === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* default */.Z, {
                            className: "icon-trading_delete",
                            onClick: function(e) {
                                onClickCross(e, id, name);
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* default */.Z, {
                            className: type === "TEMPLATE_TYPE_GURU" ? "icon-trading_star-fill" : menuType === "favorite" ? "icon-trading_star-fill" : "icon-trading_star",
                            color: color/* default.primary */.Z.primary,
                            onClick: function(e) {
                                onClickStar(e, id, type);
                            }
                        })
                    ]
                });
            })
        ]
    });
};
var FavoriteDropdown = function() {
    // prettier-ignore
    var ref = (0,react.useState)([]), screenerFavorites = ref[0], setScreenerFavorites = ref[1];
    // prettier-ignore
    var ref1 = (0,react.useState)([]), screenerCustom = ref1[0], setScreenerCustom = ref1[1];
    // prettier-ignore
    var ref2 = (0,react.useState)(false), isDeleteModalVisible = ref2[0], setIsDeleteModalVisible = ref2[1];
    var ref3 = (0,react.useState)({
        id: null,
        name: null
    }), deleteScreener = ref3[0], setDeleteScreener = ref3[1];
    var ref4 = (0,es/* useSelector */.v9)(slice/* screenerSelectors */.p0), _screenerFavorites = ref4.screenerFavorites, dataFavorites = _screenerFavorites.data, _screenerCustom = ref4.screenerCustom, dataCustoms = _screenerCustom.data, _removeScreenerCustomResult = ref4.removeScreenerCustomResult, dataRemoveCustomResult = _removeScreenerCustomResult.data;
    var removeFavorite = slice/* screenerEffects.removeFavorite */.Ko.removeFavorite, addFavorite = slice/* screenerEffects.addFavorite */.Ko.addFavorite, getScreenerCustom = slice/* screenerEffects.getScreenerCustom */.Ko.getScreenerCustom, getScreener = slice/* screenerEffects.getScreener */.Ko.getScreener, removeScreenerCustom = slice/* screenerEffects.removeScreenerCustom */.Ko.removeScreenerCustom;
    var _actions = slice/* default.actions */.ZP.actions, setIsFormActive = _actions.setIsFormActive, setIsFormCreateMode = _actions.setIsFormCreateMode, setIsFormEditMode = _actions.setIsFormEditMode;
    var dispatch = (0,es/* useDispatch */.I0)();
    var resetFormState = function() {
        dispatch(setIsFormActive(false));
        dispatch(setIsFormCreateMode(false));
        dispatch(setIsFormEditMode(false));
    };
    var adjustFavorite = function(screenerID) {
        var result = screenerCustom.map(function(el) {
            if (Number(el.id) === Number(screenerID)) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, el), {
                    favorite: el.favorite === 0 ? 1 : 0
                });
            }
            return (0,_object_spread/* default */.Z)({}, el);
        });
        setScreenerCustom(result);
    };
    var onClickFavoriteStar = function(e, screenerID, screenerType) {
        e.stopPropagation();
        adjustFavorite(screenerID);
        dispatch(removeFavorite({
            screenerID: screenerID,
            screenerType: screenerType
        }));
    };
    var onClickFavoriteLabel = function(guruID, type) {
        resetFormState();
        dispatch(getScreener({
            screenerID: guruID,
            type: type
        }));
    };
    var onClickScreenerStar = function(e, screenerID) {
        e.stopPropagation();
        adjustFavorite(screenerID);
        dispatch(addFavorite({
            screenerID: screenerID,
            screenerType: "TEMPLATE_TYPE_CUSTOM"
        }));
    };
    var onClickScreenerLabel = function(guruID) {
        resetFormState();
        dispatch(getScreener({
            screenerID: guruID,
            type: "TEMPLATE_TYPE_CUSTOM"
        }));
    };
    var onClickScreenerCross = function(e, screenerID, screenerName) {
        e.stopPropagation();
        setDeleteScreener(function(prevState) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), {
                id: screenerID,
                name: screenerName
            });
        });
        setIsDeleteModalVisible(true);
    };
    var PopoverContent = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentWrapper, {
            children: [
                Menu({
                    title: "My Favorites",
                    data: screenerFavorites,
                    menuType: "favorite",
                    onClickStar: onClickFavoriteStar,
                    onClickLabel: onClickFavoriteLabel,
                    onClickCross: null
                }),
                Menu({
                    title: "ALL SCREENER",
                    data: screenerCustom,
                    menuType: "all",
                    onClickStar: onClickScreenerStar,
                    onClickLabel: onClickScreenerLabel,
                    onClickCross: onClickScreenerCross
                })
            ]
        });
    };
    var onClickCancelModal = function() {
        setIsDeleteModalVisible(false);
    };
    var onClickOkModal = function(screenerID) {
        dispatch(removeScreenerCustom({
            id: screenerID
        }));
        setIsDeleteModalVisible(false);
    };
    (0,react.useEffect)(function() {
        dispatch(getScreenerCustom());
    }, []);
    (0,react.useEffect)(function() {
        setScreenerFavorites(dataFavorites);
    }, [
        dataFavorites
    ]);
    (0,react.useEffect)(function() {
        setScreenerCustom(dataCustoms);
    }, [
        dataCustoms
    ]);
    (0,react.useEffect)(function() {
        dispatch(getScreenerCustom());
    }, [
        dataRemoveCustomResult
    ]);
    (0,react.useEffect)(function() {
        dispatch(getScreenerCustom());
    }, [
        screenerFavorites
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Popover/* default */.ZP, {
                content: PopoverContent,
                placement: "bottomRight",
                trigger: "click",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FavoritesDropdown_SButton, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        justify: "space-between",
                        align: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                padding: "0 8px 0 0",
                                children: "Favorites"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* default */.Z, {
                                className: "icon-toolbar_down"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_DeleteModal, {
                isVisible: isDeleteModalVisible,
                title: "Remove from favorites",
                screenerID: deleteScreener.id,
                screenerName: deleteScreener.name,
                onCancel: onClickCancelModal,
                onOk: onClickOkModal
            })
        ]
    });
};
/* harmony default export */ var FavoritesDropdown = (FavoriteDropdown);

;// CONCATENATED MODULE: ./src/features/screener/components/Header/index.tsx

function Header_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  margin-bottom: 15px;\n  background: ",
        ";\n  border-radius: 3px;\n  border: 1px solid ",
        ";\n"
    ]);
    Header_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Header_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 20px;\n  border-bottom: 1px solid ",
        ";\n"
    ]);
    Header_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Header_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 10px 20px;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"
    ]);
    Header_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Header_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 700;\n  color: ",
        ";\n  font-size: 16px;\n  cursor: pointer;\n  margin: 0px;\n"
    ]);
    Header_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}









var SHeaderContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e4ad0330-0"
})(Header_templateObject(), color/* default.light */.Z.light, color/* default.gainsboro */.Z.gainsboro);
var SHeaderTopContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e4ad0330-1"
})(Header_templateObject1(), color/* default.gainsboro */.Z.gainsboro);
var SHeaderBottomContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e4ad0330-2"
})(Header_templateObject2());
var SHeaderTopContainerTitle = styled_components_browser_esm/* default.h5.withConfig */.ZP.h5.withConfig({
    componentId: "sc-e4ad0330-3"
})(Header_templateObject3(), color/* default.dimgray */.Z.dimgray);
var Index = function() {
    var getScreenerFavorites = slice/* screenerEffects.getScreenerFavorites */.Ko.getScreenerFavorites, getScreenerUniverse = slice/* screenerEffects.getScreenerUniverse */.Ko.getScreenerUniverse;
    var dispatch = (0,es/* useDispatch */.I0)();
    (0,react.useEffect)(function() {
        dispatch(getScreenerFavorites());
        dispatch(getScreenerUniverse());
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SHeaderContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SHeaderTopContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SHeaderTopContainerTitle, {
                        children: "Stock Screener"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_ScreenerButton, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SHeaderBottomContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_FavoritesBar, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FavoritesDropdown, {})
                ]
            })
        ]
    });
};
/* harmony default export */ var Header = (Index);

// EXTERNAL MODULE: ./src/utils/general.js
var general = __webpack_require__(42227);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Input.js
var Input = __webpack_require__(54325);
// EXTERNAL MODULE: ./src/utils/number.js
var number = __webpack_require__(62974);
// EXTERNAL MODULE: ./src/global/AlertErrorMessage/index.js + 1 modules
var AlertErrorMessage = __webpack_require__(25516);
// EXTERNAL MODULE: ./src/constants/errorMessage.js
var errorMessage = __webpack_require__(61608);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/antd/es/dropdown/index.js + 2 modules
var dropdown = __webpack_require__(38504);
;// CONCATENATED MODULE: ./src/@deprecated-ui/screener/Dropdown.js

function Dropdown_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    Dropdown_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Dropdown = (0,styled_components_browser_esm/* default */.ZP)(dropdown/* default */.Z).withConfig({
    componentId: "sc-1b53b2c8-0"
})(Dropdown_templateObject());
/* harmony default export */ var screener_Dropdown = (Dropdown);

// EXTERNAL MODULE: ./node_modules/antd/es/menu/index.js + 8 modules
var menu = __webpack_require__(58928);
;// CONCATENATED MODULE: ./src/@deprecated-ui/screener/Menu.js

function Menu_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    Menu_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Menu_Menu = (0,styled_components_browser_esm/* default */.ZP)(menu/* default */.Z).withConfig({
    componentId: "sc-137c9a62-0"
})(Menu_templateObject());
/* harmony default export */ var screener_Menu = (Menu_Menu);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./src/features/screener/components/AutoSuggestion/index.tsx
var AutoSuggestion = __webpack_require__(27358);
// EXTERNAL MODULE: ./src/constants/data-cy.ts
var data_cy = __webpack_require__(70524);
;// CONCATENATED MODULE: ./src/features/screener/components/Body/ScreenerForm/ScreenerRules/styled.ts

function styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 100%;\n  display: flex;\n\n  .ant-select-selector {\n    border-radius: 3px !important;\n  }\n\n  & > button {\n    border-radius: 3px;\n  }\n  & > input {\n    border-radius: 3px !important;\n  }\n  & > .icon-trading_delete {\n    position: relative;\n    display: flex;\n    align-items: center;\n    padding: 0px 8px;\n  }\n"
    ]);
    styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  row-gap: 15px;\n"
    ]);
    styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: bold;\n  display: flex;\n  align-items: center;\n  padding-left: 9px;\n"
    ]);
    styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid ",
        ";\n  padding: 2px 4px;\n  margin: 0 10px;\n  border-radius: 3px;\n"
    ]);
    styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




var ContainerBasicScreener = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e1141925-0"
})(styled_templateObject());
var ContainerScreenerRules = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs({
    align: "center",
    width: "100%",
    mr: "8px",
    direction: "column"
}).withConfig({
    componentId: "sc-e1141925-1"
})(styled_templateObject1());
var IconRemove = (0,styled_components_browser_esm/* default */.ZP)(Iconmoon/* default */.Z).attrs({
    className: "icon-toolbar_delete",
    color: color/* default.sunsetOrange */.Z.sunsetOrange
}).withConfig({
    componentId: "sc-e1141925-2"
})(styled_templateObject2());
var SSelect = styled_components_browser_esm/* default.select.withConfig */.ZP.select.withConfig({
    componentId: "sc-e1141925-3"
})(styled_templateObject3(), color/* default.gainsboro */.Z.gainsboro);


;// CONCATENATED MODULE: ./src/features/screener/components/Body/ScreenerForm/ScreenerRules/index.tsx
/* eslint-disable react/no-array-index-key */ /* eslint-disable function-paren-newline */ 




















var operatorOptions = [
    ">",
    "<",
    "<=",
    "=",
    ">="
];
var ScreenerRules = function(param) {
    var defaultValue = param.defaultValue, onChangeRules = param.onChangeRules, onRunScreener = param.onRunScreener;
    var ref = (0,react.useState)(0), modalFinancialIndex = ref[0], setModalFinancialIndex = ref[1];
    var ref1 = (0,react.useState)(""), modalFinancialType = ref1[0], setModalFinancialType = ref1[1];
    var ref2 = (0,react.useState)([
        {
            type: "basic",
            item1: null,
            item1name: "",
            operator: ">",
            item2: null,
            multiplier: ""
        }, 
    ]), screenerRules = ref2[0], setScreenerRules = ref2[1];
    var delayTimer = (0,react.useRef)(undefined);
    var ref3 = (0,es/* useSelector */.v9)(slice/* screenerSelectors */.p0), financialModal = ref3.screenerModal.financialModal;
    var setIsModalFinancialMetricActive = slice/* default.actions.setIsModalFinancialMetricActive */.ZP.actions.setIsModalFinancialMetricActive;
    var dispatch = (0,es/* useDispatch */.I0)();
    var showModalFinancial = function(indexRules, type, fieldName) {
        dispatch(setIsModalFinancialMetricActive(true));
        setModalFinancialIndex(indexRules);
        setModalFinancialType("".concat(type, ".").concat(fieldName));
    };
    var onModalClosed = function(id, name, modalType) {
        if (modalType === "basic.only") {
            setScreenerRules(function(prevState) {
                return Object.assign([], prevState, (0,_define_property/* default */.Z)({}, modalFinancialIndex, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState[modalFinancialIndex]), {
                    item1: id,
                    item1name: name
                })));
            });
        } else {
            var ref = (0,_sliced_to_array/* default */.Z)(modalType.split("."), 2), type = ref[0], align = ref[1];
            setScreenerRules(function(prevState) {
                var _obj;
                return Object.assign([], prevState, (0,_define_property/* default */.Z)({}, modalFinancialIndex, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState[modalFinancialIndex]), (_obj = {}, (0,_define_property/* default */.Z)(_obj, "".concat(align), id), (0,_define_property/* default */.Z)(_obj, "".concat(align, "name"), name), _obj))));
            });
        }
    };
    var onAutocompleteSelect = function(id, name, idx, type, fieldName) {
        if (type === "basic") {
            setScreenerRules(function(prevState) {
                return Object.assign([], prevState, (0,_define_property/* default */.Z)({}, idx, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState[idx]), {
                    item1: id,
                    item1name: name
                })));
            });
        } else {
            setScreenerRules(function(prevState) {
                var _obj;
                return Object.assign([], prevState, (0,_define_property/* default */.Z)({}, idx, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState[idx]), (_obj = {}, (0,_define_property/* default */.Z)(_obj, fieldName, id), (0,_define_property/* default */.Z)(_obj, "".concat(fieldName, "name"), name), _obj))));
            });
        }
    };
    var onOperatorSelect = function(value, idx) {
        setScreenerRules(function(prevState) {
            return Object.assign([], prevState, (0,_define_property/* default */.Z)({}, idx, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState[idx]), {
                operator: value
            })));
        });
    };
    var onInputRules = function(input, idx, fieldName) {
        var value = input.target.value;
        setScreenerRules(function(prevState) {
            return Object.assign([], prevState, (0,_define_property/* default */.Z)({}, idx, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState[idx]), (0,_define_property/* default */.Z)({}, fieldName, value))));
        });
    };
    var onChooseScreenerType = function(item) {
        var key = item.key;
        if (key === "basic-ratio") {
            setScreenerRules(function(prevState) {
                return prevState.concat([
                    {
                        type: "basic",
                        item1: null,
                        item1name: "",
                        operator: ">",
                        item2: null,
                        multiplier: ""
                    }, 
                ]);
            });
        } else {
            setScreenerRules(function(prevState) {
                return prevState.concat([
                    {
                        type: "compare",
                        item1: null,
                        item1name: "",
                        operator: ">",
                        multiplier: "",
                        item2: null,
                        item2name: ""
                    }, 
                ]);
            });
        }
    };
    var onRemoveRules = function(idx) {
        var result = (0,_to_consumable_array/* default */.Z)(screenerRules.slice(0, idx)).concat((0,_to_consumable_array/* default */.Z)(screenerRules.slice(idx + 1)));
        setScreenerRules(result);
    };
    var AddRules = function(param) {
        var onMenuClick = param.onMenuClick;
        var RulesContent = /*#__PURE__*/ (0,jsx_runtime.jsxs)(screener_Menu, {
            // @ts-expect-error
            onClick: function(item) {
                onMenuClick(item);
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(screener_Menu.Item, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        align: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* default */.Z, {
                                className: "icon-compose_plus"
                            }),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                pl: "8px",
                                children: "Basic Ratio"
                            })
                        ]
                    })
                }, "basic-ratio"),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(screener_Menu.Item, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        align: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* default */.Z, {
                                className: "icon-compose_plus"
                            }),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                ml: "8px",
                                children: "Ratio Vs Ratio"
                            })
                        ]
                    })
                }, "ratio-vs-ratio")
            ]
        });
        return(// @ts-expect-error
        /*#__PURE__*/ (0,jsx_runtime.jsx)(screener_Dropdown, {
            overlay: RulesContent,
            trigger: "click",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                p: "6px 8px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    justify: "space-between",
                    align: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* default */.Z, {
                            className: "icon-compose_plus"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            padding: "0 0 0 8px",
                            children: "Add a Rule"
                        })
                    ]
                })
            })
        }));
    };
    (0,react.useEffect)(function() {
        var id = financialModal.id, name = financialModal.name;
        if (id && name) {
            onModalClosed(id, name, modalFinancialType);
        }
    }, [
        financialModal
    ]);
    (0,react.useEffect)(function() {
        clearTimeout(delayTimer.current);
        delayTimer.current = setTimeout(function() {
            onChangeRules(screenerRules);
        }, 100);
    }, [
        screenerRules
    ]);
    (0,react.useEffect)(function() {
        setScreenerRules(defaultValue);
    }, [
        defaultValue
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        direction: "column",
        width: "100%",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                color: color/* default.dimgray */.Z.dimgray,
                weight: "700",
                as: "h3",
                pb: "10px",
                family: "bold",
                children: "Screening Rules"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContainerScreenerRules, {
                children: screenerRules.map(function(param, rulesIndex) {
                    var type = param.type, item1name = param.item1name, operator = param.operator, item2 = param.item2, multiplier = param.multiplier, item2name = param.item2name;
                    if (type === "basic") {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContainerBasicScreener, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoSuggestion/* default */.Z, {
                                    width: "50%",
                                    paddingX: "0px",
                                    paddingT: "0px",
                                    type: "financial",
                                    selectedValue: item1name,
                                    placeholder: "Please enter the ratio name",
                                    onClickSuggestion: function(id, name) {
                                        onAutocompleteSelect(id, name, rulesIndex, type, undefined);
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    width: "10px",
                                    height: "32px",
                                    // @ts-expect-error
                                    p: "4px 11px",
                                    onClick: function() {
                                        showModalFinancial(rulesIndex, "basic", "only");
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* default */.Z, {
                                        size: "14px",
                                        className: "icon-toolbar_down"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SSelect, {
                                    onChange: function(e) {
                                        onOperatorSelect(e.target.value, rulesIndex);
                                    },
                                    children: operatorOptions.map(function(operation, operatorIndex) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                            value: operation,
                                            selected: operation === operator,
                                            children: operation
                                        }, "operator-".concat(operatorIndex + 1));
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                    value: item2,
                                    onChange: function(e) {
                                        onInputRules(e, rulesIndex, "item2");
                                    },
                                    name: "value",
                                    width: "45%"
                                }, "".concat(type, "-").concat(rulesIndex)),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(IconRemove, {
                                    onClick: function() {
                                        return onRemoveRules(rulesIndex);
                                    },
                                    "data-cy": data_cy/* default.SCREENER.DELETE_RULES_BUTTON */.Z.SCREENER.DELETE_RULES_BUTTON
                                })
                            ]
                        }, "".concat(type, "-").concat(rulesIndex));
                    }
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContainerBasicScreener, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoSuggestion/* default */.Z, {
                                width: "calc((90% - 165px)/ 2)",
                                paddingX: "0px",
                                paddingT: "0px",
                                type: "financial",
                                selectedValue: item1name,
                                placeholder: "Please enter the ratio name",
                                onClickSuggestion: function(id, name) {
                                    onAutocompleteSelect(id, name, rulesIndex, type, "item1");
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                width: "10px",
                                height: "32px",
                                // @ts-expect-error
                                p: "4px 11px",
                                onClick: function() {
                                    showModalFinancial(rulesIndex, "compare", "item1");
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* default */.Z, {
                                    size: "14px",
                                    className: "icon-toolbar_down"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SSelect, {
                                onChange: function(e) {
                                    onOperatorSelect(e.target.value, rulesIndex);
                                },
                                children: operatorOptions.map(function(operation, operatorIndex) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                        value: operation,
                                        selected: operation === operator,
                                        children: operation
                                    }, "operator-".concat(operatorIndex + 1));
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                value: multiplier,
                                onChange: function(e) {
                                    onInputRules(e, rulesIndex, "multiplier");
                                },
                                name: "value",
                                width: "10%",
                                // @ts-expect-error
                                mr: "10px"
                            }, "".concat(type, "-").concat(rulesIndex)),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                as: "span",
                                align: "center",
                                justify: "center",
                                mr: "10px",
                                style: {
                                    fontWeight: "bold"
                                },
                                children: "x"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoSuggestion/* default */.Z, {
                                width: "calc((90% - 165px)/ 2)",
                                paddingX: "0px",
                                paddingT: "0px",
                                type: "financial",
                                selectedValue: item2name,
                                placeholder: "Please enter the ratio name",
                                onClickSuggestion: function(id, name) {
                                    onAutocompleteSelect(id, name, rulesIndex, type, "item2");
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                width: "10px",
                                height: "32px",
                                // @ts-expect-error
                                p: "4px 11px",
                                onClick: function() {
                                    showModalFinancial(rulesIndex, "compare", "item2");
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* default */.Z, {
                                    size: "14px",
                                    className: "icon-toolbar_down"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconRemove, {
                                onClick: function() {
                                    return onRemoveRules(rulesIndex);
                                }
                            })
                        ]
                    }, "".concat(type, "-").concat(rulesIndex));
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                pt: "15px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AddRules, {
                        onMenuClick: onChooseScreenerType
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        ml: "15px",
                        type: "primary",
                        onClick: onRunScreener,
                        children: "Screen"
                    })
                ]
            })
        ]
    });
};
ScreenerRules.defaultProps = {
    defaultValue: []
};
ScreenerRules.propTypes = {
    defaultValue: prop_types_default().instanceOf(Array)
};
/* harmony default export */ var ScreenerForm_ScreenerRules = (/*#__PURE__*/react.memo(ScreenerRules));

// EXTERNAL MODULE: ./src/@deprecated-ui/common/Select.js
var Select = __webpack_require__(6305);
;// CONCATENATED MODULE: ./src/features/screener/components/Body/ScreenerForm/ScreenerStocks/index.tsx











var SelectOption = Select/* default.Option */.Z.Option;
var ScreenerStocks = function(param) {
    var defaultValue = param.defaultValue, onSelectUniverse = param.onSelectUniverse;
    var ref = (0,react.useState)(null), filteredSectors = ref[0], setFilteredSectors = ref[1];
    var ref1 = (0,react.useState)(null), filteredIndex = ref1[0], setFilteredIndex = ref1[1];
    var ref2 = (0,react.useState)(null), filteredWatchlist = ref2[0], setFilteredWatchlist = ref2[1];
    var ref3 = (0,react.useState)("IHSG"), selectedSector = ref3[0], setSelectedSector = ref3[1];
    var ref4 = (0,es/* useSelector */.v9)(slice/* screenerSelectors */.p0), data = ref4.screenerUniverse.data;
    var sectors = data.sectors, index = data.index, watchlist = data.watchlist;
    var filterIndex = function(query) {
        var lowerCaseQuery = query.toLowerCase();
        var ref = index[0], list = ref.list, name = ref.name;
        if (name.toLowerCase().includes(lowerCaseQuery)) {
            return index;
        }
        var filteredList = list.filter(function(el) {
            return el.name.toLowerCase().includes(lowerCaseQuery);
        });
        return [
            {
                name: name,
                list: filteredList
            }
        ];
    };
    var filterSector = function(query) {
        var lowerCaseQuery = query.toLowerCase();
        return sectors.filter(function(el) {
            return JSON.stringify(el).toLowerCase().includes(lowerCaseQuery);
        });
    };
    var filterWatchlist = function(query) {
        var lowerCaseQuery = query.toLowerCase();
        return watchlist.filter(function(el) {
            return el.name.toLowerCase().includes(lowerCaseQuery);
        });
    };
    var onTypeHandler = function(e) {
        var query = e.target.value;
        if (query.length !== 0) {
            var foundSector = filterSector(query);
            var foundIndex = filterIndex(query);
            var foundWatchlist = filterWatchlist(query);
            setFilteredSectors(foundSector);
            setFilteredIndex(foundIndex);
            setFilteredWatchlist(foundWatchlist);
        } else {
            setFilteredSectors(null);
            setFilteredIndex(null);
            setFilteredWatchlist(null);
        }
    };
    var dropdownSectorSearch = function(dropdownItem) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                    // @ts-expect-error
                    mx: "8px",
                    width: "calc(100% - 16px)",
                    onChange: onTypeHandler,
                    "data-cy": data_cy/* default.SCREENER.STOCK_SEARCH_INPUT */.Z.SCREENER.STOCK_SEARCH_INPUT
                }),
                dropdownItem
            ]
        });
    };
    var onSelectHandler = function(val) {
        var ref = (0,_sliced_to_array/* default */.Z)(val.split("."), 2), name = ref[0], id = ref[1];
        setSelectedSector(val);
        onSelectUniverse(name, id);
    };
    var recomposeSectors = function() {
        var sectorsOption = [
            // @ts-expect-error
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectOption, {
                disabled: true,
                children: "Sectors"
            }, "sector-title"), 
        ];
        if (filteredSectors) {
            filteredSectors === null || filteredSectors === void 0 ? void 0 : filteredSectors.forEach(function(param) {
                var name = param.name, scopeSect = param.scope, idSect = param.id, subsector = param.subsector;
                sectorsOption.push(/*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectOption, {
                            value: "".concat(scopeSect, ".").concat(idSect),
                            style: {
                                paddingLeft: "30px"
                            },
                            children: name
                        }, "".concat(scopeSect, "-").concat(idSect)),
                        subsector.map(function(param) {
                            var idSub = param.id, subSectorName = param.name, scopeSub = param.scope;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectOption, {
                                value: "".concat(scopeSub, ".").concat(idSub),
                                style: {
                                    paddingLeft: "46px"
                                },
                                children: subSectorName
                            }, "".concat(scopeSub, "-").concat(idSub));
                        })
                    ]
                }, "".concat(scopeSect, "-").concat(idSect)));
            });
        } else {
            sectors === null || sectors === void 0 ? void 0 : sectors.forEach(function(param) {
                var name = param.name, scopeSect = param.scope, idSect = param.id, subsector = param.subsector;
                sectorsOption.push(/*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectOption, {
                            value: "".concat(scopeSect, ".").concat(idSect),
                            style: {
                                paddingLeft: "30px"
                            },
                            children: name
                        }, "".concat(scopeSect, "-").concat(idSect)),
                        subsector.map(function(param) {
                            var idSub = param.id, subSectorName = param.name, scopeSub = param.scope;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectOption, {
                                value: "".concat(scopeSub, ".").concat(idSub),
                                style: {
                                    paddingLeft: "46px"
                                },
                                children: subSectorName
                            }, "".concat(scopeSub, "-").concat(idSub));
                        })
                    ]
                }, "".concat(scopeSect, "-").concat(idSect)));
            });
        }
        return sectorsOption;
    };
    var recomposeIndex = function() {
        var indexOption = [
            // @ts-expect-error
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectOption, {
                disabled: true,
                children: "Index"
            }, "index-title"), 
        ];
        if (filteredIndex) {
            filteredIndex.forEach(function(param) {
                var name = param.name, id = param.id, scope = param.scope, list = param.list;
                if (list.length > 0) {
                    indexOption.push(/*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectOption, {
                                value: "".concat(scope, ".").concat(id),
                                style: {
                                    paddingLeft: "30px"
                                },
                                children: name
                            }, "".concat(scope, ".").concat(id)),
                            list.map(function(param) {
                                var listId = param.id, listName = param.name, listScope = param.scope;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectOption, {
                                    style: {
                                        paddingLeft: "46px"
                                    },
                                    value: "".concat(listScope, ".").concat(listId),
                                    children: listName
                                }, "".concat(listScope, ".").concat(listId));
                            })
                        ]
                    }, "".concat(id, "-").concat(name)));
                }
            });
        } else {
            index === null || index === void 0 ? void 0 : index.forEach(function(param) {
                var name = param.name, list = param.list, id = param.id, scope = param.scope;
                indexOption.push(/*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectOption, {
                            value: "".concat(scope, ".").concat(id),
                            style: {
                                paddingLeft: "30px"
                            },
                            children: name
                        }, "".concat(scope, ".").concat(id)),
                        list.map(function(param) {
                            var listId = param.id, listName = param.name, listScope = param.scope;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectOption, {
                                style: {
                                    paddingLeft: "46px"
                                },
                                value: "".concat(listScope, ".").concat(listId),
                                children: listName
                            }, "".concat(listScope, ".").concat(listId));
                        })
                    ]
                }, "".concat(id, "-").concat(name)));
            });
        }
        return indexOption;
    };
    var recomposeWatchlist = function() {
        var watchlistOption = [
            // @ts-expect-error
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectOption, {
                disabled: true,
                children: "Watchlist"
            }, "watchlist-title"), 
        ];
        if (filteredWatchlist) {
            filteredWatchlist.forEach(function(param) {
                var name = param.name, id = param.id, scope = param.scope;
                watchlistOption.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(SelectOption, {
                    value: "".concat(scope, ".").concat(id),
                    style: {
                        paddingLeft: "30px"
                    },
                    children: name
                }, "".concat(scope, ".").concat(id)));
            });
        } else {
            watchlist === null || watchlist === void 0 ? void 0 : watchlist.forEach(function(param) {
                var name = param.name, id = param.id, scope = param.scope;
                watchlistOption.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectOption, {
                        value: "".concat(scope, ".").concat(id),
                        style: {
                            paddingLeft: "30px"
                        },
                        children: name
                    }, "".concat(scope, ".").concat(id))
                }, "".concat(id, "-").concat(name)));
            });
        }
        return watchlistOption;
    };
    var handleOptions = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                recomposeIndex(),
                recomposeSectors(),
                recomposeWatchlist()
            ]
        });
    };
    (0,react.useEffect)(function() {
        var scope = defaultValue.scope, scopeID = defaultValue.scopeID;
        if (scopeID !== "") {
            setSelectedSector("".concat(scope, ".").concat(scopeID));
        } else {
            setSelectedSector("".concat(scope));
        }
    }, [
        defaultValue
    ]);
    (0,react.useEffect)(function() {
        handleOptions();
    }, [
        filteredSectors,
        filteredIndex,
        filteredWatchlist
    ]);
    return(// @ts-expect-error
    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        direction: "column",
        mb: "15px",
        width: "100%",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                color: color/* default.dimgray */.Z.dimgray,
                weight: "700",
                as: "h3",
                pb: "10px",
                family: "bold",
                children: "Stock Universe"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* default */.Z, {
                // @ts-expect-error
                name: "stockUniverse",
                width: "300px",
                dropdownRender: dropdownSectorSearch,
                showArrow: true,
                onChange: onSelectHandler,
                value: selectedSector,
                onSearch: onTypeHandler,
                children: handleOptions()
            })
        ]
    }));
};
// I've test this memo, and its necessary
/* harmony default export */ var ScreenerForm_ScreenerStocks = (/*#__PURE__*/(0,react.memo)(ScreenerStocks));

// EXTERNAL MODULE: ./src/global/Loading/PrimarySpinner.tsx
var PrimarySpinner = __webpack_require__(32253);
;// CONCATENATED MODULE: ./src/features/screener/components/Body/styled.ts

function Body_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: block;\n  width: 100%;\n  padding: 20px;\n  background: ",
        ";\n  border-radius: 3px;\n  border: 1px solid ",
        ";\n  margin-bottom: 0px;\n  border-top: 1px solid ",
        ";\n  margin-top: 0px;\n"
    ]);
    Body_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Body_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    border-top: 1px solid ",
        ";\n    margin-top: 20px;\n  "
    ]);
    Body_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Body_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: block;\n  width: 100%;\n  padding: 10px 20px;\n  background: ",
        ";\n  border-radius: 3px 3px 0 0;\n  border: 1px solid ",
        ";\n  margin-bottom: 0px;\n\n  border-top: none;\n  margin-top: 0px;\n\n  ",
        "\n"
    ]);
    Body_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Body_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: block;\n  background: ",
        ";\n  border-right: 1px solid ",
        ";\n  border-left: 1px solid ",
        ";\n  border-bottom: 1px solid ",
        ";\n  border-radius: 0 0 3px 3px;\n"
    ]);
    Body_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  padding-bottom: 45px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      display: block;\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n  &::before {\n    border-top: 2px solid #ccc;\n    border-right: 2px solid transparent;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 240px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: ",
        ";\n  margin-top: 15px;\n  border-radius: 3px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}



// prettier-ignore
var SContainerScreenerBody = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6f84e760-0"
})(Body_styled_templateObject(), color/* default.light */.Z.light, color/* default.gainsboro */.Z.gainsboro, color/* default.gainsboro */.Z.gainsboro);
// prettier-ignore
var SContainerScreenerPagination = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6f84e760-1"
})(Body_styled_templateObject2(), color/* default.light */.Z.light, color/* default.gainsboro */.Z.gainsboro, function(param) {
    var isFormActive = param.isFormActive;
    return isFormActive && (0,styled_components_browser_esm/* css */.iv)(Body_styled_templateObject1(), color/* default.gainsboro */.Z.gainsboro);
});
var SContainerScreenerTable = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6f84e760-2"
})(Body_styled_templateObject3(), color/* default.light */.Z.light, color/* default.gainsboro */.Z.gainsboro, color/* default.gainsboro */.Z.gainsboro, color/* default.gainsboro */.Z.gainsboro);
var SContainerScreener = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6f84e760-3"
})(_templateObject4());
var ScreenerLoadingOverlay = (0,styled_components_browser_esm/* default */.ZP)(PrimarySpinner/* default */.Z).attrs({
    overlay: true
}).withConfig({
    componentId: "sc-6f84e760-4"
})(_templateObject6(), function(param) {
    var isLoading = param.isLoading;
    return isLoading && (0,styled_components_browser_esm/* css */.iv)(_templateObject5());
});
var ScreenerResultEmpty = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6f84e760-5"
})(_templateObject7(), color/* default.light */.Z.light);


;// CONCATENATED MODULE: ./src/features/screener/components/Body/ScreenerForm/index.tsx
/* eslint-disable array-callback-return */ /* eslint-disable consistent-return */ 



function ScreenerForm_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: none;\n  .ant-input-group-addon {\n    background: ",
        ";\n  }\n  .ant-input:hover,\n  .ant-input:focus,\n  .ant-input-focused {\n    border-color: #d9d9d9;\n    box-shadow: none;\n  }\n"
    ]);
    ScreenerForm_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
















var TextArea = Input/* default.TextArea */.Z.TextArea;
var getRandomInt = number/* default.getRandomInt */.ZP.getRandomInt;
var SInput = (0,styled_components_browser_esm/* default */.ZP)(Input/* default */.Z).withConfig({
    componentId: "sc-2d0bf8a8-0"
})(ScreenerForm_templateObject(), color/* default.whisper */.Z.whisper);
var createSequence = function(rules) {
    var sequenceList = [];
    rules.forEach(function(param) {
        var type = param.type, item1 = param.item1, item2 = param.item2;
        var nItem1 = Number(item1);
        var nItem2 = Number(item2);
        if (sequenceList.indexOf(nItem1) < 0) sequenceList.push(nItem1);
        if (type !== "basic" && sequenceList.indexOf(nItem2) < 0) {
            sequenceList.push(nItem2);
        }
    });
    return sequenceList.join();
};
var ScreenerForm = function() {
    var ref = (0,es/* useSelector */.v9)(slice/* screenerSelectors */.p0), _screenerUtils = ref.screenerUtils, isFormEditMode = _screenerUtils.isFormEditMode, isFormCreateMode = _screenerUtils.isFormCreateMode, screenerAction = _screenerUtils.screenerAction, _screenerResult = ref.screenerResult, screenerResultData = _screenerResult.data;
    var postScreener = slice/* screenerEffects.postScreener */.Ko.postScreener, getScreenerCustom = slice/* screenerEffects.getScreenerCustom */.Ko.getScreenerCustom, getScreenerFavorites = slice/* screenerEffects.getScreenerFavorites */.Ko.getScreenerFavorites;
    var ref1 = (0,react.useState)({
        name: "",
        description: "",
        save: "1",
        ordertype: "asc",
        ordercol: 2,
        page: 1,
        universe: {
            scope: "IHSG",
            scopeID: "",
            name: ""
        },
        filters: [
            {
                type: "basic",
                item1: null,
                item1name: "",
                operator: ">",
                item2: null,
                multiplier: ""
            }, 
        ],
        sequence: ""
    }), form = ref1[0], setForm = ref1[1];
    var ref2 = (0,react.useState)(false), isLoading = ref2[0], setIsLoading = ref2[1];
    var dispatch = (0,es/* useDispatch */.I0)();
    var onInputForm = function(field, value) {
        setForm(function(prevState) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), (0,_define_property/* default */.Z)({}, field, value));
        });
    };
    var onSelectUniverse = function(scope, scopeID) {
        setForm(function(prevState) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), {
                universe: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState.universe), {
                    scope: scope,
                    scopeID: scopeID
                })
            });
        });
    };
    var onChangeRules = function(rules) {
        if (rules !== form.filters) {
            var sequences = createSequence(rules);
            setForm(function(prevState) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), {
                    filters: rules,
                    sequence: sequences,
                    save: "1"
                });
            });
            if (rules.length === 0) {
                dispatch(slice/* default.actions.updateScreenerResult */.ZP.actions.updateScreenerResult({
                    screenerAction: screenerAction,
                    screener: {
                        rules: rules
                    }
                }));
            }
        }
    };
    var resetState = function() {
        setForm({
            name: "",
            description: "",
            save: "1",
            ordertype: "asc",
            ordercol: 2,
            page: 1,
            universe: {
                scope: "IHSG",
                scopeID: "",
                name: ""
            },
            filters: [
                {
                    type: "basic",
                    item1: null,
                    item1name: "",
                    operator: ">",
                    item2: null,
                    multiplier: ""
                }, 
            ],
            sequence: ""
        });
    };
    var validateFormScreener = function(func) {
        if (form.filters.length === 0) {
            (0,AlertErrorMessage/* default */.Z)(errorMessage/* default.SCREENER_SPECIFY_RULES */.Z.SCREENER_SPECIFY_RULES, errorMessage/* default.ALERT_RED */.Z.ALERT_RED);
            return;
        }
        return func();
    };
    var parseScreenerRules = function(rules) {
        var updatedRules = rules.map(function(rule) {
            var item2 = rule.item1 !== "" ? rule.item2 : "";
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rule), {
                item2: rule.item2 ? item2 : 0
            });
        });
        return updatedRules;
    };
    var onSaveScreener = function() {
        return validateFormScreener(function() {
            var ref;
            setIsLoading(true);
            var randomName = "TEMPLATE_BUILD_".concat(getRandomInt(1, 9999), "_").concat(getRandomInt(1, 9999));
            var screenerName = form.name;
            if (!(form === null || form === void 0 ? void 0 : form.screenerid) && !screenerName) screenerName = randomName;
            var parsedScreenerRules = parseScreenerRules(form.filters);
            var correctForm = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, form), {
                name: screenerName,
                universe: JSON.stringify(form.universe),
                filters: JSON.stringify(parsedScreenerRules),
                screenerid: (form === null || form === void 0 ? void 0 : (ref = form.screenerid) === null || ref === void 0 ? void 0 : ref.toString()) || undefined,
                fromForm: true
            });
            setForm(function(prev) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                    filters: parsedScreenerRules
                });
            });
            onInputForm("name", screenerName);
            // @ts-ignore
            dispatch(postScreener(correctForm)).then(function() {
                dispatch(getScreenerCustom());
                dispatch(getScreenerFavorites());
                setIsLoading(false);
            });
        });
    };
    var onRunScreener = function() {
        return validateFormScreener(function() {
            var randomName = "TEMPLATE_BUILD_".concat(getRandomInt(1, 9999), "_").concat(getRandomInt(1, 9999));
            var screenerName = form.name !== "" ? form.name : randomName;
            var parsedScreenerRules = parseScreenerRules(form.filters);
            var correctForm = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, form), {
                screenerid: "0",
                name: screenerName,
                save: "0",
                universe: JSON.stringify(form.universe),
                filters: JSON.stringify(parsedScreenerRules),
                type: "TEMPLATE_TYPE_CUSTOM",
                fromForm: true
            });
            setForm(function(prev) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                    filters: parsedScreenerRules
                });
            });
            onInputForm("name", screenerName);
            dispatch(postScreener(correctForm));
        });
    };
    var convertRules = function(rules) {
        var convertedRules = [];
        rules.map(function(rule) {
            convertedRules.push({
                type: rule.type,
                item1: rule.item1,
                item1name: rule.item1_name,
                operator: rule.operator,
                item2: rule.item2,
                item2name: rule.item2_name,
                multiplier: rule.multiplier
            });
        });
        return convertedRules;
    };
    var initValueFormEdit = function(screenName, screenDesc, sort, order, universe, sequence, rules, screenerid, isguru) {
        var parsedUniverse = JSON.parse(universe);
        setForm(function(prevState) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), {
                name: screenName,
                description: screenDesc,
                ordertype: sort,
                ordercol: order,
                universe: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState.universe), {
                    scope: parsedUniverse.scope,
                    scopeID: parsedUniverse.scopeID,
                    name: parsedUniverse.name
                }),
                sequence: sequence.join(),
                filters: convertRules(rules),
                screenerid: isguru ? "0" : screenerid
            });
        });
    };
    (0,react.useEffect)(function() {
        var screenName = screenerResultData.screen_name, screenDesc = screenerResultData.screen_desc, sort = screenerResultData.sort, order = screenerResultData.order, universe = screenerResultData.universe, sequence = screenerResultData.sequence, rules = screenerResultData.rules, screenerid = screenerResultData.screenerid, isguru = screenerResultData.isguru;
        if (isFormEditMode) {
            initValueFormEdit(screenName, screenDesc, sort, order, universe, sequence, rules, screenerid, isguru);
        }
    }, [
        screenerResultData
    ]);
    (0,react.useEffect)(function() {
        if (isFormCreateMode) {
            resetState();
        }
    }, [
        isFormCreateMode
    ]);
    var name = form.name, description = form.description, universe = form.universe, filters = form.filters;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScreenerLoadingOverlay, {
                isLoading: isLoading
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                justify: "space-between",
                width: "100%",
                mb: "15px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SInput, {
                        width: "calc(100% - 130px)",
                        // prettier-ignore
                        addonBefore: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            color: color/* default.highempahis */.Z.highempahis,
                            weight: "700",
                            family: "bold",
                            children: "Screen Name"
                        }),
                        name: "screenName",
                        // @ts-expect-error
                        mr: "12px",
                        onChange: function(e) {
                            onInputForm("name", e.target.value);
                        },
                        defaultValue: name,
                        value: name
                    }, "input"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        type: "primary",
                        p: "4px 10px",
                        onClick: onSaveScreener,
                        children: "Save Screener"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                direction: "column",
                mb: "15px",
                width: "100%",
                as: "h3",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: color/* default.dimgray */.Z.dimgray,
                        weight: "700",
                        family: "bold",
                        children: "Description"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextArea, {
                        // @ts-expect-error
                        mt: "10px",
                        name: "description",
                        rows: 1,
                        autoSize: true,
                        onChange: function(e) {
                            onInputForm("description", e.target.value);
                        },
                        defaultValue: description,
                        value: description
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScreenerForm_ScreenerStocks, {
                defaultValue: universe,
                onSelectUniverse: onSelectUniverse
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScreenerForm_ScreenerRules, {
                defaultValue: filters,
                onChangeRules: onChangeRules,
                onRunScreener: onRunScreener
            })
        ]
    });
};
// I've test this memo, and its necessary
/* harmony default export */ var Body_ScreenerForm = (/*#__PURE__*/react.memo(ScreenerForm));

;// CONCATENATED MODULE: ./src/features/screener/components/Body/ScreenerMain/ScreenerLabel/index.tsx

function ScreenerLabel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid ",
        ";\n  border-bottom: none;\n  background: ",
        ";\n  padding: 20px;\n"
    ]);
    ScreenerLabel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ScreenerLabel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: none;\n  && input {\n    color: ",
        "\n  }\n  && input:disabled {\n    background: #FAFAFA;\n  }\n  .ant-input-group-addon {\n    background: ",
        ";\n  }\n"
    ]);
    ScreenerLabel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}










var SFlex = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-d422a8f6-0"
})(ScreenerLabel_templateObject(), color/* default.gainsboro */.Z.gainsboro, color/* default.light */.Z.light);
var ScreenerLabel_SInput = (0,styled_components_browser_esm/* default */.ZP)(Input/* default */.Z).withConfig({
    componentId: "sc-d422a8f6-1"
})(ScreenerLabel_templateObject1(), color/* default.highempahis */.Z.highempahis, color/* default.whisper */.Z.whisper);
var ScreenerLabel = function(param) {
    var data = param.data;
    var _actions = slice/* default.actions */.ZP.actions, setIsFormActive = _actions.setIsFormActive, setIsFormEditMode = _actions.setIsFormEditMode;
    var ref = (0,es/* useSelector */.v9)(slice/* screenerSelectors */.p0), isFormEditMode = ref.screenerUtils.isFormEditMode;
    var dispatch = (0,es/* useDispatch */.I0)();
    var onEditScreener = function() {
        dispatch(setIsFormActive(true));
        dispatch(setIsFormEditMode(true));
    };
    return !isFormEditMode && /*#__PURE__*/ (0,jsx_runtime.jsxs)(SFlex, {
        justify: "space-between",
        width: "100%",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScreenerLabel_SInput, {
                width: "calc(100% - 130px)",
                // prettier-ignore
                addonBefore: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    weight: "700",
                    family: "bold",
                    children: "Screen Name"
                }),
                name: "screenName",
                // @ts-expect-error
                mr: "12px",
                disabled: true,
                value: data === null || data === void 0 ? void 0 : data.screen_name
            }, "input"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                type: "primary",
                p: "4px 10px",
                onClick: onEditScreener,
                children: "Edit Screener"
            })
        ]
    });
};
/* harmony default export */ var ScreenerMain_ScreenerLabel = (ScreenerLabel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
;// CONCATENATED MODULE: ./src/features/screener/components/Body/ScreenerMain/ScreenerResult/ScreenerPagination/styled.ts

function ScreenerPagination_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"
    ]);
    ScreenerPagination_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ScreenerPagination_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: block;\n  font-size: 14px;\n  font-family: var(--font-regular);\n  color: ",
        ";\n"
    ]);
    ScreenerPagination_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var ContainerResult = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c356b6c4-0"
})(ScreenerPagination_styled_templateObject());
var ResultPaginationInfo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c356b6c4-1"
})(ScreenerPagination_styled_templateObject1(), color/* default.highempahis */.Z.highempahis);


;// CONCATENATED MODULE: ./src/features/screener/components/Body/ScreenerMain/ScreenerResult/ScreenerPagination/index.tsx














var ScreenerPagination = function() {
    var ref = (0,es/* useSelector */.v9)(slice/* screenerSelectors */.p0), _screenerResult = ref.screenerResult, screenerResult = _screenerResult.data, _screenerPostResult = ref.screenerPostResult, screenerPostResult = _screenerPostResult.data;
    var setIsModalAddColumnActive = slice/* default.actions.setIsModalAddColumnActive */.ZP.actions.setIsModalAddColumnActive;
    var dataScreenerResult = !(0,general/* emptyObject */.FD)(screenerPostResult) ? screenerPostResult : screenerResult;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref1 = (0,react.useState)({}), paginationAttributes = ref1[0], setPaginationAttributes = ref1[1];
    var calcs = paginationAttributes.calcs, curpage = paginationAttributes.curpage, perpage = paginationAttributes.perpage, totalrows = paginationAttributes.totalrows;
    var screenerNumberPaginationStart = function() {
        if (curpage === 1) return 1;
        return perpage * curpage - perpage + 1;
    };
    var screenerNumberPaginationEnd = function() {
        if (curpage === 1) return calcs.length;
        return curpage * (calcs === null || calcs === void 0 ? void 0 : calcs.length) < totalrows ? perpage * curpage - perpage + (calcs === null || calcs === void 0 ? void 0 : calcs.length) : totalrows;
    };
    var showModalFinancial = function() {
        dispatch(setIsModalAddColumnActive(true));
    };
    (0,react.useEffect)(function() {
        var totalrowsResult = dataScreenerResult.totalrows, curpageResult = dataScreenerResult.curpage, perpageResult = dataScreenerResult.perpage, calcsResult = dataScreenerResult.calcs, sortResult = dataScreenerResult.sort, orderResult = dataScreenerResult.order, universeResult = dataScreenerResult.universe, rulesResult = dataScreenerResult.rules, sequenceResult = dataScreenerResult.sequence, screeneridResult = dataScreenerResult.screenerid, restScreenerResult = (0,_object_without_properties/* default */.Z)(dataScreenerResult, [
            "totalrows",
            "curpage",
            "perpage",
            "calcs",
            "sort",
            "order",
            "universe",
            "rules",
            "sequence",
            "screenerid"
        ]);
        setPaginationAttributes(function(prevState) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState, restScreenerResult), {
                calcs: calcsResult,
                perpage: perpageResult,
                curpage: curpageResult,
                totalrows: totalrowsResult,
                sort: sortResult,
                order: orderResult,
                universe: universeResult,
                rules: rulesResult,
                sequence: sequenceResult,
                screenerid: screeneridResult
            });
        });
    }, [
        dataScreenerResult
    ]);
    return totalrows > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContainerResult, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ResultPaginationInfo, {
                children: [
                    "Results ",
                    screenerNumberPaginationStart(),
                    " -",
                    " ",
                    screenerNumberPaginationEnd(),
                    " of ",
                    totalrows,
                    " Equities"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                type: "borderless",
                pr: "0px",
                onClick: showModalFinancial,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    align: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* default */.Z, {
                            className: "icon-compose_plus",
                            color: "midgray"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            ml: "5px",
                            color: color/* default.primary */.Z.primary,
                            children: "Add Financial Column"
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var ScreenerResult_ScreenerPagination = (ScreenerPagination);

// EXTERNAL MODULE: ./node_modules/react-drag-listview/es/index.js + 3 modules
var react_drag_listview_es = __webpack_require__(54663);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Table.js
var Table = __webpack_require__(77148);
;// CONCATENATED MODULE: ./src/features/screener/components/Body/ScreenerMain/ScreenerResult/ScreenerTable/styled.ts

function ScreenerTable_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: flex;\n  padding-left: 20px;\n  padding-right: 20px;\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    ScreenerTable_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ScreenerTable_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 2px;\n  color: ",
        ";\n  font-size: 13px;\n  font-family: ProximaNovaRg;\n  padding: 0 5px;\n  position: relative;\n  display: block;\n  right: 5px;\n  line-height: 14.95px;\n  margin-top: 4px;\n\n  &:focus {\n    color: ",
        ";\n  }\n\n  &:hover {\n    background-color: ",
        ";\n    color: ",
        ";\n  }\n"
    ]);
    ScreenerTable_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ScreenerTable_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: block;\n  padding: 0 20px;\n"
    ]);
    ScreenerTable_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ScreenerTable_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: 20px;\n  table {\n    display: block;\n    overflow-x: auto;\n  }\n  \n  .ant-table-thead {\n    tr {\n      th {\n        height: 40px;\n      }\n      .custom-column {\n        border-bottom: 2px solid ",
        ";\n        padding: 0 20px 8px 10px;\n        font-family: var(--regular-font);\n        vertical-align: top;\n        font-size: 14px;\n        line-height: 16.1px;\n\n        .ant-table-column-sorters {\n          padding: 0;\n        }\n\n        .ant-table-column-sorter-full {\n          bottom: 6px;\n          right: 0;\n        }\n\n        .ant-table-column-sorter-inner {\n          position: relative;\n          top: 6px;\n        }\n\n        &:nth-child(1) {\n          padding-left: 0px;\n        }\n\n        &:last-child {\n          display: none;\n        }\n      }\n    }\n  }\n\n  .ant-table-tbody {\n    .custom-column {\n      &:nth-child(1) {\n        padding-left: 0px;\n      }\n    }\n\n    tr {\n      td {\n        padding: 5px 10px;\n        font-family: var(--regular-font);\n        background: ",
        ";\n        line-height: 16.1px;\n        white-space: nowrap;\n\n        :last-child {\n          display: none;\n        }\n      }\n\n      .cell-symbol-title {\n        a:hover {\n          color: unset;\n        }\n      }\n\n      .coloring {\n        color: ",
        ';\n      }\n      .coloring[data-raw^="-" i] {\n        color: ',
        ";\n      }\n    }\n  }\n\n  && .custom-column:hover {\n    .delete-column-icon {\n      display: block;\n      color: red;\n      font-weight: 700;\n      cursor: pointer;\n    }\n  }\n"
    ]);
    ScreenerTable_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0px;\n  right: 1px;\n  font-weight: bold;\n  color: red;\n  z-index: 10;\n  cursor: pointer;\n"
    ]);
    styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .delete-column-icon {\n    display: none;\n  }\n"
    ]);
    styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: block;\n  padding: 20px 15px 15px 15px;\n"
    ]);
    styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function styled_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 1.75px 4px;\n  border: 1px solid #00AB6B;\n  border-radius: 2px;\n"
    ]);
    styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}






var SContainerPageNavigation = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cf734655-0"
})(ScreenerTable_styled_templateObject(), function(param) {
    var paddingTop = param.paddingTop;
    return paddingTop && "\n    padding-top: ".concat(paddingTop, ";\n    ");
}, function(param) {
    var paddingBottom = param.paddingBottom;
    return paddingBottom && "\n    padding-bottom: ".concat(paddingBottom, ";\n    ");
});
var SButtonPageNavigation = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).attrs({
    ml: "0px",
    mr: "0px",
    pl: "0px",
    pr: "0px",
    pt: "0px",
    pb: "0px",
    // @ts-expect-error
    type: "borderless"
}).withConfig({
    componentId: "sc-cf734655-1"
})(ScreenerTable_styled_templateObject1(), color/* default.midgray */.Z.midgray, color/* default.midgray */.Z.midgray, color/* default.primary */.Z.primary, color/* default.light */.Z.light);
var SContainerTable = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cf734655-2"
})(ScreenerTable_styled_templateObject2());
var Buttons = [
    "First",
    "Previous",
    "Next",
    "Last"
];
var STable = (0,styled_components_browser_esm/* default */.ZP)(Table/* default */.Z).withConfig({
    componentId: "sc-cf734655-3"
})(ScreenerTable_styled_templateObject3(), color/* default.darkGray */.Z.darkGray, color/* default.light */.Z.light, color/* default.primary */.Z.primary, color/* default.sunsetOrange */.Z.sunsetOrange);
var SDeleteIcon = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-cf734655-4"
})(styled_templateObject4());
var CustomColumn = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cf734655-5"
})(styled_templateObject5());
var SContainerNote = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).attrs({
    size: "14px"
}).withConfig({
    componentId: "sc-cf734655-6"
})(styled_templateObject6());
var FlagNew = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs({
    justify: "center",
    align: "center"
}).withConfig({
    componentId: "sc-cf734655-7"
})(styled_templateObject7());


// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/features/screener/components/Body/ScreenerMain/ScreenerResult/ScreenerTable/utilities.tsx
/* eslint-disable no-param-reassign */ 





var addDeleteIcon = function(param) {
    var title = param.title, id = param.id, showDeleteIcon = param.showDeleteIcon, onCloseHeaderColumn = param.onCloseHeaderColumn;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomColumn, {
        children: [
            showDeleteIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)(SDeleteIcon, {
                className: "delete-column-icon",
                title: "Delete this column",
                onClick: function(e) {
                    e.stopPropagation();
                    onCloseHeaderColumn(id);
                },
                children: "X"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                children: title
            })
        ]
    });
};
var setColumnOrder = function(orderAtIndex, index, sortType) {
    var targetColumnOrder = orderAtIndex - 1;
    var targetColumnSort = sortType.toLowerCase() === "asc" ? "ascend" : "descend";
    if (targetColumnOrder === index) return targetColumnSort;
    return false;
};
var directionsOption = function(sortType) {
    if (sortType.toLowerCase() === "asc") return [
        "ascend",
        "descend"
    ];
    return [
        "descend",
        "ascend"
    ];
};
var addSymbolColumnAndEmptySpace = function() {
    var rawColumn = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    var compiledColumns = [
        {
            title: "Symbol",
            className: "custom-column not-dragable",
            dataIndex: [
                "company",
                "symbol"
            ],
            isRemovable: 0,
            sorter: true,
            coloring: 0,
            width: 120,
            // textWrap: 'word-break',
            key: 9999,
            fixed: "left",
            render: function(symbol, row) {
                var ref;
                /*#__PURE__*/ return (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    width: "120px",
                    className: "cell-symbol-title",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/symbol/".concat(symbol),
                            passHref: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                width: "55%",
                                family: "bold",
                                as: "a",
                                color: color/* default.dark */.Z.dark,
                                target: "_blank",
                                children: symbol
                            })
                        }),
                        ((ref = row.company.badges) === null || ref === void 0 ? void 0 : ref.is_new) && /*#__PURE__*/ (0,jsx_runtime.jsx)(FlagNew, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                size: "11px",
                                family: "bold",
                                color: color/* default.primary */.Z.primary,
                                as: "span",
                                children: "New"
                            })
                        })
                    ]
                });
            }
        }, 
    ].concat((0,_to_consumable_array/* default */.Z)(rawColumn), [
        // add empty column to make column respect width (130px)
        {
            title: "",
            className: "custom-column not-dragable",
            dataIndex: [
                ""
            ],
            isRemovable: 0,
            sorter: false,
            id: 0,
            coloring: 0,
            width: undefined,
            textWrap: "word-break"
        }, 
    ]);
    return compiledColumns;
};
// eslint-disable-next-line comma-spacing
var moveArrayElements = function(arr, indexA, indexB) {
    var clonedArr = (0,_to_consumable_array/* default */.Z)(arr);
    var element = clonedArr[indexA];
    if (element) {
        clonedArr.splice(indexA, 1);
        clonedArr.splice(indexB, 0, element);
    }
    return clonedArr;
};


;// CONCATENATED MODULE: ./src/features/screener/components/Body/ScreenerMain/ScreenerResult/ScreenerTable/index.tsx
/* eslint-disable indent */ /* eslint-disable no-shadow */ 













var ScreenerTable = function() {
    var ref = (0,react.useState)([]), tableColumns = ref[0], setTableColumns = ref[1];
    var ref1 = (0,react.useState)([]), tableData = ref1[0], setTableData = ref1[1];
    var ref2 = (0,react.useState)({}), tableAttributes = ref2[0], setTableAttributes = ref2[1];
    var ref3 = (0,react.useState)([]), addedColumns = ref3[0], setAddedColumns = ref3[1];
    var latestTableAttributes = (0,react.useRef)({});
    latestTableAttributes.current = tableAttributes;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref4 = (0,es/* useSelector */.v9)(slice/* screenerSelectors */.p0), addColumnModal = ref4.screenerModal.addColumnModal, _screenerResult = ref4.screenerResult, screenerResult = _screenerResult.data, _screenerPostResult = ref4.screenerPostResult, screenerPostResult = _screenerPostResult.data, screenerModal = ref4.screenerModal;
    var dataScreenerResult = !(0,general/* emptyObject */.FD)(screenerPostResult) ? screenerPostResult : screenerResult;
    var screenerName = tableAttributes.screen_name, screenerDesc = tableAttributes.screen_desc, columns = tableAttributes.columns, order = tableAttributes.order, sort = tableAttributes.sort, universe = tableAttributes.universe, rules = tableAttributes.rules, totalrows = tableAttributes.totalrows, curpage = tableAttributes.curpage, perpage = tableAttributes.perpage, sequence = tableAttributes.sequence, screenerid = tableAttributes.screenerid, type = tableAttributes.type;
    var postScreener = slice/* screenerEffects.postScreener */.Ko.postScreener;
    var onChangePagination = function(page) {
        dispatch(postScreener({
            name: screenerName,
            description: screenerDesc,
            ordercol: order,
            ordertype: sort,
            page: page,
            sequence: sequence.join(),
            universe: universe,
            filters: JSON.stringify(rules),
            screenerid: "".concat(screenerid),
            type: type
        }));
    };
    var validateFormScreener = function() {
        if (tableAttributes.rules.length === 0) {
            (0,AlertErrorMessage/* default */.Z)(errorMessage/* default.SCREENER_SPECIFY_RULES */.Z.SCREENER_SPECIFY_RULES, errorMessage/* default.ALERT_RED */.Z.ALERT_RED);
            return false;
        }
        return true;
    };
    var onClickButtonNavigation = function(action) {
        if (validateFormScreener()) {
            if (action.toLowerCase() === "first") {
                onChangePagination(1);
            }
            if (action.toLowerCase() === "last") {
                var lastPage = Math.ceil(totalrows / perpage);
                onChangePagination(lastPage);
            }
            if (action.toLowerCase() === "previous") {
                if (curpage !== 1) onChangePagination(curpage - 1);
            }
            if (action.toLowerCase() === "next") {
                var isNextPageAvailable = curpage * perpage < totalrows;
                if (isNextPageAvailable) onChangePagination(curpage + 1);
            }
        }
    };
    var onCloseColumnHeader = function(id) {
        var current = latestTableAttributes.current;
        var filters = current.rules, name = current.screen_name, description = current.screen_desc, universes = current.universe, page = current.curpage, order = current.order, ordertype = current.sort, sequence = current.sequence, columns = current.columns;
        if (columns.length <= 1) {
            (0,AlertErrorMessage/* default */.Z)(errorMessage/* default.SCREENER_SPECIFY_RULES */.Z.SCREENER_SPECIFY_RULES, errorMessage/* default.ALERT_RED */.Z.ALERT_RED);
            return;
        }
        var newRules = filters.filter(function(rule) {
            return rule.item1 !== id;
        });
        var newOrder = sequence.findIndex(function(s) {
            return s === id.toString();
        }) + 2 < order ? order - 1 : order;
        var newSequence = sequence.filter(function(s) {
            return s !== id.toString();
        }).join();
        dispatch(postScreener({
            name: name,
            description: description,
            ordercol: newOrder,
            ordertype: ordertype,
            sequence: newSequence,
            filters: JSON.stringify(newRules),
            universe: universes,
            page: page,
            screenerid: "".concat(screenerid),
            type: type
        }));
        // Handle remove column in state
        var indexDeletedColumn = addedColumns.indexOf(id.toString());
        if (indexDeletedColumn !== -1) {
            var newAddedColumn = addedColumns.splice(indexDeletedColumn, 1);
            setAddedColumns(newAddedColumn);
        }
    };
    var columnStyleGenerator = function(column) {
        var className = "custom-column";
        if (parseInt(column.removeable, 10)) {
            className += " removeable";
        }
        if (parseInt(column.coloring, 10)) {
            className += " coloring";
        }
        return className;
    };
    var createColumnTable = function(columns, preferedOrder, preferedSort) {
        var sequence = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [];
        var sequencedColumns = sequence.map(function(x) {
            return columns.find(function(y) {
                return y.id === Number(x);
            });
        }).filter(function(x) {
            return x;
        });
        var rawColumns = sequencedColumns.map(function(column, index) {
            return {
                title: column.removable === "1" ? addDeleteIcon({
                    title: column.name,
                    id: column.id,
                    showDeleteIcon: true,
                    // showDeleteIcon: addedColumns.includes(`${column.id}`),
                    onCloseHeaderColumn: function() {
                        return onCloseColumnHeader(column.id);
                    }
                }) : column.name,
                className: columnStyleGenerator(column),
                dataIndex: [
                    "results",
                    "".concat(index),
                    "display"
                ],
                isRemovable: column.removable,
                sorter: true,
                coloring: column.coloring,
                width: "130px",
                key: column.id,
                onCell: function(record) {
                    return {
                        "data-raw": record === null || record === void 0 ? void 0 : record.results[index].raw
                    };
                }
            };
        });
        var compiledColumns = columns.length ? addSymbolColumnAndEmptySpace(rawColumns) : [];
        var columnsOrder = compiledColumns.map(function(column, index) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, column), {
                sortDirections: directionsOption(preferedSort),
                sortOrder: setColumnOrder(preferedOrder, index, preferedSort),
                columnSorterID: index + 1
            });
        });
        return columnsOrder;
    };
    var onSortHandler = function(orderData) {
        var nextOrderType = orderData.order, columnKey = orderData.columnKey;
        var orderCol = tableColumns.findIndex(function(col) {
            return columnKey === col.key;
        });
        dispatch(postScreener({
            name: screenerName,
            description: screenerDesc,
            ordercol: orderCol + 1,
            ordertype: nextOrderType === "ascend" ? "asc" : "desc",
            filters: JSON.stringify(rules),
            universe: universe,
            page: curpage,
            sequence: sequence.join(),
            save: "0",
            screenerid: "".concat(screenerid),
            type: type
        }));
        dispatch(slice/* default.actions.updateScreenerResult */.ZP.actions.updateScreenerResult({
            screenerAction: "get",
            screener: {
                order: orderCol + 1
            }
        }));
    };
    var generateTableColumn = function() {
        var columns = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], preferedOrder = arguments.length > 1 ? arguments[1] : void 0, preferedSort = arguments.length > 2 ? arguments[2] : void 0, sequence = arguments.length > 3 ? arguments[3] : void 0;
        var formatedTable = createColumnTable(columns, preferedOrder, preferedSort, sequence);
        setTableColumns(formatedTable);
    };
    var generateTableData = function() {
        var calcs = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sequence = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
        var sequencedCalcs = calcs.map(function(x) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, x), {
                results: sequence.map(function(seq) {
                    return x.results.find(function(y) {
                        return y.id === Number(seq);
                    });
                }).filter(function(x) {
                    return x;
                })
            });
        });
        setTableData(sequencedCalcs);
    };
    var handleDragEnd = function(fromIndex, toIndex) {
        if (toIndex < 0) return;
        var calcs = dataScreenerResult.calcs;
        var newCalcs = calcs.map(function(x) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, x), {
                results: moveArrayElements(x.results, fromIndex, toIndex)
            });
        });
        var newColumns = moveArrayElements(columns, fromIndex, toIndex);
        var newSequences = moveArrayElements(sequence, fromIndex, toIndex);
        var newRules = moveArrayElements(rules, fromIndex, toIndex);
        var fromIndexSeq = fromIndex + 2;
        var toIndexSeq = toIndex + 2;
        var newOrderCol = order;
        if (order === fromIndexSeq) newOrderCol = toIndexSeq;
        if (order > fromIndexSeq && order <= toIndexSeq) newOrderCol = order - 1;
        if (order < fromIndexSeq && order >= toIndexSeq) newOrderCol = order + 1;
        dispatch(slice/* default.actions.updateScreenerResult */.ZP.actions.updateScreenerResult({
            screenerAction: "get",
            screener: {
                // order: newOrderCol,
                sequence: newSequences
            }
        }));
        if (!(0,general/* emptyObject */.FD)(screenerPostResult)) {
            dispatch(slice/* default.actions.updateScreenerResult */.ZP.actions.updateScreenerResult({
                screenerAction: "post",
                screener: {
                    calcs: newCalcs,
                    columns: newColumns,
                    order: newOrderCol,
                    sequence: newSequences,
                    rules: newRules
                }
            }));
        }
    };
    // on modal add column closed
    var onModalClosed = function(id) {
        if (columns.find(function(x) {
            return x.id === Number(id);
        })) return;
        dispatch(postScreener({
            ordercol: order,
            ordertype: sort,
            page: curpage,
            universe: universe,
            filters: JSON.stringify((0,_to_consumable_array/* default */.Z)(rules || []).concat([
                {
                    type: "basic",
                    item1: id,
                    item2: "",
                    operator: "all",
                    multiplier: ""
                }, 
            ])),
            name: screenerName,
            description: screenerDesc,
            sequence: (0,_to_consumable_array/* default */.Z)(sequence).concat([
                id.toString()
            ]).join(),
            save: "0",
            screenerid: "".concat(screenerid),
            type: type
        }));
        dispatch(slice/* default.actions.resetAddColumnModal */.ZP.actions.resetAddColumnModal());
    };
    // listen when modal add column closed
    (0,react.useEffect)(function() {
        var id = addColumnModal.id;
        if (id) {
            onModalClosed(id);
        }
    }, [
        addColumnModal
    ]);
    (0,react.useEffect)(function() {
        var calcsResult = dataScreenerResult.calcs, columnsResult = dataScreenerResult.columns, orderResult = dataScreenerResult.order, sortResult = dataScreenerResult.sort, screenerId = dataScreenerResult.screenerid, _sequence = dataScreenerResult.sequence, sequence = _sequence === void 0 ? [] : _sequence, dataAttributes = (0,_object_without_properties/* default */.Z)(dataScreenerResult, [
            "calcs",
            "columns",
            "order",
            "sort",
            "screenerid",
            "sequence"
        ]);
        var screenerIdValue = screenerId || screenerid;
        var uniqueSequence = sequence.filter(function(v, i) {
            return sequence.indexOf(v) === i;
        });
        generateTableColumn(columnsResult, orderResult, sortResult, uniqueSequence);
        generateTableData(calcsResult, uniqueSequence);
        setTableAttributes(function(prevState) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), {
                order: orderResult,
                sort: sortResult,
                columns: columnsResult
            }), dataAttributes), {
                sequence: uniqueSequence,
                screenerid: screenerIdValue
            });
        });
    }, [
        dataScreenerResult
    ]);
    (0,react.useEffect)(function() {
        // reset added column
        setAddedColumns([]);
    }, [
        screenerResult
    ]);
    (0,react.useEffect)(function() {
        if (addColumnModal.id && rules) {
            var isColumnNeedUpdate = !rules.find(function(rule) {
                return rule.item1 === screenerModal.addColumnModal.id;
            });
            if (isColumnNeedUpdate) {
                setAddedColumns(function(prevState) {
                    return (0,_to_consumable_array/* default */.Z)(prevState).concat([
                        "".concat(screenerModal.addColumnModal.id), 
                    ]);
                });
            }
        }
    }, [
        addColumnModal
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SContainerPageNavigation, {
                children: totalrows !== (tableData === null || tableData === void 0 ? void 0 : tableData.length) && Buttons.map(function(buttonLabel) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SButtonPageNavigation, {
                        onClick: function() {
                            onClickButtonNavigation(buttonLabel);
                        },
                        children: buttonLabel
                    });
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SContainerTable, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_drag_listview_es/* default.DragColumn */.Z.DragColumn, {
                    ignoreSelector: ".not-dragable",
                    nodeSelector: "th",
                    onDragEnd: handleDragEnd,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(STable, {
                        columns: tableColumns,
                        dataSource: tableData,
                        rowKey: function(record) {
                            return record.company.id;
                        },
                        pagination: false,
                        showSorterTooltip: false,
                        onChange: function(pagination, filters, sorter) {
                            onSortHandler(sorter);
                        },
                        // @ts-expect-error
                        width: "max-content",
                        scroll: {
                            x: 1000
                        }
                    })
                })
            }),
            totalrows !== (tableData === null || tableData === void 0 ? void 0 : tableData.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(SContainerPageNavigation, {
                paddingBottom: "5px",
                children: Buttons.map(function(buttonLabel) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SButtonPageNavigation, {
                        onClick: function() {
                            onClickButtonNavigation(buttonLabel);
                        },
                        children: buttonLabel
                    });
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SContainerNote, {
                children: [
                    "*Market Data (Technical) di update setiap 15 menit. (Contoh: Price, Volume, Value)",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "*Fundamental Data di update setiap akhir hari pukul 06.30pm. (Contoh: Revenue, Net Profit)"
                ]
            })
        ]
    });
};
/* harmony default export */ var ScreenerResult_ScreenerTable = (ScreenerTable);

;// CONCATENATED MODULE: ./src/features/screener/components/Body/index.tsx










var Body = function() {
    var ref = (0,es/* useSelector */.v9)(slice/* screenerSelectors */.p0), _screenerUtils = ref.screenerUtils, isFormActive = _screenerUtils.isFormActive, isFormEditMode = _screenerUtils.isFormEditMode, isFormCreateMode = _screenerUtils.isFormCreateMode, screenerAction = _screenerUtils.screenerAction, isEmptyResult = _screenerUtils.isEmptyResult, _screenerResult = ref.screenerResult, dataScreenerResult = _screenerResult.data, isLoadingResult = _screenerResult.isLoading, _screenerPostResult = ref.screenerPostResult, dataScreenerPostResult = _screenerPostResult.data, isLoadingPostResult = _screenerPostResult.isLoading;
    var isLoading = isLoadingResult || isLoadingPostResult;
    var isDataEmpty = !(0,general/* emptyObject */.FD)(dataScreenerResult) || !(0,general/* emptyObject */.FD)(dataScreenerPostResult);
    var showScreenerLabel = !isFormCreateMode && !isFormActive && isDataEmpty;
    var isEmpty = (0,react.useMemo)(function() {
        if (screenerAction === "get") {
            var ref;
            if ((dataScreenerResult === null || dataScreenerResult === void 0 ? void 0 : (ref = dataScreenerResult.calcs) === null || ref === void 0 ? void 0 : ref.length) === 0) {
                return true;
            }
            if ((0,general/* emptyObject */.FD)(dataScreenerResult) && isFormCreateMode) {
                return true;
            }
            return false;
        }
        if (screenerAction === "post") {
            var ref1;
            if ((dataScreenerPostResult === null || dataScreenerPostResult === void 0 ? void 0 : (ref1 = dataScreenerPostResult.calcs) === null || ref1 === void 0 ? void 0 : ref1.length) === 0) {
                return true;
            }
            if ((0,general/* emptyObject */.FD)(dataScreenerPostResult) && isFormCreateMode) {
                return true;
            }
            return false;
        }
        if (isEmptyResult && isFormCreateMode) {
            return true;
        }
        return false;
    }, [
        isEmptyResult,
        screenerAction,
        dataScreenerResult,
        dataScreenerPostResult,
        isFormCreateMode
    ]);
    var showResult = !isEmpty && screenerAction !== null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            isFormActive && /*#__PURE__*/ (0,jsx_runtime.jsx)(SContainerScreenerBody, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Body_ScreenerForm, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SContainerScreener, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ScreenerLoadingOverlay, {
                        isLoading: isLoading
                    }),
                    showScreenerLabel && /*#__PURE__*/ (0,jsx_runtime.jsx)(ScreenerMain_ScreenerLabel, {
                        data: dataScreenerResult
                    }),
                    showResult && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SContainerScreenerPagination, {
                                isFormActive: isFormCreateMode || isFormEditMode || isFormActive,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScreenerResult_ScreenerPagination, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SContainerScreenerTable, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScreenerResult_ScreenerTable, {})
                            })
                        ]
                    }),
                    isEmpty && !isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(ScreenerResultEmpty, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "No Result for this rule"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_Body = (Body);

;// CONCATENATED MODULE: ./src/features/screener/index.tsx




var PresetModal = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(76750), __webpack_require__.e(35851), __webpack_require__.e(36055), __webpack_require__.e(67555), __webpack_require__.e(97751), __webpack_require__.e(76219), __webpack_require__.e(48308), __webpack_require__.e(21378)]).then(__webpack_require__.bind(__webpack_require__, 6218));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6218)
            ];
        }
    },
    ssr: false
});
var FinancialModal = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(76750), __webpack_require__.e(35851), __webpack_require__.e(36055), __webpack_require__.e(67555), __webpack_require__.e(97751), __webpack_require__.e(76219), __webpack_require__.e(48308), __webpack_require__.e(51159)]).then(__webpack_require__.bind(__webpack_require__, 55661));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(55661)
            ];
        }
    },
    ssr: false
});
var Screener = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PresetModal, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Body, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FinancialModal, {})
        ]
    });
};
/* harmony default export */ var screener = (Screener);

// EXTERNAL MODULE: ./src/global/MainLayout/index.tsx + 4 modules
var MainLayout = __webpack_require__(53120);
// EXTERNAL MODULE: ./src/hooks/useProtectedRoute.js
var useProtectedRoute = __webpack_require__(56198);
// EXTERNAL MODULE: ./src/global/SEO/index.tsx
var SEO = __webpack_require__(26350);
// EXTERNAL MODULE: ./src/features/paywall/Wrapper/Page.tsx
var Page = __webpack_require__(16943);
;// CONCATENATED MODULE: ./pages/screener.tsx

__webpack_require__(14473);






var ScreenerPage = function() {
    var isLoaded = (0,useProtectedRoute/* default */.Z)().isLoaded;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SEO/* default */.Z, {
                title: "Stockbit Screener"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(MainLayout["default"], {
                maxWidth: 970,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageLoader["default"], {
                        loaded: isLoaded
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Page/* default */.Z, {
                        feature: "SCREENER",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(screener, {})
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var pages_screener = (ScreenerPage);


/***/ }),

/***/ 22147:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/**
 * Color name source http://www.htmlcsscolor.com/
 */ /* harmony default export */ __webpack_exports__["Z"] = ({
    light: "#FFFFFF",
    highempahis: "#333333",
    highgray: "#969696",
    midgray: "#B5B5B5",
    lowgray: "#CBCBCB",
    downgray: "#EDEDED",
    component: "#F5F5F5",
    primary: "#00ab6b",
    "primary60%": "#00ab6b99",
    secondary: "#3b5998",
    trading: "#2facb2",
    gainsboro: "#DADADA",
    whisper: "#EEEEEE",
    silver: "#BBBBBB",
    aliceBlue: "#F5F6F7",
    snow: "#F9F9F9",
    dimgray: "#6b6b6b",
    black: "#000000",
    nightRider: "#333333",
    zambezi: "#595959",
    veryLightGrey: "#CCCCCC",
    suvaGrey: "#939393",
    highball: "#979134",
    sunsetOrange: "#ee4a49",
    clearDay: "#e6f8f1",
    darkGray: "#AAAAAA",
    dimGray: "#666666",
    mintCream: "#eafff7",
    nobel: "#999999",
    bubbles: "#DEF2E5",
    heather: "#B5B6B7",
    bermuda: "#80D5B5",
    sundown: "#F7A5A4",
    hummingBird: "#cceee1",
    coralCandy: "#FAC8C8",
    darkGrey: "#AAAAAA",
    valencia: "#d9534f",
    mischka: "#a2a7b0",
    royalBlue: "#5766D3",
    steelBlue: "#4178bb",
    scooter: "#2c8aa3",
    java: "#169b8b",
    jade: "#00ad73",
    /* handling hex code with duplicate name */ "seasonality-darkest-green": "#006c00",
    "seasonality-medium-green": "#018601",
    "seasonality-green": "#009b00",
    "seasonality-bright-green": "#01ad01",
    "seasonality-darkest-red": "#a70000",
    "seasonality-medium-red": "#c20d0d",
    "seasonality-red": "#d00808",
    "seasonality-bright-red": "#e70000",
    amber: "#ffbf00",
    mintTulip: "#bde9d9",
    dodgerBlue: "#1E90FF",
    navyBlue: "#136ad5",
    whiteSmoke: "#F2F2F2",
    pigmentGreen: "#019934",
    lightGreen: "#90E897",
    monaLisa: "#ff988e",
    purpleHeart: "#7924c3",
    venetianRed: "#c11214",
    green: "#0c8414",
    cadetBlue: "#49a3ac",
    pinkSwan: "#B6B6B6",
    grannyApple: "#C7F3CB",
    alertRed: "#FCD0CE",
    alertOrange: "#F0AD4E",
    alertBlue: "#337AB7",
    yellowSea: "#eba031",
    chardonnay: "#ffc774",
    softgreen: "#E5F7F0",
    mountainMeadow: "#0bba7a",
    grey: "#777777",
    nero: "#222222",
    ghostWhite: "#f8f8f9",
    azureBlue: "#2F8EF7",
    bitterSweet: "#fc605c",
    supernova: "#fdbc40",
    limeGreen: "#34c84a",
    softGainsboro: "#DDDDDD",
    mediumAquamarine: "#5dcbad",
    cosmicLatte: "#e1f6e5",
    vividViolet: "#712E9E"
});


/***/ }),

/***/ 74575:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({
    mobileS: "(min-width:320px)",
    mobileM: "(min-width:375px)",
    mobileL: "(min-width:425px)",
    tablet: "(min-width:768px)",
    laptop: "(min-width:1024px)",
    laptopL: "(min-width:1440px)",
    desktop: "(min-width:2560px)"
});


/***/ }),

/***/ 20539:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71577);
/* harmony import */ var _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52435);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22147);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n    color: ",
        ";\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    border: 1px solid ",
        ";\n    color: ",
        ";\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n    color: ",
        ";\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n    color: ",
        ";\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n    color: ",
        ";\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n    color: inherit;\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background: none;\n    border: none;\n    box-shadow: none;\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border: unset;\n    color: ",
        ";\n    cursor: not-allowed;\n  "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      color: ",
        ";\n      :hover {\n        color: ",
        ";\n      }\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      :hover {\n        transition: 0.2s ease-in;\n        cursor: pointer;\n        background-color: ",
        ";\n        color: ",
        ";\n        border: 1px solid ",
        ";\n      }\n    "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        "\n    "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: 'ProximaNovaRg';\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: ",
        ";\n  margin: ",
        ";\n  width: ",
        ";\n  height: ",
        ";\n  font-size: ",
        ";\n\n  ",
        "\n  ",
        ";\n\n  :focus,\n  :hover {\n    ",
        "\n  }\n\n  [disabled] {\n    color: ",
        " !important;\n    background-color: ",
        " !important;\n  }\n\n  ::after {\n    content: unset;\n  }\n\n  ",
        "\n\n  ",
        "\n\n    ::after {\n    content: unset;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}




var buttonTheme = {
    primary: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light),
    "outline-primary": (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject1(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary),
    secondary: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject2(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].sunsetOrange */ .Z.sunsetOrange, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].sunsetOrange */ .Z.sunsetOrange, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light),
    facebook: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject3(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].secondary */ .Z.secondary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].secondary */ .Z.secondary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light),
    trading: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject4(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].trading */ .Z.trading, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].trading */ .Z.trading, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light),
    default: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject5(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].gainsboro */ .Z.gainsboro),
    borderless: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject6()),
    muted: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject7(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].suvaGrey */ .Z.suvaGrey, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light)
};
var Button = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).attrs(function(props) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        type: props.type || "default",
        margin: props.margin || "unset",
        height: props.height || "auto",
        radius: props.radius || "2px",
        isHoverable: props.isHoverable || false,
        width: props.width,
        fontSize: props.fontSize || "14px"
    }, (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__/* .spacingProps */ .t)(props));
}).withConfig({
    componentId: "sc-3738f451-0"
})(_templateObject11(), function(param) {
    var radius = param.radius;
    return radius;
}, function(param) {
    var margin = param.margin;
    return margin;
}, function(param) {
    var width = param.width;
    return width;
}, function(param) {
    var height = param.height;
    return height;
}, function(param) {
    var fontSize = param.fontSize;
    return fontSize;
}, function(param) {
    var key = param.color;
    return _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject8(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z[key] || "inherit", _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z[key] || "inherit");
}, function(param) {
    var type = param.type;
    return buttonTheme[type];
}, function(param) {
    var type = param.type;
    return buttonTheme[type];
}, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].midgray */ .Z.midgray, function(param) {
    var isHoverable = param.isHoverable;
    return isHoverable && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject9(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].gainsboro */ .Z.gainsboro);
}, function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject10(), (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(props));
});
/* harmony default export */ __webpack_exports__["Z"] = (Button);


/***/ }),

/***/ 70821:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52435);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: ",
        ";\n  justify-content: ",
        ";\n  align-items: ",
        ";\n  padding: ",
        ";\n  margin: ",
        ";\n  width: ",
        ";\n  height: ",
        ";\n  flex-wrap: ",
        ";\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Flex = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.attrs */ .ZP.div.attrs(function(props) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        direction: props.direction || "row",
        justify: props.justify || "left",
        align: props.align || "flex-start",
        padding: props.padding || "0",
        margin: props.margin || "0",
        width: props.width,
        height: props.height,
        wrap: props.wrap || "nowrap"
    }, (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__/* .spacingProps */ .t)(props));
}).withConfig({
    componentId: "sc-c038202d-0"
})(_templateObject(), function(param) {
    var direction = param.direction;
    return direction;
}, function(param) {
    var justify = param.justify;
    return justify;
}, function(param) {
    var align = param.align;
    return align;
}, function(param) {
    var padding = param.padding;
    return padding;
}, function(param) {
    var margin = param.margin;
    return margin;
}, function(param) {
    var width = param.width;
    return width;
}, function(param) {
    var height = param.height;
    return height;
}, function(param) {
    var wrap = param.wrap;
    return wrap;
}, _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);
/* harmony default export */ __webpack_exports__["Z"] = (Flex);


/***/ }),

/***/ 15807:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ IconWrapper; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  height: ",
        ";\n  width: ",
        ";\n  padding: ",
        ";\n  display: flex;\n  align-items: center;\n  justify-content: ",
        ";\n  cursor : pointer;\n  \n  ::before {\n    content: '",
        "';\n    position: absolute;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    top: 7%;\n    left: 7%;\n    color: ",
        ";\n    background: ",
        ";\n    border-radius: 50%;\n    min-width: 18px;\n    font-size: 12px;\n    font-weight: bold;\n    z-index: 2;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  font-family: "icomoon";\n  font-size: ',
        ";\n  font-weight: ",
        ";\n  color: ",
        ";\n  margin: 0;\n\n  :hover {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var IconWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.attrs */ .ZP.div.attrs(function(props) {
    return {
        size: props.size || "auto",
        padding: props.padding || "0px",
        newItem: props.newItem || 0,
        justify: props.justify || "center"
    };
}).withConfig({
    componentId: "sc-793d8880-0"
})(_templateObject(), function(param) {
    var size = param.size;
    return size;
}, function(param) {
    var size = param.size;
    return size;
}, function(param) {
    var padding = param.padding;
    return padding;
}, function(param) {
    var justify = param.justify;
    return justify;
}, function(param) {
    var newItem = param.newItem;
    return newItem || "";
}, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary);
var Iconmoon = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].p.attrs */ .ZP.p.attrs(function(props) {
    return {
        size: props.size || "16px",
        color: props.color || _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].highgray */ .Z.highgray,
        isActive: props.isActive || false,
        hoverColor: props.hoverColor || _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary,
        weight: props.weight || "normal"
    };
}).withConfig({
    componentId: "sc-793d8880-1"
})(_templateObject1(), function(param) {
    var size = param.size;
    return size;
}, function(param) {
    var weight = param.weight;
    return weight;
}, function(props) {
    return !props.isActive ? props.color : _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary;
}, function(props) {
    return props.hoverColor;
});

/* harmony default export */ __webpack_exports__["Z"] = (Iconmoon);


/***/ }),

/***/ 54325:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19521);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7648);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);
/* harmony import */ var _style_device__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74575);
/* harmony import */ var _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52435);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    font-size: 22px;\n    font-weight: 600;\n    text-align: center;\n    height: 35px;\n    border: 1px solid ",
        ";\n    @media ",
        " {\n      width: 300px;\n    }\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        "\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  font-family: "ProximaNovaRg";\n  height: ',
        ";\n  width: ",
        " !important;\n  margin: ",
        ";\n  border: 1px solid ",
        ";\n  border-radius: ",
        ";\n\n  .ant-input::placeholder {\n    color: ",
        ";\n    font-size: 13px;\n  }\n\n  :hover,\n  :focus,\n  :focus-within {\n    border-color: ",
        ";\n    outline-color: transparent;\n    box-shadow: none;\n  }\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        "\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  font-family: "ProximaNovaRg";\n  height: ',
        ";\n  width: ",
        " !important;\n  margin: ",
        ";\n  border-color: ",
        ";\n\n  .ant-input::placeholder {\n    color: ",
        ";\n    font-size: 13px;\n  }\n\n  :hover,\n  :focus,\n  :focus-within {\n    border-color: ",
        ";\n    box-shadow: none;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}





var type = {
    basic: (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject()),
    withdraw: (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject1(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, _style_device__WEBPACK_IMPORTED_MODULE_2__/* ["default"].laptop */ .Z.laptop)
};
var Input = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).attrs(function(props) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        height: props.height || "auto",
        width: props.width || "auto",
        margin: props.margin || "0",
        padding: props.padding || "5px",
        round: props.round || true,
        type: props.type || "basic"
    }, (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_3__/* .spacingProps */ .t)(props));
}).withConfig({
    componentId: "sc-85b10eda-0"
})(_templateObject3(), function(param) {
    var height = param.height;
    return height;
}, function(param) {
    var width = param.width;
    return width;
}, function(param) {
    var margin = param.margin;
    return margin;
}, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, function(param) {
    var round = param.round;
    return round ? "2px" : "unset";
}, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].dimgray */ .Z.dimgray, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, function(param) {
    var typeKey = param.type;
    return type[typeKey];
}, function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject2(), (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(props));
});
Input.TextArea = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_5__/* ["default"].TextArea */ .Z.TextArea).attrs(function(props) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        height: props.height || "auto",
        width: props.width || "100%",
        margin: props.margin || "0"
    }, (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_3__/* .spacingProps */ .t)(props));
}).withConfig({
    componentId: "sc-85b10eda-1"
})(_templateObject5(), function(param) {
    var height = param.height;
    return height;
}, function(param) {
    var width = param.width;
    return width;
}, function(param) {
    var margin = param.margin;
    return margin;
}, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].dimgray */ .Z.dimgray, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject4(), (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(props));
});
/* harmony default export */ __webpack_exports__["Z"] = (Input);


/***/ }),

/***/ 16368:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33070);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-header {\n    border-bottom: 0;\n    padding: 0;\n  }\n\n  .ant-modal-footer {\n    border-top: 0;\n    padding: 0;\n    text-align: unset;\n  }\n\n  .ant-modal-footer button + button {\n    margin: 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-content {\n    background: unset;\n    box-shadow: unset;\n  }\n\n  .ant-modal-header {\n    background: unset;\n    padding: unset;\n    border: unset;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: unset !important;\n  height: 100vh;\n  top: unset;\n  background-color: ",
        ";\n  max-width: unset;\n  margin: unset;\n\n  .ant-modal-header {\n    border: unset;\n    padding: 0;\n  }\n\n  .ant-modal-content {\n    box-shadow: unset;\n    margin: auto;\n    width: 100%;\n    height: 100%;\n  }\n\n  .ant-modal-body {\n    height: 90%;\n    overflow-y: scroll;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-body {\n    padding: 0;\n  }\n\n  ",
        "\n\n  .ant-modal-content {\n    border-radius: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var basicModal = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject());
var transparentModal = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject1());
var fullscreenModal = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject2(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light);
var modalTypes = {
    basic: basicModal,
    transparent: transparentModal,
    fullscreen: fullscreenModal
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).attrs(function(props) {
    return {
        footer: props.footer || false,
        type: props.type || "basic",
        radius: props.radius || "2px"
    };
}).withConfig({
    componentId: "sc-697a6696-0"
})(_templateObject3(), function(param) {
    var type = param.type;
    return modalTypes[type];
}, function(param) {
    var radius = param.radius;
    return radius;
}));


/***/ }),

/***/ 70187:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R_": function() { return /* binding */ PopoverContentWrapper; },
/* harmony export */   "xK": function() { return /* binding */ PopoverTitleWrapper; },
/* harmony export */   "yk": function() { return /* binding */ PopoverContent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10808);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);
/* harmony import */ var _Flex__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70821);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 100%;\n  max-height: 400px;\n  border: 1px solid ",
        ";\n  border-radius: 2px;\n  padding: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid ",
        ";\n  height: 40px;\n  padding: 0 16px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  max-height: 360px;\n  overflow-y: auto;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var PopoverContentWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.attrs */ .ZP.div.attrs(function(props) {
    return {
        padding: props.padding || 0
    };
}).withConfig({
    componentId: "sc-b405b759-0"
})(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, function(param) {
    var padding = param.padding;
    return padding;
});
var PopoverTitleWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-b405b759-1"
})(_templateObject1(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro);
var PopoverContent = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-b405b759-2"
})(_templateObject2());

/* harmony default export */ __webpack_exports__["ZP"] = (antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z);


/***/ }),

/***/ 6305:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92961);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);
/* harmony import */ var _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52435);
/* eslint-disable react/jsx-props-no-spreading */ 

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: ",
        ";\n  ",
        "\n\n  .ant-select-selector {\n    border-color: ",
        " !important;\n    box-shadow: none !important;\n    height: inherit !important;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var Select = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).attrs(function(props) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        width: props.width
    }, (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_2__/* .spacingProps */ .t)(props));
}).withConfig({
    componentId: "sc-8dcb9882-0"
})(_templateObject(), function(param) {
    var width = param.width;
    return width;
}, _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro);
/* harmony default export */ __webpack_exports__["Z"] = (Select);


/***/ }),

/***/ 77148:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79931);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    .ant-table-thead > tr > th {\n      background: ",
        ";\n    }\n\n    .ant-table-tbody > tr > td {\n      padding: 8px 15px;\n    }\n\n    .ant-table-column-sorter {\n      position: absolute;\n      right: 0;\n    }\n\n    .ant-table-column-sorter-up,\n    .ant-table-column-sorter-down {\n      display: none;\n    }\n\n    .ant-table-thead th.ant-table-column-has-sorters:hover {\n      background-color: unset;\n    }\n\n    .ant-table-thead th.ant-table-column-has-sorters:hover .ant-table-column-sorter-up,\n    .ant-table-thead th.ant-table-column-has-sorters:hover .ant-table-column-sorter-down {\n      display: block;\n    }\n\n    .ant-table-column-sorter-up.active,\n    .ant-table-column-sorter-down.active {\n      color: ",
        ";\n      display: block;\n    }\n\n    .ant-empty-image {\n      display: none;\n    }\n\n    .ant-empty-normal {\n      margin: unset;\n    }\n\n    .ant-table-ping-left .ant-table-cell-fix-left-last::after {\n      box-shadow: unset;\n    }\n\n    .ant-table-container::after {\n      content: unset;\n    }\n\n    .ant-pagination-prev {\n      margin: unset;\n    }\n    .ant-pagination-item {\n      display: none;\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var variants = {
    basic: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].highempahis */ .Z.highempahis)
};
var Table = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).attrs(function(props) {
    return {
        variant: props.variant || "basic"
    };
}).withConfig({
    componentId: "sc-24c3e4c6-0"
})(_templateObject1(), function(param) {
    var variant = param.variant;
    return variants[variant];
});
/* harmony default export */ __webpack_exports__["Z"] = (Table);


/***/ }),

/***/ 95541:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);
/* harmony import */ var _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52435);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        "\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        "\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  line-height: ",
        ";\n  color: ",
        ";\n  text-align: ",
        ";\n  padding: ",
        ";\n  width: ",
        ";\n  text-transform: ",
        ";\n  margin: 0;\n\n  ",
        "\n\n  ",
        "\n\n  & > a {\n    color: ",
        ";\n    text-decoration: none;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var familyType = {
    regular: "ProximaNovaRg",
    light: "ProximaNovaLt",
    bold: "ProximaNovaBd"
};
/* harmony default export */ __webpack_exports__["Z"] = (styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    shouldForwardProp: function(prop) {
        return ![
            "ellipsis",
            "textTransform"
        ].includes(prop);
    }
}).attrs(function(props) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        size: props.size || "14px",
        weight: props.weight || "normal",
        height: props.height || "normal",
        color: props.color || _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].highempahis */ .Z.highempahis,
        align: props.align || "left",
        padding: props.padding || 0,
        width: props.width,
        ellipsis: props.ellipsis,
        textTransform: props.textTransform,
        family: props.family || "regular"
    }, (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_2__/* .spacingProps */ .t)(props));
}).withConfig({
    componentId: "sc-8a078c1d-0"
})(_templateObject3(), function(param) {
    var family = param.family;
    return familyType[family];
}, function(param) {
    var size = param.size;
    return size;
}, function(param) {
    var weight = param.weight;
    return weight;
}, function(param) {
    var height = param.height;
    return height;
}, function(props) {
    return props.color;
}, function(param) {
    var align = param.align;
    return align;
}, function(param) {
    var padding = param.padding;
    return padding;
}, function(param) {
    var width = param.width;
    return width;
}, function(param) {
    var textTransform = param.textTransform;
    return textTransform;
}, function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject(), (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props));
}, function(param) {
    var ellipsis = param.ellipsis;
    return ellipsis && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject1());
}, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary, function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject2(), (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props));
}));


/***/ }),

/***/ 52435:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ spacingProps; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36305);




var types = {
    m: "margin",
    p: "padding"
};
var directions = {
    t: [
        "-top"
    ],
    r: [
        "-right"
    ],
    b: [
        "-bottom"
    ],
    l: [
        "-left"
    ],
    x: [
        "-left",
        "-right"
    ],
    y: [
        "-top",
        "-bottom"
    ]
};
var EMPTY_STRING = "";
var WHITE_SPACE = " ";
var REGEX = /^([mp][trblxy]?)$/;
var pipe = function() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++){
        fns[_key] = arguments[_key];
    }
    return function(x) {
        return fns.reduce(function(prev, f) {
            return f(prev, x);
        }, x);
    };
};
var filter = function(keys) {
    return keys.filter(function(key) {
        return key.match(REGEX);
    });
};
var merge = function(props) {
    return props.map(function(param) {
        var type = param.type, direction = param.direction, value = param.value;
        return direction.map(function(d) {
            return "".concat(type).concat(d, ": ").concat(value, ";");
        }).join(WHITE_SPACE);
    });
};
var splitPropKey = function(keys, props) {
    return keys.map(function(key) {
        var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(key.split(""), 2), type = ref[0], direction = ref[1];
        return {
            type: types[type],
            direction: directions[direction] || [
                EMPTY_STRING
            ],
            value: props[key]
        };
    });
};
var handleSpaces = function(props) {
    return pipe(Object.keys, filter, splitPropKey, merge)(props).join(WHITE_SPACE);
};
var spacingProps = function(props) {
    var typesKeys = Object.keys(types);
    var directionsKeys = Object.keys(directions);
    var result = typesKeys.map(function(type) {
        return directionsKeys.map(function(dir) {
            return (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, "".concat(type).concat(dir), props["".concat(type).concat(dir)]);
        });
    }).reduce(function(prev, curr) {
        return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(prev).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(curr));
    }, []).filter(function(prop) {
        return Object.values(prop)[0];
    }).reduce(function(prev, curr) {
        return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, prev, curr);
    }, {});
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, result);
};
/* harmony default export */ __webpack_exports__["Z"] = (handleSpaces);


/***/ }),

/***/ 67864:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(49288);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52435);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22147);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "border: border: 1px solid ",
        ";"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        "\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: ",
        ";\n  border: none;\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var AutoComplete = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).attrs(function(props) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        width: props.width || "",
        bordered: props.bordered || false
    }, (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__/* .spacingProps */ .t)(props));
}).withConfig({
    componentId: "sc-b0070c62-0"
})(_templateObject2(), function(param) {
    var width = param.width;
    return width;
}, function(param) {
    var bordered = param.bordered;
    return bordered && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].dimGray */ .Z.dimGray);
}, function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject1(), (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(props));
});
/* harmony default export */ __webpack_exports__["Z"] = (AutoComplete);


/***/ }),

/***/ 60714:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ APIErrorMessage; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/global/AlertErrorMessage/index.js + 1 modules
var AlertErrorMessage = __webpack_require__(25516);
// EXTERNAL MODULE: ./src/constants/errorMessage.js
var errorMessage = __webpack_require__(61608);
// EXTERNAL MODULE: ./src/config/APIErrorMessage/utils.ts
var utils = __webpack_require__(63858);
;// CONCATENATED MODULE: ./src/config/APIErrorMessage/handler.js





/**
 * handleDefault
 * @param {*} errorType | optional
 * @param {*} message | optional
 * @param {*} singleError  | optional
 */ var handleDefault = function(errorType, message) {
    // Some API chat with 'blokir' message and 'FORBIDDEN' error_type should show alert
    // remove this block whenever BE possible to change error_type from 'FORBIDDEN'
    if (message.includes("blokir")) {
        var errMessageDefault = message;
        (0,AlertErrorMessage/* default */.Z)(errMessageDefault, errorMessage/* default.ALERT_RED */.Z.ALERT_RED);
        return;
    }
    /// ///////////////////////////////////////////////////
    if (errorType === errorMessage/* default.PAYWALL_NOSUBSCRIPTION */.Z.PAYWALL_NOSUBSCRIPTION) return;
    if (errorType === errorMessage/* default.FORBIDDEN */.Z.FORBIDDEN) return;
    var errMessageDefault1 = message;
    (0,AlertErrorMessage/* default */.Z)(errMessageDefault1, errorMessage/* default.ALERT_RED */.Z.ALERT_RED);
};
/**
 * handleMaintenance
 * web legacy: app\lib\Api.js line 184
 * @param {*} errorType | MAINTENANCE | ERROR_GATEWAY
 * @param {*} message | optional
 * @param {*} singleError  | optional
 */ var handleMaintenance = function(errorType, message) {
    if (errorType === "MAINTENANCE" && message) {
        (0,utils/* dispatchSetErrorCode */.S)(503, message);
    }
};
/**
 * handleUnAuthorized
 * web legacy: app\lib\Api.js line 192
 * @param {*} errorType | optional
 * @param {*} message | optional
 * @param {*} singleError  | optional
 */ var handleInvalidParameter = function(errorType, message) {
    if (errorType === "INVALID_RECAPTCHA") {
        return;
    }
    (0,AlertErrorMessage/* default */.Z)(message, errorMessage/* default.ALERT_RED */.Z.ALERT_RED);
};
/**
 * handleInternalServerError
 * @param {*} errorType | optional
 * @param {*} message | optional
 * @param {*} singleError  | optional
 */ // eslint-disable-next-line no-unused-vars
var handleInternalServerError = function(_, message) {
    (0,utils/* dispatchSetErrorCode */.S)(500);
};
/**
 * handleNotFound
 * @param {*} errorType | optional
 * @param {*} message | optional
 * @param {*} singleError  | optional
 */ var handleNotFound = function(_, message) {
    (0,AlertErrorMessage/* default */.Z)(message, errorMessage/* default.ALERT_RED */.Z.ALERT_RED);
};
/**
 * handleNotSubscription
 * web legacy: app\lib\Api.js line 238
 * @param {*} errorType | optional
 * @param {*} message | optional
 * @param {*} singleError  | optional
 */ var handleNotSubscription = function() {
// TODO: url
};
/**
 * @deprecated 401 Unathorized is directly handled from API instance
 * handleUnAuthorized
 * @param {Promise} originalRequest
 * @return Promise originalRequest with new Authorization header or error rejection
 */ // eslint-disable-next-line @typescript-eslint/no-empty-function
var handleUnAuthorized = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(originalRequest) {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function handleUnAuthorized(originalRequest) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var handler = ({
    handleDefault: handleDefault,
    handleMaintenance: handleMaintenance,
    handleInvalidParameter: handleInvalidParameter,
    handleNotFound: handleNotFound,
    handleNotSubscription: handleNotSubscription,
    handleUnAuthorized: handleUnAuthorized,
    handleInternalServerError: handleInternalServerError
});

;// CONCATENATED MODULE: ./src/config/APIErrorMessage/index.js

var APIErrorMessage_handleDefault = handler.handleDefault, APIErrorMessage_handleMaintenance = handler.handleMaintenance, APIErrorMessage_handleInvalidParameter = handler.handleInvalidParameter, APIErrorMessage_handleNotFound = handler.handleNotFound, APIErrorMessage_handleNotSubscription = handler.handleNotSubscription, APIErrorMessage_handleUnAuthorized = handler.handleUnAuthorized, APIErrorMessage_handleInternalServerError = handler.handleInternalServerError;
/**
 * Exodus API error message handler
 * @param {number} status - HTTP Response status | required
 * @param {string} errorType - Error types | required
 * @param {string} message - Error message | required
 */ var APIExodusErrorHandler = function(status, errorType, message) {
    var listErrorResponse = {
        DEFAULT: APIErrorMessage_handleDefault,
        400: APIErrorMessage_handleInvalidParameter,
        401: APIErrorMessage_handleUnAuthorized,
        402: APIErrorMessage_handleNotSubscription,
        404: APIErrorMessage_handleNotFound,
        500: APIErrorMessage_handleInternalServerError,
        503: APIErrorMessage_handleMaintenance
    };
    var response = listErrorResponse[status] || listErrorResponse.DEFAULT;
    return response(errorType, message);
};
/* harmony default export */ var APIErrorMessage = ({
    APIExodusErrorHandler: APIExodusErrorHandler
});


/***/ }),

/***/ 63858:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ dispatchSetErrorCode; }
/* harmony export */ });
/* harmony import */ var global_MainLayout_store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73580);
/* eslint-disable import/prefer-default-export */ 
var dispatchSetErrorCode = function(errorCode) {
    var errorMessage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    global_MainLayout_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].setState */ .Z.setState({
        errorCode: errorCode,
        errorMessage: errorMessage
    });
};


/***/ }),

/***/ 14350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RL": function() { return /* binding */ getAccessTokenDataFn; },
/* harmony export */   "oD": function() { return /* binding */ getRefreshTokenConfigFn; },
/* harmony export */   "x5": function() { return /* binding */ refreshExodusToken; }
/* harmony export */ });
/* unused harmony export initialRefreshTokenConfig */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var utils_auth__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19225);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37213);





var initialRefreshTokenConfig = {
    refreshingTokenStatus: "initial",
    refreshAndRetryQueue: []
};
var getRefreshTokenConfigFn = function() {
    var initNewConfig = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    if (true) {
        if (initNewConfig) {
            window.refreshRequestConfig = {
                refreshingTokenStatus: "initial",
                refreshAndRetryQueue: []
            };
            return window.refreshRequestConfig;
        }
        if (typeof window.refreshRequestConfig !== "undefined") {
            return window.refreshRequestConfig;
        }
        return undefined;
    }
    return initialRefreshTokenConfig;
};
var getAccessTokenDataFn = function() {
    var ref, ref1, ref2, ref3;
    var parsedToken = utils_auth__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getToken */ .Z.getToken();
    var accessToken = (parsedToken === null || parsedToken === void 0 ? void 0 : (ref = parsedToken.accessToken) === null || ref === void 0 ? void 0 : ref.token) || "";
    var accessTokenExpiry = (parsedToken === null || parsedToken === void 0 ? void 0 : (ref1 = parsedToken.accessToken) === null || ref1 === void 0 ? void 0 : ref1.expiry) || 0;
    var refreshToken = (parsedToken === null || parsedToken === void 0 ? void 0 : (ref2 = parsedToken.refresh) === null || ref2 === void 0 ? void 0 : ref2.token) || "";
    var refreshTokenExpiry = (parsedToken === null || parsedToken === void 0 ? void 0 : (ref3 = parsedToken.refresh) === null || ref3 === void 0 ? void 0 : ref3.expiry) || 0;
    return {
        accessToken: accessToken,
        accessTokenExpiry: accessTokenExpiry,
        refreshToken: refreshToken,
        refreshTokenExpiry: refreshTokenExpiry
    };
};
var refreshExodusToken = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var ref, parsedToken, refreshToken, response, _data, newAccessTokenData, parsedAccessExpired, parsedRefreshExpired;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    parsedToken = utils_auth__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getToken */ .Z.getToken();
                    refreshToken = parsedToken === null || parsedToken === void 0 ? void 0 : (ref = parsedToken.refresh) === null || ref === void 0 ? void 0 : ref.token;
                    _ctx.next = 5;
                    return axios__WEBPACK_IMPORTED_MODULE_1___default().post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_EXODUS_URL */ .q7, "/login/refresh"), null, {
                        headers: {
                            Authorization: "Bearer ".concat(refreshToken)
                        }
                    });
                case 5:
                    response = _ctx.sent;
                    if (!(!response || !response.data || !response.data.data)) {
                        _ctx.next = 8;
                        break;
                    }
                    throw new Error("Failed Refresh Token");
                case 8:
                    _data = response.data, newAccessTokenData = _data.data;
                    parsedAccessExpired = new Date(newAccessTokenData.access.expired_at).getTime();
                    parsedRefreshExpired = new Date(newAccessTokenData.refresh.expired_at).getTime();
                    utils_auth__WEBPACK_IMPORTED_MODULE_2__/* ["default"].saveToken */ .Z.saveToken({
                        accessToken: newAccessTokenData.access.token,
                        accessTokenExp: parsedAccessExpired,
                        refreshToken: newAccessTokenData.refresh.token,
                        refreshTokenExp: parsedRefreshExpired,
                        accessUser: utils_auth__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getUserAccess */ .Z.getUserAccess()
                    });
                    return _ctx.abrupt("return", newAccessTokenData.access.token);
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function refreshExodusToken() {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 68425:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ config_requestExodus; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./src/constants/api.js
var api = __webpack_require__(37213);
// EXTERNAL MODULE: ./src/constants/app.js
var app = __webpack_require__(86123);
// EXTERNAL MODULE: ./src/constants/errorMessage.js
var errorMessage = __webpack_require__(61608);
// EXTERNAL MODULE: ./src/global/AlertErrorMessage/index.js + 1 modules
var AlertErrorMessage = __webpack_require__(25516);
// EXTERNAL MODULE: ./src/utils/auth.js + 1 modules
var auth = __webpack_require__(19225);
// EXTERNAL MODULE: ./src/utils/logger.ts
var logger = __webpack_require__(91635);
;// CONCATENATED MODULE: ./src/config/refreshToken/index.ts
/* eslint-disable no-param-reassign */ 

var generateNewRequestWithRefreshToken = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
        var apiInstance, axiosError, getRefreshTokenConfig, getAccessTokenData, refreshTokenPromise, refreshTokenConfig, dateNow, newAccessToken, newRequest;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    apiInstance = param.apiInstance, axiosError = param.axiosError, getRefreshTokenConfig = param.getRefreshTokenConfig, getAccessTokenData = param.getAccessTokenData, refreshTokenPromise = param.refreshTokenPromise;
                    refreshTokenConfig = getRefreshTokenConfig();
                    dateNow = Math.floor(Date.now() / 1000);
                    _ctx.prev = 3;
                    if (!(dateNow > getAccessTokenData().refreshTokenExpiry)) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Failed Refresh Token");
                case 6:
                    if (!(typeof refreshTokenConfig === "undefined" || // Previous success refresh token config need to reset
                    (refreshTokenConfig.refreshingTokenStatus === "success" && dateNow > getAccessTokenData().accessTokenExpiry))) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", generateNewRequestWithRefreshToken({
                        apiInstance: apiInstance,
                        axiosError: axiosError,
                        getAccessTokenData: getAccessTokenData,
                        refreshTokenPromise: refreshTokenPromise,
                        getRefreshTokenConfig: function() {
                            return getRefreshTokenConfig(true);
                        }
                    }));
                case 8:
                    if (!(refreshTokenConfig.refreshingTokenStatus === "initial")) {
                        _ctx.next = 22;
                        break;
                    }
                    refreshTokenConfig.refreshingTokenStatus = "processing";
                    ;
                    _ctx.prev = 11;
                    _ctx.next = 14;
                    return refreshTokenPromise();
                case 14:
                    newAccessToken = _ctx.sent;
                    refreshTokenConfig.refreshingTokenStatus = "success";
                    _ctx.next = 21;
                    break;
                case 18:
                    _ctx.prev = 18;
                    _ctx.t0 = _ctx["catch"](11);
                    throw new Error("Failed Refresh Token");
                case 21:
                    // After refresh token API call success,
                    // proceed every API call within queue
                    refreshTokenConfig.refreshAndRetryQueue.forEach(function() {
                        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
                            var config, resolve, newRequest;
                            return runtime_default().wrap(function _callee$(_ctx) {
                                while(1)switch(_ctx.prev = _ctx.next){
                                    case 0:
                                        config = param.config, resolve = param.resolve;
                                        config.headers.Authorization = "Bearer ".concat(newAccessToken);
                                        _ctx.prev = 2;
                                        _ctx.next = 5;
                                        return apiInstance.request(config);
                                    case 5:
                                        newRequest = _ctx.sent;
                                        resolve(newRequest);
                                        _ctx.next = 12;
                                        break;
                                    case 9:
                                        _ctx.prev = 9;
                                        _ctx.t0 = _ctx["catch"](2);
                                        throw new Error("Failed API call after success refresh token");
                                    case 12:
                                    case "end":
                                        return _ctx.stop();
                                }
                            }, _callee, null, [
                                [
                                    2,
                                    9
                                ]
                            ]);
                        }));
                        return function(_) {
                            return _ref.apply(this, arguments);
                        };
                    }());
                case 22:
                    if (!(refreshTokenConfig.refreshingTokenStatus === "success")) {
                        _ctx.next = 30;
                        break;
                    }
                    if (!(axiosError.config.headers.Authorization === "Bearer ".concat(getAccessTokenData().accessToken))) {
                        _ctx.next = 25;
                        break;
                    }
                    throw new Error("Token Alreadry Refreshed");
                case 25:
                    // Proceed new incoming API call with new API token
                    axiosError.config.headers.Authorization = "Bearer ".concat(getAccessTokenData().accessToken);
                    _ctx.next = 28;
                    return apiInstance.request(axiosError.config);
                case 28:
                    newRequest = _ctx.sent;
                    return _ctx.abrupt("return", newRequest);
                case 30:
                    if (refreshTokenConfig.refreshingTokenStatus === "failed") {
                        refreshTokenConfig.refreshAndRetryQueue.forEach(function() {
                            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param, index) {
                                var reject;
                                return runtime_default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            reject = param.reject;
                                            reject(axiosError);
                                            if (index === refreshTokenConfig.refreshAndRetryQueue.length - 1) {
                                                refreshTokenConfig.refreshAndRetryQueue = [];
                                            }
                                        case 3:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee);
                            }));
                            return function(_, index) {
                                return _ref.apply(this, arguments);
                            };
                        }());
                    }
                    _ctx.next = 37;
                    break;
                case 33:
                    _ctx.prev = 33;
                    _ctx.t1 = _ctx["catch"](3);
                    if (typeof refreshTokenConfig !== "undefined") {
                        refreshTokenConfig.refreshingTokenStatus = "failed";
                    }
                    return _ctx.abrupt("return", Promise.reject(_ctx.t1));
                case 37:
                    return _ctx.abrupt("return", new Promise(function(resolve, reject) {
                        getRefreshTokenConfig().refreshAndRetryQueue.push({
                            config: axiosError.config,
                            resolve: resolve,
                            reject: reject
                        });
                    }));
                case 38:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                3,
                33
            ],
            [
                11,
                18
            ]
        ]);
    }));
    return function generateNewRequestWithRefreshToken(_) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var refreshToken = (generateNewRequestWithRefreshToken);

// EXTERNAL MODULE: ./src/config/refreshToken/exodus.ts
var exodus = __webpack_require__(14350);
// EXTERNAL MODULE: ./src/config/APIErrorMessage/utils.ts
var utils = __webpack_require__(63858);
// EXTERNAL MODULE: ./src/config/APIErrorMessage/index.js + 1 modules
var APIErrorMessage = __webpack_require__(60714);
;// CONCATENATED MODULE: ./src/config/requestExodus.ts















var APIExodusErrorHandler = APIErrorMessage/* default.APIExodusErrorHandler */.Z.APIExodusErrorHandler;
function requestExodus() {
    var isShowAlertMessage = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true, context = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, customUserAgent = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, extraHeaders = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    var headers = (0,_object_spread/* default */.Z)({
        Accept: "application/json"
    }, extraHeaders);
    if (customUserAgent) {
        headers = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, headers), {
            "User-Agent": api/* CUSTOM_USER_AGENT */.GV
        });
    }
    var apiInstance = axios_default().create({
        baseURL: api/* API_EXODUS_URL */.q7,
        headers: headers
    });
    apiInstance.interceptors.request.use(function(request) {
        var ref, ref1;
        var requestFromBrowser = (0,app/* isClient */.C5)();
        if (!requestFromBrowser) {
            return request;
        }
        if (!(window === null || window === void 0 ? void 0 : (ref = window.navigator) === null || ref === void 0 ? void 0 : ref.onLine)) {
            (0,AlertErrorMessage/* default */.Z)(errorMessage/* default.OFFLINE */.Z.OFFLINE, errorMessage/* default.ALERT_RED */.Z.ALERT_RED);
            return Promise.reject(errorMessage/* default.OFFLINE */.Z.OFFLINE);
        }
        // Custom Authorization Header Exist
        if (request.headers.Authorization) {
            return request;
        }
        // Default Authorization
        var parsedToken = auth/* default.getToken */.Z.getToken();
        var token = parsedToken === null || parsedToken === void 0 ? void 0 : (ref1 = parsedToken.accessToken) === null || ref1 === void 0 ? void 0 : ref1.token;
        if (request.url !== "/user/setting/password/reset" && token) {
            // eslint-disable-next-line no-param-reassign
            request.headers.Authorization = "Bearer ".concat(token);
        }
        return request;
    }, function(error) {
        return Promise.reject(error);
    });
    apiInstance.interceptors.response.use(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(response) {
            var responseRetrieveFromBrowser, _data, errorType, _message, message;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        responseRetrieveFromBrowser = (0,app/* isClient */.C5)();
                        if (responseRetrieveFromBrowser) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return", response);
                    case 3:
                        _data = response.data, errorType = _data.error_type, _message = _data.message, message = _message === void 0 ? errorMessage/* default.DEFAULT_ERROR_MESSAGE */.Z.DEFAULT_ERROR_MESSAGE : _message;
                        if (!(errorType && isShowAlertMessage)) {
                            _ctx.next = 7;
                            break;
                        }
                        (0,AlertErrorMessage/* default */.Z)(message, errorMessage/* default.ALERT_RED */.Z.ALERT_RED);
                        throw message;
                    case 7:
                        return _ctx.abrupt("return", response);
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(response) {
            return _ref.apply(this, arguments);
        };
    }(), function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(axiosError) {
            var ref, ref1, ref2, ref3, responseRetrieveFromBrowser, newRequest, _response, status, data, message, errorType, errors, parsedMessage;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        responseRetrieveFromBrowser = (0,app/* isClient */.C5)();
                        if (responseRetrieveFromBrowser) {
                            _ctx.next = 4;
                            break;
                        }
                        return _ctx.abrupt("return", Promise.reject(axiosError));
                    case 4:
                        if (axiosError === null || axiosError === void 0 ? void 0 : axiosError.response) {
                            _ctx.next = 6;
                            break;
                        }
                        return _ctx.abrupt("return", Promise.reject(axiosError));
                    case 6:
                        //-------------------------------------------
                        // Error Logger
                        (0,logger/* sentryLog */.gB)({
                            scope: "server-layer",
                            level: "info",
                            httpStatusCode: (ref = axiosError.response) === null || ref === void 0 ? void 0 : ref.status,
                            tags: [
                                {
                                    title: "api-error-url",
                                    value: axiosError === null || axiosError === void 0 ? void 0 : (ref1 = axiosError.request) === null || ref1 === void 0 ? void 0 : ref1.responseURL
                                },
                                {
                                    title: "api-error-text",
                                    value: axiosError === null || axiosError === void 0 ? void 0 : (ref2 = axiosError.request) === null || ref2 === void 0 ? void 0 : ref2.responseText
                                }, 
                            ],
                            error: new Error(axiosError.message)
                        });
                        if (![
                            401
                        ].includes((ref3 = axiosError.response) === null || ref3 === void 0 ? void 0 : ref3.status)) {
                            _ctx.next = 19;
                            break;
                        }
                        _ctx.prev = 8;
                        _ctx.next = 11;
                        return refreshToken({
                            apiInstance: apiInstance,
                            axiosError: axiosError,
                            getRefreshTokenConfig: exodus/* getRefreshTokenConfigFn */.oD,
                            getAccessTokenData: exodus/* getAccessTokenDataFn */.RL,
                            refreshTokenPromise: exodus/* refreshExodusToken */.x5
                        });
                    case 11:
                        newRequest = _ctx.sent;
                        return _ctx.abrupt("return", newRequest);
                    case 15:
                        _ctx.prev = 15;
                        _ctx.t0 = _ctx["catch"](8);
                        (0,utils/* dispatchSetErrorCode */.S)(401);
                        return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                    case 19:
                        _response = axiosError.response, status = _response.status, data = _response.data;
                        message = data === null || data === void 0 ? void 0 : data.message;
                        errorType = data === null || data === void 0 ? void 0 : data.error_type;
                        errors = (data === null || data === void 0 ? void 0 : data.errors) || [];
                        // Some error message is unparsed in `message`
                        if (!errorType) {
                            parsedMessage = JSON.parse(message);
                            message = parsedMessage.message;
                            errorType = parsedMessage.error_type;
                        }
                        if (isShowAlertMessage) {
                            _ctx.next = 26;
                            break;
                        }
                        return _ctx.abrupt("return", Promise.reject(new Error(axiosError.message, {
                            cause: {
                                status: status,
                                message: message,
                                errorType: errorType,
                                errors: errors
                            }
                        })));
                    case 26:
                        APIExodusErrorHandler(status, errorType, message);
                        return _ctx.abrupt("return", Promise.reject(new Error(axiosError.message, {
                            cause: {
                                status: status,
                                message: message,
                                errorType: errorType,
                                errors: errors
                            }
                        })));
                    case 28:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    8,
                    15
                ]
            ]);
        //-------------------------------------------
        }));
        return function(axiosError) {
            return _ref.apply(this, arguments);
        };
    }());
    return apiInstance;
}
/* harmony default export */ var config_requestExodus = (requestExodus);


/***/ }),

/***/ 37213:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BW": function() { return /* binding */ STOCKBIT_ACADEMY_URL; },
/* harmony export */   "CT": function() { return /* binding */ API_BASE_URL; },
/* harmony export */   "Cb": function() { return /* binding */ API_TRADING_URL; },
/* harmony export */   "GV": function() { return /* binding */ CUSTOM_USER_AGENT; },
/* harmony export */   "J3": function() { return /* binding */ GIPHY_STICKERS_URL; },
/* harmony export */   "Me": function() { return /* binding */ AWS_IMAGES_BUCKET; },
/* harmony export */   "UY": function() { return /* binding */ GIPHY_API_KEY; },
/* harmony export */   "VE": function() { return /* binding */ GOOGLE_PLAY_URL; },
/* harmony export */   "ZB": function() { return /* binding */ API_CURATOR_URL; },
/* harmony export */   "_O": function() { return /* binding */ SITE_URL; },
/* harmony export */   "cU": function() { return /* binding */ AWS_AVATAR_BUCKET; },
/* harmony export */   "cu": function() { return /* binding */ API_TRADING_URL_V2; },
/* harmony export */   "fN": function() { return /* binding */ GIPHY_URL; },
/* harmony export */   "jd": function() { return /* binding */ CURATOR_FEED_ID; },
/* harmony export */   "kg": function() { return /* binding */ API_SECURITIES_GENERAL_URL; },
/* harmony export */   "l5": function() { return /* binding */ APP_STORE_URL; },
/* harmony export */   "lZ": function() { return /* binding */ FACEBOOK_APP_ID; },
/* harmony export */   "q$": function() { return /* binding */ AVATAR_URL; },
/* harmony export */   "q7": function() { return /* binding */ API_EXODUS_URL; },
/* harmony export */   "rM": function() { return /* binding */ AWS_EBOOK_BUCKET; },
/* harmony export */   "uJ": function() { return /* binding */ GOPAY_URL_JAVASCRIPT; },
/* harmony export */   "vw": function() { return /* binding */ AWS_TRADE_REG_BUCKET; }
/* harmony export */ });
/* unused harmony exports STAGE, API_SECURITIES_ALT_URL, SOCKET_URL, AWS_CHAT_BUCKET, GOPAY_QR_CODE_URL, GOPAY_REF_ID_URL, API_VERSION_ALT, DESKTOP_APP_BUCKET, DESKTOP_APP_SECRET_KEY, DESKTOP_APP_ACCESS_KEY, DESKTOP_APP_URL, DESKTOP_APP_END_POINT, CURATOR_TOKEN, APPLE_APP_SITE_ID */
/* provided dependency */ var process = __webpack_require__(34155);
var STAGE = (/* unused pure expression or super */ null && ("production" || 0));
var SITE_URL = "https://stockbit.com" || 0;
var SOCKET_URL = (/* unused pure expression or super */ null && ("https://ws3.stockbit.com/"));
// Separate the version with base URL, if we need more version
// just add from `.env`, then add them into this file
var API_VERSION = "v2.5";
var API_VERSION_ALT = "v2.4" || 0;
var API_BASE_URL = "".concat("https://api.stockbit.com", "/").concat(API_VERSION);
var API_EXODUS_URL = "https://exodus.stockbit.com";
var API_TRADING_URL = "https://trading.masonline.id";
var API_TRADING_URL_V2 = "https://carina.stockbit.com";
var API_SECURITIES_ALT_URL = "".concat("https://api.stockbit.com", "/").concat(API_VERSION_ALT);
// Can be used with social or trading authorization
var API_SECURITIES_GENERAL_URL = "https://api-sekuritas.stockbit.com";
var API_CURATOR_URL = "https://api.curator.io";
var AVATAR_URL = "https://avatar.stockbit.com" || 0;
var AWS_AVATAR_BUCKET = "https://avatar.stockbit.com" || 0;
var AWS_IMAGES_BUCKET = "https://stockbit.s3.amazonaws.com";
var AWS_TRADE_REG_BUCKET = "https://simasreg.s3.amazonaws.com";
var AWS_EBOOK_BUCKET = "https://s3-ap-southeast-1.amazonaws.com/ebookstbx";
var AWS_CHAT_BUCKET = process.env.NEXT_PUBLIC_AWS_CHAT_BUCKET;
var GIPHY_URL = "https://api.giphy.com/v1/gifs";
var GIPHY_STICKERS_URL = "https://api.giphy.com/v1/stickers";
var GIPHY_API_KEY = "ZME7nTxOPIqXCf9qhCfqB1ICqtFCbCs5" || 0;
var GOPAY_URL_JAVASCRIPT = "https://app.midtrans.com/snap/snap.js" || 0;
var GOPAY_QR_CODE_URL = (/* unused pure expression or super */ null && ("https://api.sandbox.veritrans.co.id/v2/gopay/" || 0));
var GOPAY_REF_ID_URL = (/* unused pure expression or super */ null && ("https://simulator.sandbox.midtrans.com/gopay/ui/checkout?referenceid=" || 0));
var FACEBOOK_APP_ID = "247631672013136" || 0;
// link to download stockbit app
var GOOGLE_PLAY_URL = "https://play.google.com/store/apps/details?id=com.stockbit.android&hl=en";
var APP_STORE_URL = "https://itunes.apple.com/us/app/stockbit/id1184800207?mt=8";
var STOCKBIT_ACADEMY_URL = "https://academy.stockbit.com";
var CUSTOM_USER_AGENT = "webapp-api-293bf2f3-2d64-4948-94dd-9277ebbe96d";
var DESKTOP_APP_BUCKET = (/* unused pure expression or super */ null && ("sb-sda-release"));
var DESKTOP_APP_SECRET_KEY = (/* unused pure expression or super */ null && ("EFKHBWQHWq0jWNNGM2/e35vU4vOrN4OHyd4f09Kv"));
var DESKTOP_APP_ACCESS_KEY = (/* unused pure expression or super */ null && ("AKIAX4CD7C6D4DF5LTF6"));
var DESKTOP_APP_URL = (/* unused pure expression or super */ null && ("https://sda-release.stockbit.com/"));
var DESKTOP_APP_END_POINT = (/* unused pure expression or super */ null && ("https://s3.ap-southeast-3.amazonaws.com/"));
var CURATOR_TOKEN = (/* unused pure expression or super */ null && ("ae406fc1-d23a-4a34-a0c9-164c7d2204ea"));
var CURATOR_FEED_ID = "1e81f0c0-550d-492e-b3ae-0dd4706df21f";
var APPLE_APP_SITE_ID = (/* unused pure expression or super */ null && ("ASHUNREKRL.stockbit.com.stockbit"));



/***/ }),

/***/ 86123:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ax": function() { return /* binding */ GTM_ID; },
/* harmony export */   "C5": function() { return /* binding */ isClient; },
/* harmony export */   "Vc": function() { return /* binding */ assetPrefix; },
/* harmony export */   "cU": function() { return /* binding */ AWS_AVATAR_BUCKET; },
/* harmony export */   "d7": function() { return /* binding */ CLEVERTAP_ID; },
/* harmony export */   "m6": function() { return /* binding */ TRADING_VIEW_ASSET_PREFIX; },
/* harmony export */   "mM": function() { return /* binding */ assetsStatic; },
/* harmony export */   "or": function() { return /* binding */ STAGE; },
/* harmony export */   "qV": function() { return /* binding */ PROJECT_FOLDER_PATH; },
/* harmony export */   "sP": function() { return /* binding */ PROJECT_FOLDER; },
/* harmony export */   "t0": function() { return /* binding */ CRISP_ID; },
/* harmony export */   "yv": function() { return /* binding */ isProduction; },
/* harmony export */   "yz": function() { return /* binding */ siteUrl; }
/* harmony export */ });
/* unused harmony exports CDN, R2_ASSET_PREFIX, FB_APP_ID, USER_AGENT, OPEN_HOUR, CLOSE_HOUR, isMarketOpen, STRUCTURED_DATA */
/* provided dependency */ var process = __webpack_require__(34155);
var PROJECT_FOLDER = process.env.NEXT_PUBLIC_PROJECT_FOLDER;
var PROJECT_FOLDER_PATH = PROJECT_FOLDER ? "/".concat(PROJECT_FOLDER) : "";
var CDN = "https://stockbit.com" || 0;
var assetPrefix = CDN ? "".concat(CDN).concat(PROJECT_FOLDER_PATH) : "";
var R2_ASSET_PREFIX = "https://web-assets.stockbit.com";
var TRADING_VIEW_ASSET_PREFIX = process.env.NEXT_PUBLIC_TV_ASSET || "https://stockbit.com/tradingview/charting_library/";
var FB_APP_ID = (/* unused pure expression or super */ null && ("247631672013136" || 0));
var GTM_ID = "GTM-5DQC6T3" || 0;
var siteUrl = "https://stockbit.com" || 0;
var STAGE = "production" || 0;
var CLEVERTAP_ID = "6ZW-897-5R6Z";
var AWS_AVATAR_BUCKET = "https://avatar.stockbit.com" || 0;
var USER_AGENT = (/* unused pure expression or super */ null && ("webapp-api-293bf2f3-2d64-4948-94dd-9277ebbe96d" || 0));
var CRISP_ID = "44ed90bf-ce78-4f5f-a9f8-82e000538b9b" || 0;
var isClient = function() {
    return "object" !== "undefined";
};
var isProduction = "production" === "production";
// Market hour
var OPEN_HOUR = 9;
var CLOSE_HOUR = 15;
var isMarketOpen = function() {
    var currentTime = new Date().getHours();
    // return currentTime >= OPEN_HOUR && currentTime <= CLOSE_HOUR;
    return currentTime >= OPEN_HOUR;
};
var STRUCTURED_DATA = {
    "@context": "http://schema.org",
    "@type": "Corporation",
    name: "Stockbit",
    legalName: "Stockbit",
    description: "Stockbit adalah komunitas investasi di Indonesia. Stockbit memberi ruang bagi investor dan trader untuk berbagi ide, berita dan informasi keuangan lainya secara real-time. Pengguna bisa membuat profil dan mengikuti saham tertentu atau investor favorit untuk mendapatkan informasi berharga dan bertukar pikiran. Fitur utama dari Stockbit yaitu 'stream' terdiri dari ide-ide, grafik saham, link dan data keuangan lainya. Stockbit menggunakan tanda '$' sebelum kode saham sebagai penandaan ide untuk mempermudah pengguna dalam mencari informasi tentang saham individu tertentu. Platform Stockbit juga terintegrasi dengan platform social media lainya, seperti Twitter dan Facebook, sehingga mudah untuk berbagi ide-ide di Stockbit ke akun Twitter dan Facebook pengguna. Stockbit dirancang dengan fitur yang terfokus dengan keperilakuan investor dan trader sehingga akan lebih berguna sebagai social media khusus investasi.",
    logo: "https://assets-nextjs.stockbit.com/img/favicon.ico",
    url: "https://stockbit.com",
    telephone: "+6221 57906242",
    sameAs: [
        "https://twitter.com/Stockbit",
        "https://www.linkedin.com/company/stockbit",
        "https://www.facebook.com/Stockbit",
        "https://www.youtube.com/c/Stockbit",
        "https://instagram.com/stockbit",
        "https://www.crunchbase.com/organization/stockbit", 
    ],
    address: {
        "@type": "PostalAddress",
        streetAddress: "RDTX Square 33rd Floor, Jl. Prof. Dr. Satrio No 164 - Jakarta",
        addressLocality: "Jakarta Selatan",
        postalCode: "12930",
        addressCountry: "Indonesia"
    }
};
var assetsStatic = "".concat("https://assets.stockbit.com");


/***/ }),

/***/ 70524:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var RUNNING_TRADE = {
    SEARCH_INPUT: "running-trade-search-input",
    SEARCH_INPUT_CLEAR_BUTTON: "running-trade-search-input-clear-button"
};
var CALENDAR = {
    HEADER_MORE_BUTTON: "calendar-header-more-button",
    ROW_SYMBOL: "calendar-row-symbol"
};
var PROFILE = {
    HEADER_MORE_BUTTON: "profile-header-more-button",
    HEADER_BLOCK_BUTTON: "profile-header-block-button"
};
var CHATROOM = {
    GROUP_MEMBER: "chatroom-group-member",
    SEND_MESSAGE_BUTTON: "chatroom-send-message-button",
    CONFIRM_DELETE_MESSAGE_BUTTON: "chatroom-confirm-delete-message-button",
    CAPSULE_USER_NEW_GROUP: "chatroom-capsule-user-new-group",
    CAPSULE_USER_NEW_GROUP_CLOSE: "chatroom-capsule-user-new-group-close",
    SUGGESTED_USER: "chatroom-suggested-user"
};
var COMPANY = {
    NAVBAR_MORE_MENU: "company-navbar-more-menu",
    WIDGET_CATALOG: "company-widget-catalog",
    WIDGET_CATALOG_ITEM: "company-widget-catalog-item",
    WIDGET_INVESTMENT_MORE_BUTTON: "company-widget-investment-more-button"
};
var NOTIFICATION = {
    TITLE_TEXT: "notification-title-text"
};
var VALUATION = {
    HEADER_TITLE: "valuation-header-title",
    HEADER_MORE_BUTTON: "valuation-header-more-button"
};
var NAVIGATION = {
    MORE_MENU_BUTTON: "navigation-more-menu-button"
};
var GLOSSARY = {
    SEARCH_SUGGESTION: "glossary-search-suggestion"
};
var SHARE_POST = {
    CHECKBOX: "share-post-checkbox",
    SEND_BUTTON: "share-post-send-button"
};
var STREAM_POST = {
    CONFIRM_DELETE_BUTTON: "stream-post-confirm-delete-button",
    CONFIRM_CANCEL_BUTTON: "stream-post-confirm-cancel-button"
};
var EARNINGS = {
    SEARCH_SYMBOL_INPUT: "earnings-search-symbol-input",
    SEARCH_SYMBOL_BUTTON: "earnings-search-symbol-button",
    TABLE_ROW_SYMBOL: "earnings-table-row-symbol"
};
var FINANCIALS = {
    TABLE_TITLE_TEXT: "financials-table-title-text",
    TABLE_QUARTER_TEXT: "financials-table-quarter-text",
    TABLE_INCOME_TEXT: "financials-table-income-text"
};
var SCREENER = {
    DELETE_RULES_BUTTON: "screener-delete-rules-button",
    CLOSE_POPUP_BUTTON: "screener-close-popup-button",
    STOCK_SEARCH_INPUT: "screener-stock-search-input"
};
var LANDING = {
    REGISTER_BUTTON: "landing-register-button",
    LOGIN_BUTTON: "landing-login-button"
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    RUNNING_TRADE: RUNNING_TRADE,
    CALENDAR: CALENDAR,
    PROFILE: PROFILE,
    CHATROOM: CHATROOM,
    COMPANY: COMPANY,
    NOTIFICATION: NOTIFICATION,
    VALUATION: VALUATION,
    NAVIGATION: NAVIGATION,
    GLOSSARY: GLOSSARY,
    SHARE_POST: SHARE_POST,
    STREAM_POST: STREAM_POST,
    EARNINGS: EARNINGS,
    FINANCIALS: FINANCIALS,
    SCREENER: SCREENER,
    LANDING: LANDING
});


/***/ }),

/***/ 61608:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var ERROR_MESSAGE = {
    ALERT_RED: "alert-red",
    DEFAULT: "DEFAULT",
    MAINTENANCE: "MAINTENANCE",
    NOPERMISSION: "NOPERMISSION",
    NOTRADINGPERMISSION: "NOTRADINGPERMISSION",
    INVALIDPARAMETER: "INVALIDPARAMETER",
    INVALID_PARAMETER: "INVALID_PARAMETER",
    INVALID_RECAPTCHA: "INVALID_RECAPTCHA",
    INVALID_LOGIN: "INVALID_LOGIN",
    ERR_SYSTEM: "ERR_SYSTEM",
    ERR_INVALID_PARAMS: "ERR_INVALID_PARAMS",
    ERR_ORDER_FAIL: "ERR_ORDER_FAIL",
    ERR_PIN_INVALID: "ERR_PIN_INVALID",
    ERR_LOGIN_FAIL: "ERR_LOGIN_FAIL",
    INVALID_AMEND: "INVALID_AMEND",
    INVALID_PIN: "INVALID_PIN",
    SYSTEMERROR: "SYSTEMERROR",
    NOTFOUND: "NOTFOUND",
    NOSUBSCRIPTION: "NOSUBSCRIPTION",
    PAYWALL_ERROR: "PAYWALL",
    PAYWALL_NOSUBSCRIPTION: "NO_SUBSCRIPTION",
    NOPHONEVERIFY: "NOPHONEVERIFY",
    UNAUTHORIZED: "UNAUTHORIZED",
    FORBIDDEN: "FORBIDDEN",
    SERVICE_BUSY: "SERVICE_BUSY",
    INVALID_SESSION: "INVALID_SESSION",
    ERR_LOGIN_AUTHORIZATION: "ERR_LOGIN_AUTHORIZATION",
    ERR_PIN_AUTHORIZATION: "ERR_PIN_AUTHORIZATION",
    ERR_UNKNOWN_BROKER: "ERR_UNKNOWN_BROKER",
    INCORRECT_PIN: "INCORRECT_PIN",
    INVALID_CREDS: "INVALID_CREDS",
    UNKNOWN_SYSTEM_ERROR: "Kondisi Internet Kamu Sedang Tidak Stabil.",
    OFFLINE: "Kondisi internet kamu sedang tidak stabil",
    DEFAULT_ERROR_MESSAGE: "Something is terribly wrong, please contact our administrator",
    PERMISSION_DENIED: "You do not have enough permission to access the resources",
    // error message upload avatar onboarding
    UPLOAD_FAILED: "Upload Failed",
    PLEASE_LOAD_IMAGE: "Please load an image",
    UPLOAD_IMAGE_TYPE_NOT_SUPPORTED: "Only image file (type: JPEG, JPG, PNG, and GIF) allowed",
    UPLOAD_DOCUMENT_TYPE_NOT_SUPPORTED: "Only document file (type: PDF, DOC, DOCX, PPT, PPTX, XLS and XLSX) allowed",
    MAX_FILE_SIZE: "Max File Size 2Mb",
    INVALID_AVATAR_EXTENSION: "Only image file (type: JPEG, JPG, and PNG) allowed",
    // stream error message
    DOCUMENT_IMAGE_NOT_ALLOWED: 'Image files (such as jpg, jpeg, png, gif) are not allowed to be uploaded from "Attach Document" input',
    MAX_UPLOAD_FILES: "Maximum of 1 file uploads allowed",
    STREAM_TEXT_REQUIRED: "Text is required in posts",
    STREAM_TARGET_PRICE_REQUIRED: "Target Price is required in posts",
    STREAM_ERROR_UPLOAD_FILE: "Upload file error",
    ACADEMY_ERROR_MESSAGE: "Failed to open Academy, Please reload this page",
    // Screener
    SCREENER_SPECIFY_RULES: "Please enter at least one screening rule",
    SCREENER_SPECIFY_RULES_VALUE: "Please enter a value on your screening rule",
    // Tipping
    TIPPING_MAX_AMOUNT_ERROR: "Jumlah Maksimal Tip Rp 10,000,000",
    // Fundachart
    MAX_METRICES_AND_SYMBOLS: "Harap pilih tidak lebih dari total 10 parameter (perusahaan/metrik) untuk bagan",
    // Chartbit
    LOAD_TEMPLATE: "Failed to load template",
    SAVE_TEMPLATE: "Failed to save template"
};
/* harmony default export */ __webpack_exports__["Z"] = (ERROR_MESSAGE);


/***/ }),

/***/ 44252:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BP": function() { return /* binding */ REGISTRATION_DATA; },
/* harmony export */   "Nv": function() { return /* binding */ REFRESH_TOKEN_KEY_EXP; },
/* harmony export */   "Wx": function() { return /* binding */ ACCESS_TOKEN_KEY; },
/* harmony export */   "ns": function() { return /* binding */ ACCESS_USER_KEY; },
/* harmony export */   "w4": function() { return /* binding */ REFRESH_TOKEN_KEY; },
/* harmony export */   "z0": function() { return /* binding */ ACCESS_TOKEN_KEY_EXP; }
/* harmony export */ });
var ACCESS_TOKEN_KEY = "at";
var ACCESS_TOKEN_KEY_EXP = "ate";
var REFRESH_TOKEN_KEY = "ar";
var REFRESH_TOKEN_KEY_EXP = "are";
var ACCESS_USER_KEY = "au";
var REGISTRATION_DATA = "registerData";


/***/ }),

/***/ 41208:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var SUCCESS_MESSAGE = {
    ALERT_GREEN: "alert-green",
    SNACKBAR_GREEN: "snackbar-green",
    PROFILE_UPDATED: "Profile Updated",
    POST_SUCCESSFUL: "Post successful",
    REPOST_SUCCESSFUL: "Post Reposted",
    REPLY_SUCCESSFUL: "Post reply successful!",
    SET_TOP_SUCCESSFUL: "Set as Top successful!",
    REMOVE_TOP_SUCCESSFUL: "Remove as Top successful!",
    RESET_TOP_SUCCESSFUL: "Reset as Top successful!",
    UNTAG_POST_SUCCESSFUL: "Untag Post Topic Success",
    PASSWORD_CHANGED: "Password changed",
    USER_BLOCKED: "User blocked",
    USER_UNBLOCKED: "User unblocked",
    CHANGE_NUMBER_SUCCESSFUL: "Phone number changed!",
    SAVE_TEMPLATE_SUCCESS: "Success save template",
    POST_SHARED_SUCCESSFUL: "Post Shared",
    EVENT_SHARED_SUCCESSFUL: "Event Shared",
    POST_PINNED_SUCCESSFUL: "Post successfully pinned",
    POST_UNPINNED_SUCCESSFUL: "Post successfully unpinned",
    POST_SUCCESSFUL_UPDATE: "Post successfully updated",
    POST_SUCCESSFUL_DELETED: "Successfully deleted",
    SCREENER_TEMPLATE_DELETED: "Screener Template Deleted",
    FACEBOOK_CONNECTED: "Facebook connect successful",
    GOPAY_CHANGED: "Nomor gopay anda berhasil diubah",
    REPORT_DELIVERED: "Success Report User",
    UPDATE_GROUP_PHOTO_SUCCESSFUL: "Group Photo Updated",
    DELETE_STREAM_MULTIPLE_SUCCESSFUL: "Success delete stream",
    FINANCIAL_COLUMN_DELETED: "Financial Column Deleted"
};
/* harmony default export */ __webpack_exports__["Z"] = (SUCCESS_MESSAGE);


/***/ }),

/***/ 4881:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _constant__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52288);

function useScrollChat() {
    var highlightChat = function(id) {
        var bubbleElement = document.getElementById("".concat(_constant__WEBPACK_IMPORTED_MODULE_0__/* .CHAT_BUBBLE_ID */ .H2, "-").concat(id));
        bubbleElement.classList.add("chat-highlight");
        setTimeout(function() {
            bubbleElement.classList.remove("chat-highlight");
        }, 3000);
    };
    var scrollToBottom = function() {
        setTimeout(function() {
            var contentElement = document.getElementById(_constant__WEBPACK_IMPORTED_MODULE_0__/* .CHAT_CONTENT_CONTAINER_ID */ .mR);
            if (contentElement) {
                contentElement.scrollTo({
                    top: contentElement.scrollHeight,
                    behavior: "smooth"
                });
            }
        }, 50);
    };
    var scrollToChatBubble = function(id) {
        var bubbleId = "".concat(_constant__WEBPACK_IMPORTED_MODULE_0__/* .CHAT_BUBBLE_ID */ .H2, "-").concat(id);
        var contentElement = document.getElementById(_constant__WEBPACK_IMPORTED_MODULE_0__/* .CHAT_CONTENT_CONTAINER_ID */ .mR);
        var bubbleElement = document.getElementById(bubbleId);
        if (bubbleElement) {
            contentElement.scrollTo({
                top: bubbleElement.offsetTop - contentElement.offsetTop - bubbleElement.offsetHeight * 0.1,
                behavior: "smooth"
            });
            highlightChat(id);
        } else {
            contentElement.scrollTo({
                top: 0,
                behavior: "smooth"
            });
            setTimeout(function() {
                scrollToChatBubble(id);
            }, 500);
        }
    };
    return {
        scrollToBottom: scrollToBottom,
        scrollToChatBubble: scrollToChatBubble,
        highlightChat: highlightChat
    };
}
/* harmony default export */ __webpack_exports__["Z"] = (useScrollChat);


/***/ }),

/***/ 37220:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ useGetReferralInfo; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lib_api_community__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89561);
/* harmony import */ var stores_useUIConfigStore__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7639);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14671);





var useGetReferralInfo = (0,zustand__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(function(set) {
    return {
        isLoading: false,
        fetchCommunityInfo: function fetchCommunityInfo() {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var remisierUI, response, data;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            remisierUI = stores_useUIConfigStore__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getState */ .Z.getState().getUIValue("remisier");
                            if (!remisierUI) {
                                _ctx.next = 4;
                                break;
                            }
                            return _ctx.abrupt("return");
                        case 4:
                            // If remisier UI is not exists, then we fetch from API
                            set({
                                isLoading: true
                            });
                            _ctx.next = 7;
                            return (0,lib_api_community__WEBPACK_IMPORTED_MODULE_1__/* .getReferralInfo */ .Qu)();
                        case 7:
                            response = _ctx.sent;
                            if (response.data) {
                                _ctx.next = 10;
                                break;
                            }
                            throw new Error("failed to get community info");
                        case 10:
                            data = response.data.data;
                            stores_useUIConfigStore__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getState */ .Z.getState().setUIValue("remisier", {
                                isLeader: data.is_leader,
                                isCommunityAccessGranted: data.enabled || data.is_leader
                            });
                            set({
                                isLoading: false
                            });
                            _ctx.next = 19;
                            break;
                        case 15:
                            _ctx.prev = 15;
                            _ctx.t0 = _ctx["catch"](0);
                            ;
                            set({
                                isLoading: false
                            });
                        case 19:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        15
                    ]
                ]);
            }))();
        }
    };
});


/***/ }),

/***/ 60602:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IX": function() { return /* binding */ AVATAR_SIZE; },
/* harmony export */   "Rm": function() { return /* binding */ ONBOARDING_MAX_STEP; },
/* harmony export */   "Wo": function() { return /* binding */ ONBOARDING_REQUEST_FILTER; }
/* harmony export */ });
var ONBOARDING_MAX_STEP = 4;
var AVATAR_SIZE = {
    BIG: "BIG",
    SMALL: "SMALL",
    PORTRAIT: "PORTRAIT"
};
// DISCOVER PEOPLE
var ONBOARDING_USER_SUGGEST_LIMIT = 30;
var ONBOARDING_USER_SUGGEST_PAGE = 1;
var ONBOARDING_USER_SUGGEST_FILTER = "FILTER_ONBOARDING";
var ONBOARDING_REQUEST_FILTER = {
    limit: ONBOARDING_USER_SUGGEST_LIMIT,
    page: ONBOARDING_USER_SUGGEST_PAGE,
    filter: ONBOARDING_USER_SUGGEST_FILTER
};



/***/ }),

/***/ 51346:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ku": function() { return /* binding */ localStorageOrderbookHandler; },
/* harmony export */   "M6": function() { return /* binding */ transformNewOrderbookListToExisting; },
/* harmony export */   "g8": function() { return /* binding */ memoizeChild; }
/* harmony export */ });
/* unused harmony export getErrorMessage */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


var localStorageOrderbookHandler = {
    get: function() {
        var orderbookName = localStorage.getItem("orderbooklistName");
        var orderbookID = localStorage.getItem("orderbooklistID");
        return {
            orderbookName: orderbookName,
            orderbookID: orderbookID
        };
    },
    set: function(orderbookName, orderbookID) {
        localStorage.setItem("orderbooklistID", orderbookID);
        localStorage.setItem("orderbooklistName", orderbookName);
    },
    remove: function() {
        localStorage.removeItem("orderbooklistID");
        localStorage.removeItem("orderbooklistName");
    }
};
var getErrorMessage = function(error) {
    var ref;
    var err = _instanceof(error, Error) ? (error === null || error === void 0 ? void 0 : (ref = error.cause) === null || ref === void 0 ? void 0 : ref.message) || error.message : String(error);
    return err;
};
var memoizeChild = function(component) {
    var circular = function() {
        var seen = new WeakSet();
        return function(key, value) {
            if (key.startsWith("_")) return; // Don't compare React's internal props.
            if (typeof value === "object" && value !== null) {
                if (seen.has(value)) return;
                seen.add(value);
            }
            // eslint-disable-next-line consistent-return
            return value;
        };
    };
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.memo)(component, function(prevProps, nextProps) {
        var prev = JSON.stringify(prevProps, circular());
        var next = JSON.stringify(nextProps, circular());
        return prev === next;
    });
};
var transformNewOrderbookListToExisting = function(newResponse) {
    var tradeable = newResponse.tradable ? 1 : 0;
    var bidObject = {};
    var offerObject = {};
    newResponse.bid.forEach(function(value, index) {
        var priceNameKey = "price".concat(index + 1);
        bidObject[priceNameKey] = value.price;
        var queNumNameKey = "que_num".concat(index + 1);
        bidObject[queNumNameKey] = value.que_num;
        var valueNameKey = "volume".concat(index + 1);
        bidObject[valueNameKey] = value.volume;
    });
    newResponse.offer.forEach(function(value, index) {
        var priceNameKey = "price".concat(index + 1);
        offerObject[priceNameKey] = value.price;
        var queNumNameKey = "que_num".concat(index + 1);
        offerObject[queNumNameKey] = value.que_num;
        var valueNameKey = "volume".concat(index + 1);
        offerObject[valueNameKey] = value.volume;
    });
    return {
        id: newResponse.id,
        symbol: newResponse.symbol,
        symbol_2: newResponse.symbol,
        symbol_3: newResponse.symbol,
        name: newResponse.name,
        status: newResponse.status,
        lastprice: newResponse.lastprice,
        previous: newResponse.previous,
        change: newResponse.change,
        percentage_change: newResponse.percentage_change,
        open: newResponse.open,
        high: newResponse.high,
        low: newResponse.low,
        close: newResponse.close,
        volume: newResponse.volume,
        value: newResponse.value,
        average: newResponse.average,
        bid: bidObject,
        offer: offerObject,
        frequency: newResponse.frequency,
        fbuy: newResponse.fbuy,
        fsell: newResponse.fsell,
        fnet: newResponse.fnet,
        fpercent: newResponse.fpercent,
        tradeable: tradeable,
        notation: newResponse.notation,
        uma: newResponse.uma,
        GUID: null,
        is_foreignbs_exist: newResponse.has_foreign_bs,
        exchange: newResponse.exchange,
        country: null,
        foreign: null,
        domestic: null,
        up: null,
        down: null,
        unchanged: null,
        iepiev: newResponse.iepiev,
        ara: newResponse.ara,
        arb: newResponse.arb,
        company_type: newResponse.company_type,
        corp_action: newResponse.corp_action,
        market_data: newResponse.market_data,
        auto_reject_estimation: newResponse.auto_reject_estimation
    };
};


/***/ }),

/***/ 16943:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _store_usePage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31837);
/* harmony import */ var _Paywall__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75850);
/* harmony import */ var _analytics__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67857);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35921);






function PaywallWrapper(param) {
    var children = param.children, feature = param.feature, isFlexible = param.isFlexible, isWidget = param.isWidget;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isReady = ref[0], setReady = ref[1];
    var ref1 = (0,_store_usePage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        featureKey: feature
    }), isPro = ref1.isPro, isLoading = ref1.isLoading, isRenewal = ref1.isRenewal;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setReady(true);
    }, []);
    if (isLoading || !isReady) {
        return null;
    }
    if (isPro) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: children
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_5__/* .PaywallPageWrapper */ .qh, {
        isFlexible: isFlexible,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Paywall__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            source: _analytics__WEBPACK_IMPORTED_MODULE_4__/* .PageAnalytics */ .oF[feature],
            isRenewal: isRenewal,
            isWidget: isWidget,
            height: "272px"
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (PaywallWrapper);


/***/ }),

/***/ 11298:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HY": function() { return /* binding */ PAYWALL_IMAGE_URL; },
/* harmony export */   "LB": function() { return /* binding */ CompanyStreamWidget; },
/* harmony export */   "RQ": function() { return /* binding */ DescriptionText; },
/* harmony export */   "Up": function() { return /* binding */ ButtonNewText; },
/* harmony export */   "Uw": function() { return /* binding */ CompanyWidgetEnum; },
/* harmony export */   "cY": function() { return /* binding */ ButtonContinueText; },
/* harmony export */   "gQ": function() { return /* binding */ CompanyWidgetTitle; },
/* harmony export */   "oz": function() { return /* binding */ OfferingPro; },
/* harmony export */   "pj": function() { return /* binding */ OfferingProText; },
/* harmony export */   "qU": function() { return /* binding */ PaywallFeatureEnum; },
/* harmony export */   "t9": function() { return /* binding */ AddOnWidget; },
/* harmony export */   "z": function() { return /* binding */ HeaderText; }
/* harmony export */ });
/* unused harmony exports IncludedNavbar, ExcludeOldPro, ExcludeOldProPage */
/* eslint-disable no-shadow */ var HeaderText = "Kuota Akses Bulanan Sudah Mencapai Limit";
var DescriptionText = "Nikmati akses seluruh fitur tanpa batas dengan membuka rekening saham di Stockbit Sekuritas.";
var ButtonNewText = "Buka Akses";
var ButtonContinueText = "Lanjut Berlangganan";
var PAYWALL_IMAGE_URL = "/img/paywall";
var OfferingPro = {
    open: {
        title: "Buka Rekening Saham",
        description: "Trading saham di Stockbit Sekuritas dan nikmati semua fitur tanpa batas.",
        iconUrl: "".concat(PAYWALL_IMAGE_URL, "/offering-open-icon.svg")
    },
    subscribe: {
        title: "Berlangganan",
        description: "Berlangganan mulai dari Rp15 ribu/hari untuk nikmati semua fitur tanpa batas.",
        iconUrl: "".concat(PAYWALL_IMAGE_URL, "/offering-subscribe-icon.svg")
    }
};
var OfferingProText = {
    headline: "Nikmati Seluruh Fitur",
    underlined: "Profesional Stockbit",
    unlimited: "Tanpa Batas"
};
var PaywallFeatureEnum;
(function(PaywallFeatureEnum) {
    PaywallFeatureEnum["DEFAULT"] = "PAYWALL_FEATURE_UNSPECIFIED";
    PaywallFeatureEnum["KEYSTATS"] = "PAYWALL_FEATURE_KEYSTATS";
    PaywallFeatureEnum["ANALYST"] = "PAYWALL_FEATURE_ANALYSIS";
    PaywallFeatureEnum["FINANCIALS"] = "PAYWALL_FEATURE_FINANCIALS";
    PaywallFeatureEnum["FUNDACHART"] = "PAYWALL_FEATURE_FUNDACHART";
    PaywallFeatureEnum["SEASONALITY"] = "PAYWALL_FEATURE_SEASONALITY";
    PaywallFeatureEnum["CHARTBIT"] = "PAYWALL_FEATURE_CHARTBIT";
    PaywallFeatureEnum["COMPARISON"] = "PAYWALL_FEATURE_COMPARISON";
    PaywallFeatureEnum["INSIDER"] = "PAYWALL_FEATURE_INSIDER";
    PaywallFeatureEnum["PROFILE"] = "PAYWALL_FEATURE_COMPANY_PROFILE";
    PaywallFeatureEnum["CORPACTION"] = "PAYWALL_FEATURE_CORP_ACTION";
    PaywallFeatureEnum["PRICE_ALERT"] = "PAYWALL_FEATURE_PRICE_ALERT";
    PaywallFeatureEnum["RUNNING_TRADE"] = "PAYWALL_FEATURE_RUNNING_TRADE";
    PaywallFeatureEnum["VALUATION"] = "PAYWALL_FEATURE_VALUATION";
    PaywallFeatureEnum["BANDAR_DETECTOR"] = "PAYWALL_FEATURE_BANDAR_DETECTOR";
    PaywallFeatureEnum["ORDERBOOK"] = "PAYWALL_FEATURE_ORDERBOOK";
    PaywallFeatureEnum["SCREENER"] = "PAYWALL_FEATURE_SCREENER";
    PaywallFeatureEnum["CALENDAR"] = "PAYWALL_FEATURE_CALENDAR";
    PaywallFeatureEnum["EARNINGS"] = "PAYWALL_FEATURE_EARNINGS";
})(PaywallFeatureEnum || (PaywallFeatureEnum = {}));
var CompanyWidgetEnum;
(function(CompanyWidgetEnum) {
    CompanyWidgetEnum["FUNDACHART"] = "FUNDACHART";
    CompanyWidgetEnum["SEASONALITY"] = "SEASONALITY";
    CompanyWidgetEnum["COMPARISON"] = "COMPARISON";
    CompanyWidgetEnum["FINANCIALS"] = "FINANCIALS";
})(CompanyWidgetEnum || (CompanyWidgetEnum = {}));
var IncludedNavbar = (/* unused pure expression or super */ null && ([
    "ORDERBOOK",
    "SCREENER",
    "VALUATION",
    "CALENDAR",
    "EARNINGS", 
]));
var CompanyStreamWidget = [
    "ORDERBOOK",
    "RUNNING_TRADE"
];
var CompanyWidgetTitle = {
    ORDERBOOK: "Orderbook",
    RUNNING_TRADE: "Running Trade",
    TRADE_BOOK: "Trade Book",
    BROKER_SUMMARY: "Broker Summary"
};
var AddOnWidget = "VALUATION";
var ExcludeOldPro = (/* unused pure expression or super */ null && ([
    "analyst",
    "insider",
    "profile",
    "corpaction"
]));
var ExcludeOldProPage = (/* unused pure expression or super */ null && ([
    "ORDERBOOK",
    "CALENDAR",
    "EARNINGS"
]));



/***/ }),

/***/ 92182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ store; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
// EXTERNAL MODULE: ./node_modules/immer/dist/immer.esm.mjs
var immer_esm = __webpack_require__(12902);
// EXTERNAL MODULE: ./src/config/requestExodus.ts + 1 modules
var requestExodus = __webpack_require__(68425);
;// CONCATENATED MODULE: ./src/lib/api/paywall.ts

var request = (0,requestExodus/* default */.Z)(false);
var GET_ELIGIBILITY_STATUS = "/paywall/eligibility/check";
var POST_PAYWALL_COUNTER = "/paywall/counter/increment";
var getPaywallStatus = function(param) {
    var company = param.company, feature = param.feature;
    var params = {
        features: feature
    };
    if (company) {
        params.company = company;
    }
    return request.get(GET_ELIGIBILITY_STATUS, {
        params: params
    });
};
var getMultipleStatus = function(payload) {
    var company = payload.company, feature = payload.feature;
    var companyQs = company ? "company=".concat(company, "&") : "";
    var featuresQs = feature.map(function(f) {
        return "features=".concat(f);
    }).join("&");
    return request.get("".concat(GET_ELIGIBILITY_STATUS, "?").concat(companyQs).concat(featuresQs));
};
var addPaywallCounter = function(param) {
    var company = param.company, feature = param.feature;
    var body = {
        feature: feature
    };
    if (company) {
        body.company = company;
    }
    return request.post(POST_PAYWALL_COUNTER, body);
};
/* harmony default export */ var paywall = ({
    getPaywallStatus: getPaywallStatus,
    getMultipleStatus: getMultipleStatus,
    addPaywallCounter: addPaywallCounter
});

;// CONCATENATED MODULE: ./src/features/paywall/store/index.ts








var sectionState = {
    isLoading: false,
    isRenewal: false,
    isPro: false,
    data: {
        features: [],
        last_subscription: null,
        company: null
    }
};
var initialState = {
    page: sectionState,
    company: sectionState,
    widget: sectionState
};
var useStorePaywall = (0,esm/* default */.ZP)(function(set) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, initialState), {
        getStatus: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(payload) {
                var ref, key, feature, company, isMultiple, payloadFeature, response, data, ref1, newData, ref2, ref3, selectedData, _is_eligible, defaultError;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            ;
                            key = payload.key, feature = payload.feature, company = payload.company;
                            isMultiple = Array.isArray(feature) && feature.length > 1;
                            payloadFeature = isMultiple ? feature[0] : feature;
                            set((0,immer_esm/* default */.ZP)(function(state) {
                                state[key].isLoading = true;
                            }));
                            if (!isMultiple) {
                                _ctx.next = 12;
                                break;
                            }
                            _ctx.next = 9;
                            return paywall.getMultipleStatus(payload);
                        case 9:
                            _ctx.t0 = _ctx.sent;
                            _ctx.next = 15;
                            break;
                        case 12:
                            _ctx.next = 14;
                            return paywall.getPaywallStatus(payload);
                        case 14:
                            _ctx.t0 = _ctx.sent;
                        case 15:
                            response = _ctx.t0;
                            if (!(!response || !response.data || !response.data.data)) {
                                _ctx.next = 18;
                                break;
                            }
                            throw new Error("Error while fetching paywall status");
                        case 18:
                            data = response.data.data;
                            ;
                            newData = {
                                isPro: false,
                                isRenewal: (ref1 = (data === null || data === void 0 ? void 0 : data.last_subscription) !== null) !== null && ref1 !== void 0 ? ref1 : false,
                                isLoading: false,
                                data: data
                            };
                            if (!(company && data.company)) {
                                _ctx.next = 27;
                                break;
                            }
                            ;
                            ;
                            newData.isPro = (ref3 = (ref2 = data.company) === null || ref2 === void 0 ? void 0 : ref2.is_eligible) !== null && ref3 !== void 0 ? ref3 : false;
                            set((0,immer_esm/* default */.ZP)(function(state) {
                                Object.assign(state[key], newData);
                            }));
                            return _ctx.abrupt("return", data);
                        case 27:
                            selectedData = (ref = data.features) === null || ref === void 0 ? void 0 : ref.find(function(item) {
                                return item.feature === payloadFeature;
                            });
                            if (selectedData) {
                                ;
                                newData.isPro = (_is_eligible = selectedData.is_eligible) !== null && _is_eligible !== void 0 ? _is_eligible : false;
                            }
                            set((0,immer_esm/* default */.ZP)(function(state) {
                                Object.assign(state[key], newData);
                            }));
                            return _ctx.abrupt("return", data);
                        case 33:
                            _ctx.prev = 33;
                            _ctx.t1 = _ctx["catch"](0);
                            defaultError = "Unknown error while fetching paywall status";
                            if (!(0,_instanceof/* default */.Z)(_ctx.t1, Error)) {
                                _ctx.next = 39;
                                break;
                            }
                            ;
                            return _ctx.abrupt("return", _ctx.t1.message);
                        case 39:
                            ;
                            return _ctx.abrupt("return", defaultError);
                        case 41:
                            _ctx.prev = 41;
                            set((0,immer_esm/* default */.ZP)(function(state) {
                                state[payload.key].isLoading = false;
                            }));
                            return _ctx.finish(41);
                        case 44:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        33,
                        41,
                        44
                    ]
                ]);
            }));
            return function(payload) {
                return _ref.apply(this, arguments);
            };
        }(),
        addCounter: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(payload) {
                var response, _data, error, errorType, message;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            _ctx.next = 3;
                            return paywall.addPaywallCounter(payload);
                        case 3:
                            response = _ctx.sent;
                            if (response.data) {
                                _ctx.next = 6;
                                break;
                            }
                            throw new Error("Error while post paywall counter");
                        case 6:
                            _data = response.data, error = _data.error, errorType = _data.error_type, message = _data.message;
                            if (!(error || errorType)) {
                                _ctx.next = 9;
                                break;
                            }
                            throw new Error(message);
                        case 9:
                            return _ctx.abrupt("return");
                        case 12:
                            _ctx.prev = 12;
                            _ctx.t0 = _ctx["catch"](0);
                            if (!(0,_instanceof/* default */.Z)(_ctx.t0, Error)) {
                                _ctx.next = 17;
                                break;
                            }
                            ;
                            return _ctx.abrupt("return");
                        case 17:
                            ;
                        case 18:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        12
                    ]
                ]);
            }));
            return function(payload) {
                return _ref.apply(this, arguments);
            };
        }(),
        resetProStatus: function(key) {
            set((0,immer_esm/* default */.ZP)(function(state) {
                state[key].isPro = false;
            }));
        }
    });
});
/* harmony default export */ var store = (useStorePaywall);


/***/ }),

/***/ 31837:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ usePage; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var zustand_shallow__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60374);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92182);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5072);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11298);





function usePage(param) {
    var featureKey = param.featureKey, _pauseCounter = param.pauseCounter, pauseCounter = _pauseCounter === void 0 ? false : _pauseCounter;
    var ref = (0,_index__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(state) {
        return {
            isPro: state.page.isPro,
            isLoading: state.page.isLoading,
            isRenewal: state.page.isRenewal,
            getStatus: state.getStatus,
            addCounter: state.addCounter
        };
    }, zustand_shallow__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z), isPro = ref.isPro, isLoading = ref.isLoading, isRenewal = ref.isRenewal, getStatus = ref.getStatus, addCounter = ref.addCounter;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var KEY = featureKey.toUpperCase();
        var featureName = _constants__WEBPACK_IMPORTED_MODULE_3__/* .PaywallFeatureEnum */ .qU[KEY];
        if (!featureName) return;
        if (!pauseCounter) addCounter({
            feature: featureName
        });
        getStatus({
            key: _types__WEBPACK_IMPORTED_MODULE_2__/* .SectionEnum.page */ .P.page,
            feature: featureName
        });
    }, [
        featureKey,
        pauseCounter
    ]);
    return {
        isPro: isPro,
        isLoading: isLoading,
        isRenewal: isRenewal
    };
};


/***/ }),

/***/ 5072:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ SectionEnum; }
/* harmony export */ });
var SectionEnum;
(function(SectionEnum) {
    SectionEnum["page"] = "page";
    SectionEnum["company"] = "company";
    SectionEnum["widget"] = "widget";
})(SectionEnum || (SectionEnum = {}));


/***/ }),

/***/ 27358:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2497);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19521);
/* harmony import */ var features_screener_slice__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15183);
/* harmony import */ var _deprecated_ui_watchlist_AutoComplete__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67864);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(22147);
/* eslint-disable array-callback-return */ /* eslint-disable no-param-reassign */ 


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-select-selection-placeholder {\n    font-family: var(--font-bold);\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var Option = _deprecated_ui_watchlist_AutoComplete__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Option */ .Z.Option;
var SAutoComplete = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_deprecated_ui_watchlist_AutoComplete__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).withConfig({
    componentId: "sc-727b1663-0"
})(_templateObject(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].downgray */ .Z.downgray);
var flattenArray = function(array, key) {
    return array.reduce(function(result, next) {
        if (next[key].length === 0) {
            result.push(next);
        }
        if (next[key]) {
            result = result.concat(flattenArray(next[key], key));
        }
        return result;
    }, []);
};
var addUniqueKey = function(dataArr) {
    return dataArr.map(function(el, index) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, el), {
            UUID: index
        });
    });
};
var convertMetricDataToAutoSuggestions = function(data) {
    var result = [];
    data.forEach(function(item) {
        result.push({
            name: item.fitem_name,
            id: item.fitem_id,
            UUID: item.UUID
        });
    });
    return result;
};
var AutoSuggestion = function(param) {
    var selectedValue = param.selectedValue, type = param.type, paddingX = param.paddingX, paddingT = param.paddingT, width = param.width, _placeholder = param.placeholder, placeholder = _placeholder === void 0 ? "Search . . ." : _placeholder, onClickSuggestion = param.onClickSuggestion;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), optionSuggestions = ref[0], setOptionSuggestions = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), resultSuggestions = ref1[0], setResultSuggestions = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), inputValue = ref2[0], setInputValue = ref2[1];
    var ref3 = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(features_screener_slice__WEBPACK_IMPORTED_MODULE_5__/* .screenerSelectors */ .p0), screenerPreset = ref3.screenerPreset, screenerFinancialMetric = ref3.screenerFinancialMetric, screenerUtils = ref3.screenerUtils;
    var isModalFinancialMetricActive = screenerUtils.isModalFinancialMetricActive, isModalPresetScreenerActive = screenerUtils.isModalPresetScreenerActive, isModalAddColumnActive = screenerUtils.isModalAddColumnActive;
    var getScreener = features_screener_slice__WEBPACK_IMPORTED_MODULE_5__/* .screenerEffects.getScreener */ .Ko.getScreener;
    var _actions = features_screener_slice__WEBPACK_IMPORTED_MODULE_5__/* ["default"].actions */ .ZP.actions, setScreenerModal = _actions.setScreenerModal, setIsModalFinancialMetricActive = _actions.setIsModalFinancialMetricActive, setIsModalPresetScreenerActive = _actions.setIsModalPresetScreenerActive, setIsModalAddColumnActive = _actions.setIsModalAddColumnActive, resetFormState = _actions.resetFormState;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useDispatch */ .I0)();
    var onTypeHandler = function() {
        var keyword = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        var lowerCaseKeyword = keyword === null || keyword === void 0 ? void 0 : keyword.toLowerCase();
        var result = optionSuggestions.filter(function(option) {
            return option.name.toLowerCase().includes(lowerCaseKeyword);
        });
        setInputValue(keyword);
        onClickSuggestion(null, keyword);
        if ((keyword === null || keyword === void 0 ? void 0 : keyword.length) > 0) {
            setResultSuggestions(result);
        } else {
            setResultSuggestions([]);
        }
    };
    var onClickHandler = function(value, option) {
        var id = option.id, name = option.name;
        // execute if autocomplete component mount in Modal: Preset
        if (isModalPresetScreenerActive) {
            setInputValue(null);
            dispatch(resetFormState());
            dispatch(getScreener({
                screenerID: id,
                type: "TEMPLATE_TYPE_GURU"
            }));
            dispatch(setIsModalPresetScreenerActive(false));
        }
        // execute if autocomplete component mount in Modal: Financial Metric
        if (isModalFinancialMetricActive) {
            setInputValue(null);
            dispatch(setScreenerModal({
                screenerType: "financial",
                id: id,
                name: name
            }));
            dispatch(setIsModalFinancialMetricActive(false));
        }
        // execute if autocomplete component mount in Modal: Add column
        if (isModalAddColumnActive) {
            setInputValue(null);
            dispatch(setScreenerModal({
                screenerType: "column",
                id: id,
                name: name
            }));
            dispatch(setIsModalAddColumnActive(false));
        }
        // execute if autocomplete component mount in screener rules (when user on new screener form)
        if (!isModalFinancialMetricActive && !isModalPresetScreenerActive && !isModalAddColumnActive) {
            onClickSuggestion(id, name);
        }
        setResultSuggestions([]);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        setInputValue(selectedValue);
    }, [
        selectedValue
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var dataPreset = screenerPreset.data;
        var dataFinancial = screenerFinancialMetric.data;
        if (type === "preset" && dataPreset.length > 0) {
            var flattedScreener = flattenArray(dataPreset, "childs");
            var withUnique = addUniqueKey(flattedScreener);
            setOptionSuggestions(withUnique);
        }
        if (type === "financial" && dataFinancial.length > 0) {
            var flattedFinancial = flattenArray(dataFinancial, "child");
            var withUnique1 = addUniqueKey(flattedFinancial);
            var convertedData = convertMetricDataToAutoSuggestions(withUnique1);
            setOptionSuggestions(convertedData);
        }
    }, [
        screenerPreset,
        screenerFinancialMetric,
        type
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SAutoComplete, {
        width: width,
        bordered: true,
        // @ts-expect-error
        px: paddingX,
        pt: paddingT,
        placeholder: placeholder,
        onSearch: onTypeHandler,
        onSelect: onClickHandler,
        value: inputValue,
        children: resultSuggestions.map(function(param) {
            var name = param.name, id = param.id, UUID = param.UUID;
            return(// @ts-expect-error
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Option, {
                id: id,
                name: name,
                children: name
            }, UUID));
        })
    });
};
AutoSuggestion.defaultProps = {
    selectedValue: null,
    type: "preset",
    paddingX: "12px",
    paddingT: "8px",
    width: "100%",
    placeholder: "Search . . .",
    onClickSuggestion: function() {}
};
AutoSuggestion.propTypes = {
    selectedValue: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    type: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    paddingX: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    paddingT: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    onClickSuggestion: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().func)
};
/* harmony default export */ __webpack_exports__["Z"] = (AutoSuggestion);


/***/ }),

/***/ 15183:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ko": function() { return /* binding */ screenerEffects; },
/* harmony export */   "p0": function() { return /* binding */ screenerSelectors; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(36305);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68697);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(61876);
/* harmony import */ var constants_successMessage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41208);
/* harmony import */ var global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25516);
/* harmony import */ var lib_api_screener__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70735);
/* eslint-disable no-undef */ 









// action types
var CONTEXT = "@feature/screener";
var actionType = {
    GET_SCREENER_FAVORITES: "".concat(CONTEXT, "/GET_SCREENER_FAVORITES"),
    GET_SCREENER_PRESET: "".concat(CONTEXT, "/GET_SCREENER_PRESET"),
    ADD_FAVORITE_SCREENER: "".concat(CONTEXT, "/ADD_FAVORITE_SCREENER"),
    REMOVE_FAVORITE_SCREENER: "".concat(CONTEXT, "/REMOVE_FAVORITE_SCREENER"),
    GET_SCREENER_UNIVERSE: "".concat(CONTEXT, "/GET_SCREENER_UNIVERSE"),
    GET_SCREENER_FINANCIAL: "".concat(CONTEXT, "/GET_SCREENER_FINANCIAL"),
    SAVE_OR_RUN_SCREENER: "".concat(CONTEXT, "/SAVE_OR_RUN_SCREENER"),
    GET_SCREENER: "".concat(CONTEXT, "/GET_SCREENER"),
    GET_SCREENER_CUSTOM: "".concat(CONTEXT, "/GET_SCREENER_CUSTOM"),
    REMOVE_SCREENER_CUSTOM: "".concat(CONTEXT, "/REMOVE_SCREENER_CUSTOM")
};
var initialState = {
    screenerUtils: {
        isFormActive: false,
        isFormEditMode: false,
        isFormCreateMode: false,
        isModalPresetScreenerActive: false,
        isModalFinancialMetricActive: false,
        isModalAddColumnActive: false,
        screenerAction: null,
        isEmptyResult: false
    },
    screenerFavorites: {
        data: [],
        message: "",
        isError: false,
        isLoading: false
    },
    screenerPreset: {
        message: "",
        data: [],
        isError: false,
        isLoading: false
    },
    activeScreener: 0,
    addFavoriteScreenerResult: {
        isError: false,
        isLoading: false,
        message: ""
    },
    removeFavoriteScreenerResult: {
        isError: false,
        isLoading: false,
        message: ""
    },
    screenerUniverse: {
        data: {},
        message: "",
        isError: false,
        isLoading: false
    },
    screenerFinancialMetric: {
        data: [],
        message: "",
        isError: false,
        isLoading: false
    },
    screenerResult: {
        data: {},
        message: "",
        isError: false,
        isLoading: false
    },
    screenerModal: {
        financialModal: {
            id: null,
            name: null
        },
        presetModal: {
            id: null,
            name: null
        },
        addColumnModal: {
            id: null,
            name: null
        }
    },
    screenerCustom: {
        message: "",
        data: [],
        isError: false,
        isLoading: false
    },
    removeCustomScreenerResult: {
        data: [],
        message: "",
        isError: false,
        isLoading: false
    },
    screenerPostResult: {
        data: {},
        message: "",
        isError: false,
        isLoading: false
    }
};
var screenerState = function(state) {
    return state.screener;
};
var screenerSelectors = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createSelector */ .P1)(screenerState, function(screener) {
    return {
        screenerUtils: screener.screenerUtils,
        screenerPreset: screener.screenerPreset,
        screenerFavorites: screener.screenerFavorites,
        addFavoriteScreenerResult: screener.addFavoriteScreenerResult,
        removeFavoriteScreenerResult: screener.removeFavoriteScreenerResult,
        screenerUniverse: screener.screenerUniverse,
        screenerFinancialMetric: screener.screenerFinancialMetric,
        screenerModal: screener.screenerModal,
        screenerResult: screener.screenerResult,
        screenerCustom: screener.screenerCustom,
        removeScreenerCustomResult: screener.removeCustomScreenerResult,
        screenerPostResult: screener.screenerPostResult
    };
});
var screenerEffects = {
    getScreenerFavorites: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createAsyncThunk */ .hg)(actionType.GET_SCREENER_FAVORITES, (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var response, data;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return lib_api_screener__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getScreenerFavorites */ .Z.getScreenerFavorites();
                case 3:
                    response = _ctx.sent;
                    if (response.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt to get list of favorites screener failed");
                case 6:
                    data = response.data;
                    return _ctx.abrupt("return", data);
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                10
            ]
        ]);
    }))),
    getScreenerPreset: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createAsyncThunk */ .hg)(actionType.GET_SCREENER_PRESET, (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var response, data;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return lib_api_screener__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getScreenerMetrics */ .Z.getScreenerMetrics();
                case 3:
                    response = _ctx.sent;
                    if (response.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt to get list of screener preset failed");
                case 6:
                    data = response.data;
                    return _ctx.abrupt("return", data);
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                10
            ]
        ]);
    }))),
    addFavorite: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createAsyncThunk */ .hg)(actionType.ADD_FAVORITE_SCREENER, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var screenerID, screenerType, response, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        screenerID = param.screenerID, screenerType = param.screenerType;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return lib_api_screener__WEBPACK_IMPORTED_MODULE_3__/* ["default"].addScreenerFavorite */ .Z.addScreenerFavorite(screenerID, screenerType);
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt to add screener favorite failed");
                    case 7:
                        data = response.data;
                        return _ctx.abrupt("return", data);
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    11
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    removeFavorite: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createAsyncThunk */ .hg)(actionType.REMOVE_FAVORITE_SCREENER, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var screenerID, screenerType, response, data, removedID;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        screenerID = param.screenerID, screenerType = param.screenerType;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return lib_api_screener__WEBPACK_IMPORTED_MODULE_3__/* ["default"].removeScreenerFavorite */ .Z.removeScreenerFavorite(screenerID, screenerType);
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt to remove screener favorite failed");
                    case 7:
                        data = response.data;
                        removedID = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, data), {
                            data: screenerID
                        });
                        return _ctx.abrupt("return", removedID);
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    12
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    getScreenerUniverse: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createAsyncThunk */ .hg)(actionType.GET_SCREENER_UNIVERSE, (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var response, data;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return lib_api_screener__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getScreenerUniverse */ .Z.getScreenerUniverse();
                case 3:
                    response = _ctx.sent;
                    if (response.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt get screener universe is failed");
                case 6:
                    data = response.data;
                    return _ctx.abrupt("return", data);
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                10
            ]
        ]);
    }))),
    getScreenerFinancialMetric: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createAsyncThunk */ .hg)(actionType.GET_SCREENER_FINANCIAL, (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var response, data;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return lib_api_screener__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getScreenerFinancial */ .Z.getScreenerFinancial();
                case 3:
                    response = _ctx.sent;
                    if (response.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt get financial metric is failed");
                case 6:
                    data = response.data;
                    return _ctx.abrupt("return", data);
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                10
            ]
        ]);
    }))),
    postScreener: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createAsyncThunk */ .hg)(actionType.SAVE_OR_RUN_SCREENER, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(_param) {
            var fromForm, payload, response, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        fromForm = _param.fromForm, payload = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_param, [
                            "fromForm"
                        ]);
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return lib_api_screener__WEBPACK_IMPORTED_MODULE_3__/* ["default"].postScreenerListResult */ .Z.postScreenerListResult(payload);
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt save or run screener is failed");
                    case 7:
                        data = response.data;
                        return _ctx.abrupt("return", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, data), {
                            fromForm: fromForm
                        }));
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    11
                ]
            ]);
        }));
        return function(_param) {
            return _ref.apply(this, arguments);
        };
    }()),
    getScreener: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createAsyncThunk */ .hg)(actionType.GET_SCREENER, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var screenerID, type, response, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        screenerID = param.screenerID, type = param.type;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return lib_api_screener__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getLoadPresetScreener */ .Z.getLoadPresetScreener(screenerID, type);
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt to get screener data is failed");
                    case 7:
                        data = response.data;
                        return _ctx.abrupt("return", data);
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    11
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    getScreenerCustom: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createAsyncThunk */ .hg)(actionType.GET_SCREENER_CUSTOM, (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var response, data;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return lib_api_screener__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getScreenerCustom */ .Z.getScreenerCustom();
                case 3:
                    response = _ctx.sent;
                    if (response.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt get custom screener is failed");
                case 6:
                    data = response.data;
                    return _ctx.abrupt("return", data);
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                10
            ]
        ]);
    }))),
    removeScreenerCustom: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createAsyncThunk */ .hg)(actionType.REMOVE_SCREENER_CUSTOM, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var id, response, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        id = param.id;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return lib_api_screener__WEBPACK_IMPORTED_MODULE_3__/* ["default"].removeScreenerCustom */ .Z.removeScreenerCustom(id);
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt to remove custom screener is failed");
                    case 7:
                        data = response.data;
                        (0,global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(constants_successMessage__WEBPACK_IMPORTED_MODULE_1__/* ["default"].SCREENER_TEMPLATE_DELETED */ .Z.SCREENER_TEMPLATE_DELETED, constants_successMessage__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ALERT_GREEN */ .Z.ALERT_GREEN);
                        return _ctx.abrupt("return", data);
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    12
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }())
};
var reducers = {
    setIsFormActive: function(state, action) {
        state.screenerUtils.isFormActive = action.payload;
    },
    setIsFormEditMode: function(state, action) {
        state.screenerUtils.isFormEditMode = action.payload;
    },
    setIsFormCreateMode: function(state, action) {
        state.screenerUtils.isFormCreateMode = action.payload;
    },
    setIsModalPresetScreenerActive: function(state, action) {
        state.screenerUtils.isModalPresetScreenerActive = action.payload;
    },
    setIsModalFinancialMetricActive: function(state, action) {
        state.screenerUtils.isModalFinancialMetricActive = action.payload;
    },
    setIsModalAddColumnActive: function(state, action) {
        state.screenerUtils.isModalAddColumnActive = action.payload;
    },
    setActiveScreener: function(state, action) {
        state.activeScreener = action.payload;
    },
    setScreenerModal: function(state, action) {
        var _payload = action.payload, screenerType = _payload.screenerType, id = _payload.id, name = _payload.name;
        if (screenerType === "preset") {
            state.screenerModal.presetModal = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, state.screenerModal.presetModal), {
                id: id,
                name: name
            });
            state.screenerModal.presetModal.name = name;
        } else if (screenerType === "financial") {
            state.screenerModal.financialModal = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, state.screenerModal.financialModal), {
                id: id,
                name: name
            });
            state.screenerModal.financialModal.name = name;
        } else if (screenerType === "column") {
            state.screenerModal.addColumnModal = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, state.screenerModal.addColumnModal), {
                id: id,
                name: name
            });
        }
    },
    resetFormState: function(state) {
        state.screenerUtils.isFormActive = false;
        state.screenerUtils.isFormEditMode = false;
        state.screenerUtils.isFormCreateMode = false;
        state.screenerResult.data = {};
        state.screenerPostResult.data = {};
        state.screenerUtils.screenerAction = null;
        state.screenerUtils.isEmptyResult = false;
    },
    addNewColumn: function(state) {
        state.screenerUtils.isFormActive = false;
        state.screenerUtils.isFormEditMode = false;
        state.screenerUtils.isFormCreateMode = false;
    },
    updateScreenerResult: function(state, action) {
        var _payload = action.payload, screenerAction = _payload.screenerAction, screener = _payload.screener;
        if (screenerAction === "get") {
            state.screenerResult.data = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, state.screenerResult.data, screener);
        }
        if (screenerAction === "post") {
            state.screenerPostResult.data = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, state.screenerPostResult.data, screener);
        }
    },
    resetAddColumnModal: function(state) {
        state.screenerModal.addColumnModal = {
            id: null,
            name: null
        };
    }
};
var extraReducer = function(builder) {
    builder.addCase(screenerEffects.getScreenerFavorites.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data;
        if (!data) {
            state.screenerFavorites.isError = true;
        } else {
            state.screenerFavorites.data = data;
            state.screenerFavorites.message = message;
        }
        state.screenerFavorites.isLoading = false;
    }).addCase(screenerEffects.getScreenerFavorites.pending, function(state) {
        state.screenerFavorites.isLoading = true;
    }).addCase(screenerEffects.getScreenerFavorites.rejected, function(state, action) {
        state.screenerFavorites.isError = action.payload.isError;
        state.screenerFavorites.isLoading = false;
    }).addCase(screenerEffects.getScreenerPreset.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data;
        if (!data) {
            state.screenerPreset.isError = true;
        } else {
            state.screenerPreset.data = data;
            state.screenerPreset.message = message;
        }
        state.screenerPreset.isLoading = false;
    }).addCase(screenerEffects.getScreenerPreset.pending, function(state) {
        state.screenerPreset.isLoading = true;
    }).addCase(screenerEffects.getScreenerPreset.rejected, function(state, action) {
        state.screenerPreset.isError = action.payload.isError;
        state.screenerPreset.isLoading = false;
    }).addCase(screenerEffects.addFavorite.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data;
        var _screenerFavorites = state.screenerFavorites, baseFavorite = _screenerFavorites.data;
        if (!data) {
            state.addFavoriteScreenerResult.isError = true;
        } else {
            var result = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(baseFavorite).concat([
                data
            ]);
            state.screenerFavorites.data = result;
            state.addFavoriteScreenerResult.message = message;
        }
        state.addFavoriteScreenerResult.isLoading = false;
    }).addCase(screenerEffects.addFavorite.pending, function(state) {
        state.addFavoriteScreenerResult.isLoading = true;
    }).addCase(screenerEffects.addFavorite.rejected, function(state, action) {
        state.addFavoriteScreenerResult.isError = action.payload.isError;
        state.addFavoriteScreenerResult.isLoading = false;
    }).addCase(screenerEffects.removeFavorite.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, obsoleteData = _payload.data;
        var _screenerFavorites = state.screenerFavorites, baseFavorite = _screenerFavorites.data;
        if (!obsoleteData) {
            state.removeFavoriteScreenerResult.isError = true;
        } else {
            var IDRemove = obsoleteData;
            var result = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(baseFavorite).filter(function(favoritesScreener) {
                return favoritesScreener.id !== IDRemove;
            });
            state.screenerFavorites.data = result;
            state.removeFavoriteScreenerResult.message = message;
        }
        state.removeFavoriteScreenerResult.isLoading = false;
    }).addCase(screenerEffects.removeFavorite.pending, function(state) {
        state.removeFavoriteScreenerResult.isLoading = true;
    }).addCase(screenerEffects.removeFavorite.rejected, function(state, action) {
        state.removeFavoriteScreenerResult.isError = action.payload.isError;
        state.removeFavoriteScreenerResult.isLoading = false;
    }).addCase(screenerEffects.getScreenerUniverse.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data;
        if (!data) {
            state.screenerUniverse.isError = true;
        } else {
            state.screenerUniverse.data = data;
            state.screenerUniverse.message = message;
        }
        state.screenerUniverse.isLoading = false;
    }).addCase(screenerEffects.getScreenerUniverse.pending, function(state) {
        state.screenerUniverse.isLoading = true;
    }).addCase(screenerEffects.getScreenerUniverse.rejected, function(state, action) {
        state.screenerUniverse.isError = action.payload.isError;
        state.screenerUniverse.isLoading = false;
    }).addCase(screenerEffects.getScreenerFinancialMetric.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data;
        if (!data) {
            state.screenerFinancialMetric.isError = true;
        } else {
            state.screenerFinancialMetric.data = data;
            state.screenerFinancialMetric.message = message;
        }
        state.screenerFinancialMetric.isLoading = false;
    }).addCase(screenerEffects.getScreenerFinancialMetric.pending, function(state) {
        state.screenerFinancialMetric.isLoading = true;
    }).addCase(screenerEffects.getScreenerFinancialMetric.rejected, function(state, action) {
        state.screenerFinancialMetric.isError = action.payload.isError;
        state.screenerFinancialMetric.isLoading = false;
    }).addCase(screenerEffects.postScreener.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data, fromForm = _payload.fromForm;
        var arg = action.meta.arg;
        if (!data) {
            state.screenerPostResult.isError = true;
        } else {
            state.screenerPostResult.data = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, state.screenerPostResult.data, data);
            // Sync ScreenerForm state after submitting form
            // use case for `rules`, etc.
            if (fromForm) {
                var screenerid = data.screenerid, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(data, [
                    "screenerid"
                ]);
                state.screenerResult.data = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, state.screenerResult.data, rest), {
                    screenerid: arg.save === "1" ? screenerid : state.screenerResult.data.screenerid
                });
            }
            state.screenerPostResult.message = message;
            state.screenerUtils.isFormCreateMode = false;
        }
        state.screenerPostResult.isLoading = false;
    }).addCase(screenerEffects.postScreener.pending, function(state) {
        state.screenerPostResult.isLoading = true;
        state.screenerUtils.screenerAction = "post";
        state.screenerUtils.isEmptyResult = false;
    }).addCase(screenerEffects.postScreener.rejected, function(state, action) {
        state.screenerPostResult.isError = action.payload.isError;
        state.screenerPostResult.isLoading = false;
        state.screenerUtils.isEmptyResult = true;
    }).addCase(screenerEffects.getScreener.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data;
        if (!data) {
            state.screenerResult.isError = true;
        } else {
            var screenerid = data.screenerid, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(data, [
                "screenerid"
            ]);
            state.screenerResult.data = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, state.screenerResult.data, rest), {
                screenerid: rest.isguru ? 0 : screenerid
            });
            state.screenerPostResult.data = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, state.screenerPostResult.data, rest), {
                screenerid: screenerid
            });
            state.screenerResult.message = message;
        }
        state.screenerResult.isLoading = false;
    }).addCase(screenerEffects.getScreener.pending, function(state) {
        state.screenerResult.isLoading = true;
        state.screenerPostResult.data = {};
        state.screenerUtils.screenerAction = "get";
        state.screenerUtils.isEmptyResult = false;
    }).addCase(screenerEffects.getScreener.rejected, function(state, action) {
        state.screenerResult.isError = action.payload.isError;
        state.screenerResult.isLoading = false;
        state.screenerUtils.isEmptyResult = true;
    }).addCase(screenerEffects.getScreenerCustom.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data;
        if (!data) {
            state.screenerCustom.isError = true;
        } else {
            state.screenerCustom.data = data;
            state.screenerCustom.message = message;
        }
        state.screenerCustom.isLoading = false;
    }).addCase(screenerEffects.getScreenerCustom.pending, function(state) {
        state.screenerCustom.isLoading = true;
    }).addCase(screenerEffects.getScreenerCustom.rejected, function(state, action) {
        state.screenerCustom.isError = action.payload.isError;
        state.screenerCustom.isLoading = false;
        state.screenerUtils.isEmptyResult = true;
    }).addCase(screenerEffects.removeScreenerCustom.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data;
        if (!data) {
            state.removeCustomScreenerResult.isError = true;
        } else {
            state.removeCustomScreenerResult.data = data;
            state.removeCustomScreenerResult.message = message;
        }
        state.removeCustomScreenerResult.isLoading = false;
    }).addCase(screenerEffects.removeScreenerCustom.pending, function(state) {
        state.removeCustomScreenerResult.isLoading = true;
    }).addCase(screenerEffects.removeScreenerCustom.rejected, function(state, action) {
        state.removeCustomScreenerResult.isError = action.payload.isError;
        state.removeCustomScreenerResult.isLoading = false;
    });
};
var screenerSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createSlice */ .oM)({
    name: "screener",
    initialState: initialState,
    // for non-async reducer logic
    reducers: reducers,
    // for async reducer logic
    extraReducers: extraReducer
});
/* harmony default export */ __webpack_exports__["ZP"] = (screenerSlice);


/***/ }),

/***/ 21455:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TradingContext */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var TradingContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
    tradingStore: null
});
/* harmony default export */ __webpack_exports__["Z"] = (TradingContext);


/***/ }),

/***/ 207:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ provider; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
;// CONCATENATED MODULE: ./src/features/transaction/store.ts



var initialState = {
    openModal: "",
    symbol: null,
    orderType: null,
    formType: null,
    openFromWidget: false
};
var tradingStore = function() {
    return (0,esm/* default */.ZP)(function(set) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, initialState), {
            setModal: function(modal, payload) {
                set((0,_object_spread/* default */.Z)({
                    openModal: modal
                }, payload));
            },
            resetModal: function() {
                set(initialState);
            },
            setSymbol: function(symbol) {
                set({
                    symbol: symbol
                });
            },
            setOrderType: function(type) {
                set({
                    orderType: type
                });
            },
            setFormType: function(type) {
                set({
                    formType: type
                });
            },
            setOpenFromWidget: function(open) {
                set({
                    openFromWidget: open
                });
            },
            setAutoOrderId: function(autoOrderId) {
                set({
                    autoOrderId: autoOrderId
                });
            }
        });
    });
};
/* harmony default export */ var store = (tradingStore);

// EXTERNAL MODULE: ./src/features/transaction/context.tsx
var context = __webpack_require__(21455);
;// CONCATENATED MODULE: ./src/features/transaction/provider.tsx




var TradingContextProvider = function(param) {
    var children = param.children;
    var formValuesContext = (0,react.useMemo)(function() {
        return {
            tradingStore: store()
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(context/* default.Provider */.Z.Provider, {
        value: formValuesContext,
        children: children
    });
};
/* harmony default export */ var provider = (TradingContextProvider);


/***/ }),

/***/ 25516:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ AlertErrorMessage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/antd/es/message/index.js + 1 modules
var message = __webpack_require__(12461);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Iconmoon.js
var Iconmoon = __webpack_require__(15807);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
// EXTERNAL MODULE: ./src/constants/app.js
var app = __webpack_require__(86123);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/global/AlertErrorMessage/styled.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  border-radius: 50%;\n  margin-right: 10px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var IconWrapper = (0,styled_components_browser_esm/* default */.ZP)(Iconmoon/* IconWrapper */.a).withConfig({
    componentId: "sc-1624a33f-0"
})(_templateObject(), color/* default.primary */.Z.primary);
// eslint-disable-next-line import/prefer-default-export


;// CONCATENATED MODULE: ./src/global/AlertErrorMessage/index.js
/* eslint-disable max-len */ 







/**
 * handleErrorMessageAPI to activate message
 * @param {string} content
 * @param {string} type - "alert-green" | "alert-red" | "alert-orange" | "alert-blue" | "snackbar-green" | "plain-green"
 * @param {=boolean} hasCloseIcon
 */ var handleErrorMessageAPI = function(content, type) {
    var hasCloseIcon = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (!(0,app/* isClient */.C5)()) return null;
    // destroy last message alert
    message/* default.destroy */.ZP.destroy();
    var Icon = null;
    var closeIcon = hasCloseIcon ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
        src: "/icon/alert-close.svg",
        onClick: function() {
            return message/* default.destroy */.ZP.destroy();
        }
    }) : null;
    if (type === "alert-green") {
        Icon = /*#__PURE__*/ (0,jsx_runtime.jsx)(IconWrapper, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* default */.Z, {
                size: "14px",
                className: "icon-toolbar_check",
                color: color/* default.light */.Z.light
            })
        });
    } else if (type === "snackbar-green") {
        Icon = /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
            src: "/icon/alert-success.svg"
        });
    }
    // show alert
    message/* default.open */.ZP.open({
        content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: type,
            "data-cy": "global-alert-message",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                align: "center",
                children: [
                    Icon,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: content
                    }),
                    closeIcon
                ]
            })
        }),
        duration: 3,
        style: {
            top: "50px",
            fontFamily: "ProximaNovaRg",
            left: 0,
            margin: "auto",
            position: "fixed",
            right: 0,
            maxWidth: "320px"
        },
        className: "sysmsg-content",
        onClick: function() {
            return message/* default.destroy */.ZP.destroy();
        }
    });
    return null;
};
/* harmony default export */ var AlertErrorMessage = (handleErrorMessageAPI);


/***/ }),

/***/ 29658:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var If = function(param) {
    var children = param.children, condition = param.condition;
    if (!condition) {
        return null;
    }
    // render children if the condition is truthy
    return children;
};
/* harmony default export */ __webpack_exports__["Z"] = (If); /**
 * https://www.stefanjudis.com/snippets/a-react-if-component/
 *
 * Use the component as follows:
 *
 * <IF condition={condition}>
 *   <Greeter username={user.name} />
 * </IF>
 */ 


/***/ }),

/***/ 579:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var constants_app__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86123);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);





var Image = function(_param) {
    var src = _param.src, _alt = _param.alt, alt = _alt === void 0 ? "" : _alt, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "src",
        "alt"
    ]);
    var source = src || "";
    var isBlob = source.startsWith("blob:");
    var isBase64 = source.startsWith("data:");
    var isUrl = source.startsWith("http") || source.startsWith("//");
    if (source && !isUrl && !isBlob && !isBase64) {
        var separator = source.startsWith("/") ? "" : "/";
        source = "".concat(constants_app__WEBPACK_IMPORTED_MODULE_1__/* .assetPrefix */ .Vc).concat(separator).concat(source);
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        src: source,
        alt: alt
    }, rest));
};
Image.defaultProps = {
    alt: ""
};
Image.propTypes = {
    src: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string.isRequired),
    alt: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string)
};
/* harmony default export */ __webpack_exports__["Z"] = (Image);


/***/ }),

/***/ 598:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Loading_PageLoader; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/global/ErrorHandlers/If.js
var If = __webpack_require__(29658);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/global/Loading/styled.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      opacity: 0;\n      visibility: hidden;\n      z-index: 1;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  background: white;\n  display: flex;\n  height: 100%;\n  justify-content: center;\n  left: 0;\n  opacity: 1;\n  position: fixed;\n  top: 0;\n  transition: all 0.3s ease-in-out;\n  visibility: visible;\n  width: 100%;\n  z-index: 1050;\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 16px;\n  height: 16px;\n  background-color: #333;\n  margin: 0 5px;\n  border-radius: 100%;\n  display: inline-block;\n  -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;\n  animation: sk-bouncedelay 1.4s infinite ease-in-out both;\n  transform-origin: center center;\n\n  &:first-child {\n    -webkit-animation-delay: -0.32s;\n    animation-delay: -0.32s;\n  }\n\n  &:nth-child(2) {\n    -webkit-animation-delay: -0.16s;\n    animation-delay: -0.16s;\n  }\n\n  @-webkit-keyframes sk-bouncedelay {\n    0%,\n    80%,\n    100% {\n      -webkit-transform: scale(0);\n    }\n    40% {\n      -webkit-transform: scale(1);\n    }\n  }\n\n  @keyframes sk-bouncedelay {\n    0%,\n    80%,\n    100% {\n      -webkit-transform: scale(0);\n      transform: scale(0);\n    }\n    40% {\n      -webkit-transform: scale(1);\n      transform: scale(1);\n    }\n  }\n\n  @-webkit-keyframes sk-bouncedelay {\n    0%,\n    80%,\n    100% {\n      -webkit-transform: scale(0);\n    }\n    40% {\n      -webkit-transform: scale(1);\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var LoadingWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-372f28a1-0"
})(_templateObject1(), function(param) {
    var loaded = param.loaded;
    return loaded && (0,styled_components_browser_esm/* css */.iv)(_templateObject());
});
var Bouncer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-372f28a1-1"
})(_templateObject2());


;// CONCATENATED MODULE: ./src/global/Loading/Bouncer.tsx





var Bouncer_Bouncer = function(param) {
    var _isLoading = param.isLoading, isLoading = _isLoading === void 0 ? true : _isLoading;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
        condition: isLoading,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bouncer, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bouncer, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bouncer, {})
            ]
        })
    });
};
/* harmony default export */ var Loading_Bouncer = (Bouncer_Bouncer);

;// CONCATENATED MODULE: ./src/global/Loading/PageLoader.jsx





function PageLoader(param) {
    var loaded = param.loaded;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingWrapper, {
        loaded: loaded,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading_Bouncer, {})
    });
}
PageLoader.propTypes = {
    loaded: (prop_types_default()).bool
};
PageLoader.defaultProps = {
    loaded: false
};
// always re-render (event no visual visiblity) => need memo
/* harmony default export */ var Loading_PageLoader = (/*#__PURE__*/react.memo(PageLoader));


/***/ }),

/***/ 32253:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var global_ErrorHandlers_If__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29658);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  min-width: 100px;\n  min-height: 100px;\n  position: relative;\n\n  @keyframes spinner {\n    to {\n      transform: rotate(360deg);\n    }\n  }\n\n  &::before {\n    content: 'Loading…';\n    position: absolute;\n    top: calc(50% - 15px);\n    left: calc(50% - 15px);\n    width: 30px;\n    height: 30px;\n    margin-top: 0;\n    margin-left: 0;\n    content: '';\n    border-radius: 50%;\n    border-top: 4px solid #00ab6b;\n    border-right: 4px solid transparent;\n    animation: 0.7s linear infinite spinner;\n    -webkit-animation: 0.7s linear infinite spinner;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var PrimarySpinnerDiv = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-717be61e-0"
})(_templateObject(), function(param) {
    var overlay = param.overlay, isDarkOverlay = param.isDarkOverlay;
    return overlay && "\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    z-index: 100;\n    background: ".concat(isDarkOverlay ? "rgba(0,0,0,.5)" : "rgba(255,255,255,.85)", ";\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n  ");
});
var PrimarySpinner = function(_param) {
    var overlay = _param.overlay, _isLoading = _param.isLoading, isLoading = _isLoading === void 0 ? true : _isLoading, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "overlay",
        "isLoading"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_ErrorHandlers_If__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        condition: isLoading,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(PrimarySpinnerDiv, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            "data-cy": "primary-spinner",
            overlay: overlay
        }, props))
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PrimarySpinner);


/***/ }),

/***/ 53120:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ global_MainLayout; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 17 modules
var es = __webpack_require__(2497);
// EXTERNAL MODULE: ./node_modules/antd/lib/grid/hooks/useBreakpoint.js
var useBreakpoint = __webpack_require__(60872);
// EXTERNAL MODULE: ./src/features/onboarding/constants.ts
var constants = __webpack_require__(60602);
// EXTERNAL MODULE: ./src/lib/entities/profile.js + 2 modules
var profile = __webpack_require__(333);
;// CONCATENATED MODULE: ./src/hooks/useOnBoarding.ts




function useOnBoarding() {
    var ref = (0,react.useState)(Infinity), onboardingProgress = ref[0], setOnboardingProgress = ref[1];
    var ref1 = (0,es/* useSelector */.v9)(profile/* selectors */.wl), dataProfile = ref1.data;
    var progress = dataProfile.onboarding, statusOnboarding = dataProfile.onboarding_done;
    (0,react.useEffect)(function() {
        // redirect only if data profile is available
        if (dataProfile.id && statusOnboarding == 0 && progress <= constants/* ONBOARDING_MAX_STEP */.Rm) {
            setOnboardingProgress(progress);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        progress,
        statusOnboarding,
        dataProfile
    ]);
    return {
        onboardingProgress: onboardingProgress
    };
}
/* harmony default export */ var hooks_useOnBoarding = (useOnBoarding);

// EXTERNAL MODULE: ./src/lib/entities/credentials.js + 4 modules
var credentials = __webpack_require__(21671);
// EXTERNAL MODULE: ./src/hooks/useProfileData.ts
var useProfileData = __webpack_require__(30995);
// EXTERNAL MODULE: ./src/hooks/useNotificationListener.ts
var useNotificationListener = __webpack_require__(91364);
// EXTERNAL MODULE: ./src/features/edit-profile/slice.ts
var slice = __webpack_require__(40927);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./node_modules/immer/dist/immer.esm.mjs
var immer_esm = __webpack_require__(12902);
// EXTERNAL MODULE: ./src/global/Notification/index.tsx + 1 modules
var Notification = __webpack_require__(77667);
// EXTERNAL MODULE: ./src/features/chat/MainContent/useScrollChat.ts
var useScrollChat = __webpack_require__(4881);
// EXTERNAL MODULE: ./src/features/chat/store/index.ts + 7 modules
var store = __webpack_require__(77284);
// EXTERNAL MODULE: ./src/global/WebSocketV2/slice.ts + 1 modules
var WebSocketV2_slice = __webpack_require__(66250);
// EXTERNAL MODULE: ./src/lib/entities/chat/slice.ts
var chat_slice = __webpack_require__(10707);
// EXTERNAL MODULE: ./src/features/chat/constant.ts
var constant = __webpack_require__(52288);
// EXTERNAL MODULE: ./src/stores/chat/index.ts + 2 modules
var chat = __webpack_require__(50490);
// EXTERNAL MODULE: ./src/features/chat/utils.ts
var utils = __webpack_require__(33037);
// EXTERNAL MODULE: ./node_modules/sanitize-html/index.js
var sanitize_html = __webpack_require__(91036);
var sanitize_html_default = /*#__PURE__*/__webpack_require__.n(sanitize_html);
;// CONCATENATED MODULE: ./src/utils/socketSocial.ts



var transformToNotifMessage = function(rawText, type) {
    var text = sanitize_html_default()(rawText);
    var _obj;
    var attachmentContentMapper = (_obj = {}, (0,_define_property/* default */.Z)(_obj, constant/* ATTACHMENT_TYPE.ATTACHMENT_TYPE_PHOTO */.G0.ATTACHMENT_TYPE_PHOTO, " *IMAGE*"), (0,_define_property/* default */.Z)(_obj, constant/* ATTACHMENT_TYPE.ATTACHMENT_TYPE_GIF */.G0.ATTACHMENT_TYPE_GIF, " *GIF*"), (0,_define_property/* default */.Z)(_obj, constant/* ATTACHMENT_TYPE.ATTACHMENT_TYPE_POST */.G0.ATTACHMENT_TYPE_POST, " *POST*"), (0,_define_property/* default */.Z)(_obj, constant/* ATTACHMENT_TYPE.ATTACHMENT_TYPE_STICKER */.G0.ATTACHMENT_TYPE_STICKER, " *STICKER*"), (0,_define_property/* default */.Z)(_obj, constant/* ATTACHMENT_TYPE.ATTACHMENT_TYPE_PDF */.G0.ATTACHMENT_TYPE_PDF, ""), (0,_define_property/* default */.Z)(_obj, constant/* ATTACHMENT_TYPE.ATTACHMENT_TYPE_UNSPECIFIED */.G0.ATTACHMENT_TYPE_UNSPECIFIED, ""), (0,_define_property/* default */.Z)(_obj, constant/* ATTACHMENT_TYPE.ATTACHMENT_TYPE_SHARETRADE */.G0.ATTACHMENT_TYPE_SHARETRADE, ""), _obj);
    text += attachmentContentMapper[type];
    return text;
};


;// CONCATENATED MODULE: ./src/hooks/useChatListenerWsSocialV2.ts
/* eslint-disable eqeqeq */ /* eslint-disable no-undef */ 



















var checkMessageDuplicated = function(messages, newRoomId, lastMessageId) {
    if (messages[newRoomId]) {
        var ref;
        return (ref = messages[newRoomId]) === null || ref === void 0 ? void 0 : ref.messages.some(function(chat) {
            return chat.id === lastMessageId;
        });
    }
    return false;
};
var checkMissingObjectText = function(body) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
    var chatMessageV1 = body === null || body === void 0 ? void 0 : (ref = body.event) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.chatMessage) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[constant/* WS_SOCIAL_VERSION */.fO]) === null || ref3 === void 0 ? void 0 : ref3.message;
    var valueText = (chatMessageV1 === null || chatMessageV1 === void 0 ? void 0 : (ref4 = chatMessageV1.body) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.conversation) === null || ref5 === void 0 ? void 0 : ref5.text) ? chatMessageV1 === null || chatMessageV1 === void 0 ? void 0 : (ref6 = chatMessageV1.body) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.conversation) === null || ref7 === void 0 ? void 0 : ref7.text : "";
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, chatMessageV1), {
        text: valueText,
        body: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, chatMessageV1.body), {
            conversation: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, chatMessageV1 === null || chatMessageV1 === void 0 ? void 0 : (ref8 = chatMessageV1.body) === null || ref8 === void 0 ? void 0 : ref8.conversation), {
                text: valueText,
                attachmentType: (chatMessageV1 === null || chatMessageV1 === void 0 ? void 0 : (ref9 = chatMessageV1.body) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.conversation) === null || ref10 === void 0 ? void 0 : ref10.attachmentType) || constant/* ATTACHMENT_TYPE.ATTACHMENT_TYPE_UNSPECIFIED */.G0.ATTACHMENT_TYPE_UNSPECIFIED
            })
        })
    });
};
var handleRefreshGroupRoom = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(chatId) {
        var hasRoomDetail, ref, groupId;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return store/* roomDetailStore.getState */.e.getState().refreshGroupRoomDetail(chatId);
                case 2:
                    hasRoomDetail = _ctx.sent;
                    if (!hasRoomDetail) {
                        _ctx.next = 9;
                        break;
                    }
                    ;
                    groupId = (ref = store/* roomDetailStore.getState */.e.getState().group[chatId]) === null || ref === void 0 ? void 0 : ref.id;
                    _ctx.next = 8;
                    return store/* groupMemberStore.getState */.VY.getState().fetchGroupMember(groupId, 0);
                case 8:
                    chat/* default.setState */.Z.setState((0,immer_esm/* default */.ZP)(function(state) {
                        state.conversation.isLoading = false;
                    }));
                case 9:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function handleRefreshGroupRoom(chatId) {
        return _ref.apply(this, arguments);
    };
}();
function useChatListenerWsSocialV2() {
    var isUserLogin = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var dispatch = (0,es/* useDispatch */.I0)();
    var activeRoomId = (0,es/* useSelector */.v9)(chat_slice/* selectors */.wl).activeRoomId;
    var ref = (0,es/* useSelector */.v9)(slice/* selectors */.wl), _notifications = ref.notifications, notif = _notifications.data;
    var ref1 = (0,es/* useSelector */.v9)(profile/* selectors */.wl), dataLoggedInUser = ref1.data;
    var newIncomingChatWsSocialV2 = (0,es/* useSelector */.v9)(WebSocketV2_slice/* chatWsSocialV2Selector */.WM);
    var messages = (0,chat/* default */.Z)(function(store) {
        return store.conversation.messages;
    });
    var defaultRooms = (0,chat/* default */.Z)(function(store) {
        return store.rooms.default.list;
    });
    var invitedRooms = (0,chat/* default */.Z)(function(store) {
        return store.rooms.invited.list;
    });
    var updateRoomListFromWS = (0,chat/* default */.Z)(function(store) {
        return store.updateRoomListFromWS;
    });
    var pushMessage = (0,chat/* default */.Z)(function(store) {
        return store.pushMessage;
    });
    var updateMessageFromWS = (0,chat/* default */.Z)(function(store) {
        return store.updateMessageFromWS;
    });
    var scrollToBottom = (0,useScrollChat/* default */.Z)().scrollToBottom;
    var actionChatRoom = function(incomingChat) {
        if (activeRoomId > 0) {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17;
            var body = incomingChat.body;
            var newMessage = checkMissingObjectText(body);
            var newRoom = body === null || body === void 0 ? void 0 : (ref = body.event) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.chatMessage) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[constant/* WS_SOCIAL_VERSION */.fO]) === null || ref3 === void 0 ? void 0 : ref3.room;
            var referenceId = body === null || body === void 0 ? void 0 : (ref4 = body.event) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.data) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.chatMessage) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[constant/* WS_SOCIAL_VERSION */.fO]) === null || ref7 === void 0 ? void 0 : ref7.referenceId;
            var roomStatus = body === null || body === void 0 ? void 0 : (ref8 = body.event) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.data) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.chatMessage) === null || ref10 === void 0 ? void 0 : (ref11 = ref10[constant/* WS_SOCIAL_VERSION */.fO]) === null || ref11 === void 0 ? void 0 : ref11.roomStatus;
            newMessage = (0,utils/* snakelizeKeys */.t_)(newMessage);
            newRoom = (0,utils/* snakelizeKeys */.t_)(newRoom);
            var isDuplicated = messages ? checkMessageDuplicated(messages, newRoom === null || newRoom === void 0 ? void 0 : newRoom.id, newMessage === null || newMessage === void 0 ? void 0 : newMessage.id) : false;
            // Check if the event comes when user leave
            var isStateUnspecified = (newRoom === null || newRoom === void 0 ? void 0 : newRoom.state) === constant/* StateChatList.ROOM_STATE_UNSPECIFIED */.Kn.ROOM_STATE_UNSPECIFIED;
            var isDeletedEvent = (newMessage === null || newMessage === void 0 ? void 0 : (ref12 = newMessage.body) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.conversation) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.flag) === null || ref14 === void 0 ? void 0 : ref14.is_deleted) ? newMessage === null || newMessage === void 0 ? void 0 : (ref15 = newMessage.body) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.conversation) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.flag) === null || ref17 === void 0 ? void 0 : ref17.is_deleted : false;
            if (!isDuplicated && !isStateUnspecified && !isDeletedEvent) {
                var ref18, ref19, ref20, ref21, ref22;
                var chatId = newRoom.id;
                // push message to state;
                pushMessage({
                    chatId: chatId,
                    message: newMessage,
                    reference_id: referenceId,
                    room_status: roomStatus,
                    room: newRoom
                });
                // scroll to bottom if in current active chat is receive new message
                var isChatPageShowed = router_default().asPath.includes("/chat/".concat(chatId)) || router_default().asPath.includes("/group-chat/".concat(chatId)) || router_default().asPath.includes("/broadcast-chat/".concat(chatId));
                var senderUserData = newMessage === null || newMessage === void 0 ? void 0 : (ref18 = newMessage.body) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.conversation) === null || ref19 === void 0 ? void 0 : (ref20 = ref19.sender) === null || ref20 === void 0 ? void 0 : ref20.user;
                var senderUserName = senderUserData && senderUserData.username ? senderUserData.username : "";
                var isReceiver = senderUserName !== dataLoggedInUser.username;
                if (isChatPageShowed) {
                    var container = document.getElementById("chat-content-container");
                    var currentPos = container.scrollHeight - container.clientHeight - 200;
                    var currentlyScrollingUp = container.scrollTop < currentPos;
                    // when there is incoming message on receiver side, that is currently scrolling up
                    // don't scroll to bottom
                    if (isReceiver && !currentlyScrollingUp || !isReceiver) {
                        scrollToBottom();
                    }
                }
                // Handle event type message from ws in group chat
                // will refresh the room detail and member list
                var isCurrentPage = router_default().asPath.includes("/group-chat/".concat(chatId));
                var isEventMessage = (newMessage === null || newMessage === void 0 ? void 0 : newMessage.body_type) === constant/* MESSAGE_BODY_TYPE.MESSAGE_BODY_TYPE_EVENT */.dn.MESSAGE_BODY_TYPE_EVENT;
                var isNotLeaveEvent = ((newMessage === null || newMessage === void 0 ? void 0 : (ref21 = newMessage.body) === null || ref21 === void 0 ? void 0 : (ref22 = ref21.event) === null || ref22 === void 0 ? void 0 : ref22.text) || "").toLowerCase() !== "you left";
                if (isCurrentPage && isEventMessage && isNotLeaveEvent) {
                    handleRefreshGroupRoom(chatId);
                }
            } else {
                // update message if id has available on convo,
                updateMessageFromWS({
                    chatId: newRoom.id,
                    messageId: newMessage.id,
                    message: newMessage
                });
            }
        }
    };
    var actionRoomList = function(incomingChat) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
        var body = incomingChat.body;
        var newRoom = body === null || body === void 0 ? void 0 : (ref = body.event) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.chatRoomInfo) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[constant/* WS_SOCIAL_VERSION */.fO]) === null || ref3 === void 0 ? void 0 : ref3.room;
        newRoom = (0,utils/* snakelizeKeys */.t_)(newRoom);
        var messageId = newRoom === null || newRoom === void 0 ? void 0 : (ref4 = newRoom.last_message) === null || ref4 === void 0 ? void 0 : ref4.id;
        var isAccepted = (newRoom === null || newRoom === void 0 ? void 0 : newRoom.state) === constant/* StateChatList.ROOM_STATE_ACCEPTED */.Kn.ROOM_STATE_ACCEPTED;
        var isPersonalChat = (newRoom === null || newRoom === void 0 ? void 0 : newRoom.type) === constant/* RoomTypeFromPayload.PERSONAL */._2.PERSONAL;
        var isBroadcast = // TODO: remove 3
        // While waiting for proto definition encoding is done,
        // we use number 3 as broadcast type,
        // Currently, BE is sending 3 instead of ROOM_TYPE_BROADCAST
        (newRoom === null || newRoom === void 0 ? void 0 : newRoom.type) === constant/* RoomTypeFromPayload.BROADCAST */._2.BROADCAST;
        var roomList = isAccepted ? defaultRooms : invitedRooms;
        var lastMessage = (0,immer_esm/* default */.ZP)(newRoom === null || newRoom === void 0 ? void 0 : newRoom.last_message, function(draft) {
            var ref, ref1, ref2, ref3;
            draft.text = (newRoom === null || newRoom === void 0 ? void 0 : (ref = newRoom.last_message) === null || ref === void 0 ? void 0 : ref.text) ? newRoom.last_message.text : "";
            draft.sender_username = ((ref1 = newRoom.last_message) === null || ref1 === void 0 ? void 0 : ref1.sender_username) || "";
            // Replace last message if user delete their own latest chat
            if ((newRoom === null || newRoom === void 0 ? void 0 : (ref2 = newRoom.last_message) === null || ref2 === void 0 ? void 0 : ref2.text) === "This message was deleted" && ((ref3 = newRoom.last_message) === null || ref3 === void 0 ? void 0 : ref3.sender_username) === dataLoggedInUser.username) {
                draft.text = "You deleted this message";
                draft.placeholder_mask.masked_text = "You deleted this message";
            }
        });
        // ws social not send sender userId
        var senderUserName = lastMessage.sender_username;
        var isReceiver = senderUserName !== dataLoggedInUser.username;
        var isEventMessage = isPersonalChat || isBroadcast ? false : !senderUserName;
        var roomIdx = roomList.findIndex(function(item) {
            return item.id === (newRoom === null || newRoom === void 0 ? void 0 : newRoom.id);
        });
        var isDuplicated = messages ? checkMessageDuplicated(messages, newRoom === null || newRoom === void 0 ? void 0 : newRoom.id, newRoom === null || newRoom === void 0 ? void 0 : (ref5 = newRoom.last_message) === null || ref5 === void 0 ? void 0 : ref5.id) : false;
        // existing chatroom
        if (roomIdx > -1) {
            var ref8, ref9, ref10;
            var roomInfo = isPersonalChat || isBroadcast ? roomList[roomIdx].info : (0,_object_spread/* default */.Z)({
                avatar_url: (newRoom === null || newRoom === void 0 ? void 0 : (ref8 = newRoom.info) === null || ref8 === void 0 ? void 0 : ref8.avatar_url) || ""
            }, newRoom === null || newRoom === void 0 ? void 0 : newRoom.info);
            var updateLastMessage = isDuplicated ? ((ref10 = (ref9 = messages[newRoom === null || newRoom === void 0 ? void 0 : newRoom.id]) === null || ref9 === void 0 ? void 0 : ref9.messages[0]) === null || ref10 === void 0 ? void 0 : ref10.id) === messageId : true;
            lastMessage = updateLastMessage ? lastMessage : roomList[roomIdx].last_message;
            var unreadCount = roomList[roomIdx].unread_count || 0;
            // counter unread count chat list
            if (!isEventMessage && isReceiver && !isDuplicated) {
                unreadCount = roomList[roomIdx].unread_count + 1;
            }
            newRoom = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, roomList[roomIdx]), {
                last_message: lastMessage,
                info: roomInfo,
                unread_count: unreadCount,
                status: newRoom === null || newRoom === void 0 ? void 0 : newRoom.status,
                isBroadcast: isBroadcast
            });
        } else {
            var unreadCount1 = 0;
            // counter unread count chat list
            if (!isEventMessage && isReceiver && !isDuplicated) {
                unreadCount1 += 1;
            }
            newRoom = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, newRoom), {
                unread_count: unreadCount1,
                isBroadcast: isBroadcast
            });
        }
        // wont update the room list if the event is us leaving
        if ((newRoom === null || newRoom === void 0 ? void 0 : (ref6 = newRoom.lastMessage) === null || ref6 === void 0 ? void 0 : ref6.text) !== "You left") {
            updateRoomListFromWS(newRoom);
        }
        // Show Left Bottom Push Notification
        var isInvitedChat = newRoom.state === constant/* StateChatList.ROOM_STATE_INVITED */.Kn.ROOM_STATE_INVITED;
        var isMuted = newRoom.status.isMuted || false;
        var getCurrentIncomingNotifType = (ref7 = (0,utils/* getNotifType */.K5)(newRoom)) === null || ref7 === void 0 ? void 0 : ref7.notifType;
        var incomingMessageDataNotifSetting = notif.find(function(notifGroup) {
            return notifGroup.group === constant/* NOTIF_GROUP_CHAT */.wS;
        }).notifications.find(function(notifItem) {
            return notifItem.type === getCurrentIncomingNotifType;
        });
        if (isReceiver && !isMuted && incomingMessageDataNotifSetting) {
            var isDesktopNotificationTurnOn = incomingMessageDataNotifSetting.settings.find(function(setting) {
                return setting.key === constant/* NOTIF_SETTING_KEY_DN */.gK;
            }).value;
            if (isDesktopNotificationTurnOn) {
                var ref11, ref12, ref13, ref14, ref15, ref16;
                var groupChatName = (newRoom === null || newRoom === void 0 ? void 0 : (ref11 = newRoom.info) === null || ref11 === void 0 ? void 0 : ref11.name) || "Group Chat";
                var usernameAtGroup = senderUserName ? "".concat(senderUserName, " @") : "";
                var notifTitle = newRoom.type === constant/* RoomTypeFromPayload.PERSONAL */._2.PERSONAL ? senderUserName : "".concat(usernameAtGroup, " ").concat(groupChatName);
                var lastMessageType = (lastMessage === null || lastMessage === void 0 ? void 0 : lastMessage.type) || constant/* ATTACHMENT_TYPE.ATTACHMENT_TYPE_UNSPECIFIED */.G0.ATTACHMENT_TYPE_UNSPECIFIED;
                (0,Notification/* showChatNotification */.Ac)({
                    title: notifTitle,
                    description: transformToNotifMessage(lastMessage.text, lastMessageType),
                    isDeactivate: (newRoom === null || newRoom === void 0 ? void 0 : (ref12 = newRoom.attributes) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.personal) === null || ref13 === void 0 ? void 0 : ref13.is_deactivated) || false,
                    name: (newRoom === null || newRoom === void 0 ? void 0 : (ref14 = newRoom.info) === null || ref14 === void 0 ? void 0 : ref14.name) || "",
                    shortName: (newRoom === null || newRoom === void 0 ? void 0 : (ref15 = newRoom.info) === null || ref15 === void 0 ? void 0 : ref15.shortened_name) || "",
                    type: (newRoom === null || newRoom === void 0 ? void 0 : newRoom.type) || constant/* RoomTypeFromPayload.PERSONAL */._2.PERSONAL,
                    avatar: (newRoom === null || newRoom === void 0 ? void 0 : (ref16 = newRoom.info) === null || ref16 === void 0 ? void 0 : ref16.avatar_url) || "",
                    id: (newRoom === null || newRoom === void 0 ? void 0 : newRoom.id) || 0,
                    key: "in-app-notification-".concat(newRoom === null || newRoom === void 0 ? void 0 : newRoom.id),
                    isPersonalChat: isPersonalChat,
                    isInvitedChat: isInvitedChat,
                    onClose: function() {
                        dispatch(WebSocketV2_slice/* default.actions.clearChat */.ZP.actions.clearChat());
                    }
                });
            }
        }
    };
    var _obj;
    var actionEventType = (_obj = {}, (0,_define_property/* default */.Z)(_obj, constant/* EVENT_TYPE_BROADCAST.TYPE_CHAT_MESSAGE */.aw.TYPE_CHAT_MESSAGE, function(incomingChat) {
        return actionChatRoom(incomingChat);
    }), (0,_define_property/* default */.Z)(_obj, constant/* EVENT_TYPE_BROADCAST.TYPE_CHAT_ROOM_INFO */.aw.TYPE_CHAT_ROOM_INFO, function(incomingChat) {
        return actionRoomList(incomingChat);
    }), _obj);
    var actionTypeBroadCast = function(incomingChat) {
        var ref, ref1;
        var incomingBodyEventType = incomingChat === null || incomingChat === void 0 ? void 0 : (ref = incomingChat.body) === null || ref === void 0 ? void 0 : (ref1 = ref.event) === null || ref1 === void 0 ? void 0 : ref1.type;
        return actionEventType[incomingBodyEventType] && actionEventType[incomingBodyEventType](incomingChat);
    };
    var chatListener = function(incomingChat) {
        if (incomingChat) {
            /* Additional information

        1. SEND MESSAGE
        When user send message to group room or personal room,
        ws will send event new messages as a sender so after
        that, we will update the slice conversations.

        2. OLD WEBSOCKET
        There is 3 version of WS, the old (M) that have been
        deprecated, the new (M2) and the latest one (M3).
        In this listener we will only use M3 as our WS event.
        To prevent doubled event sented to us, we use message.id
        as identifier to check if the message has been save in
        redux/slice or not.

        3. BODY TYPE OF EVENT
        Personal room and group room message now have same
        body payload. We dont need to transform the body.

       */ actionTypeBroadCast(incomingChat);
        }
    };
    (0,react.useEffect)(function() {
        if (!isUserLogin) {
            return;
        }
        // After check the behaviour, it more safe to use
        // synchronously process instead of asynchronous
        // when receive double events from ws
        // @ts-ignore
        chatListener(newIncomingChatWsSocialV2);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        newIncomingChatWsSocialV2,
        isUserLogin
    ]);
    return null;
}
/* harmony default export */ var hooks_useChatListenerWsSocialV2 = (useChatListenerWsSocialV2);

// EXTERNAL MODULE: ./src/features/community/hooks/useGetReferralInfo.ts
var useGetReferralInfo = __webpack_require__(37220);
// EXTERNAL MODULE: ./src/stores/chat/useGetChatUnreadCount.ts
var useGetChatUnreadCount = __webpack_require__(9986);
// EXTERNAL MODULE: ./src/features/transaction/provider.tsx + 1 modules
var provider = __webpack_require__(207);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/global/MainLayout/styled.ts
var styled = __webpack_require__(92589);
// EXTERNAL MODULE: ./src/global/MainLayout/slice.js
var MainLayout_slice = __webpack_require__(48153);
;// CONCATENATED MODULE: ./src/global/MainLayout/__tests__/constant.ts
var DATA_CY_MAIN_LAYOUT = "main-layout";

;// CONCATENATED MODULE: ./src/global/MainLayout/index.tsx
/* eslint-disable react/forbid-prop-types */ 










// Local Components








// import webSocketSlice from 'global/WebSocketV2/slice';

// local redux slice


var HeaderWeb = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2678), __webpack_require__.e(88069), __webpack_require__.e(92961), __webpack_require__.e(92077), __webpack_require__.e(42298), __webpack_require__.e(70659), __webpack_require__.e(75413), __webpack_require__.e(71682), __webpack_require__.e(63923), __webpack_require__.e(77934), __webpack_require__.e(50011), __webpack_require__.e(73671)]).then(__webpack_require__.bind(__webpack_require__, 73671));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(73671)
            ];
        }
    },
    ssr: false
});
var HeaderMobile = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2678), __webpack_require__.e(88069), __webpack_require__.e(92961), __webpack_require__.e(42298), __webpack_require__.e(70659), __webpack_require__.e(75413), __webpack_require__.e(71682), __webpack_require__.e(63923), __webpack_require__.e(77934), __webpack_require__.e(12127)]).then(__webpack_require__.bind(__webpack_require__, 12127));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(12127)
            ];
        }
    },
    ssr: false
});
var SideWidget = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(88069), __webpack_require__.e(50299), __webpack_require__.e(92961), __webpack_require__.e(33070), __webpack_require__.e(58928), __webpack_require__.e(92077), __webpack_require__.e(76750), __webpack_require__.e(79931), __webpack_require__.e(35851), __webpack_require__.e(46312), __webpack_require__.e(74749), __webpack_require__.e(6581), __webpack_require__.e(57437)]).then(__webpack_require__.bind(__webpack_require__, 69908));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(69908)
            ];
        }
    },
    ssr: false
});
var OnBoarding = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(88069), __webpack_require__.e(92961), __webpack_require__.e(29306), __webpack_require__.e(7475), __webpack_require__.e(54392), __webpack_require__.e(24826), __webpack_require__.e(91086)]).then(__webpack_require__.bind(__webpack_require__, 91086));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(91086)
            ];
        }
    },
    ssr: false
});
var ModalTransactionSecurities = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(60296), __webpack_require__.e(88069), __webpack_require__.e(50299), __webpack_require__.e(92961), __webpack_require__.e(33070), __webpack_require__.e(58928), __webpack_require__.e(92077), __webpack_require__.e(76750), __webpack_require__.e(79931), __webpack_require__.e(42298), __webpack_require__.e(35851), __webpack_require__.e(36055), __webpack_require__.e(67555), __webpack_require__.e(97751), __webpack_require__.e(80822), __webpack_require__.e(98294), __webpack_require__.e(76219), __webpack_require__.e(48761), __webpack_require__.e(54392), __webpack_require__.e(75413), __webpack_require__.e(71682), __webpack_require__.e(36902), __webpack_require__.e(48308), __webpack_require__.e(79624), __webpack_require__.e(91727), __webpack_require__.e(6684), __webpack_require__.e(10231), __webpack_require__.e(70536), __webpack_require__.e(12104), __webpack_require__.e(37376), __webpack_require__.e(18027), __webpack_require__.e(5411)]).then(__webpack_require__.bind(__webpack_require__, 39337));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(39337)
            ];
        }
    },
    ssr: false
});
var ModalAuthSecurities = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(33070), __webpack_require__.e(42298), __webpack_require__.e(61980), __webpack_require__.e(75413), __webpack_require__.e(36902), __webpack_require__.e(38305), __webpack_require__.e(62366), __webpack_require__.e(49432)]).then(__webpack_require__.bind(__webpack_require__, 62366));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(62366)
            ];
        }
    },
    ssr: false
});
var ModalShareTradeManager = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(88069), __webpack_require__.e(50299), __webpack_require__.e(92961), __webpack_require__.e(33070), __webpack_require__.e(58928), __webpack_require__.e(92077), __webpack_require__.e(76750), __webpack_require__.e(79931), __webpack_require__.e(42298), __webpack_require__.e(35851), __webpack_require__.e(36055), __webpack_require__.e(33082), __webpack_require__.e(67555), __webpack_require__.e(97751), __webpack_require__.e(98294), __webpack_require__.e(76219), __webpack_require__.e(75413), __webpack_require__.e(36902), __webpack_require__.e(48308), __webpack_require__.e(68106), __webpack_require__.e(20242), __webpack_require__.e(83474), __webpack_require__.e(65972)]).then(__webpack_require__.bind(__webpack_require__, 61785));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(61785)
            ];
        }
    },
    ssr: false
});
var GlobalModalManager = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(88069), __webpack_require__.e(50299), __webpack_require__.e(92961), __webpack_require__.e(33070), __webpack_require__.e(58928), __webpack_require__.e(92077), __webpack_require__.e(79931), __webpack_require__.e(42298), __webpack_require__.e(35851), __webpack_require__.e(33082), __webpack_require__.e(80822), __webpack_require__.e(1013), __webpack_require__.e(75413), __webpack_require__.e(74673), __webpack_require__.e(36902), __webpack_require__.e(10231), __webpack_require__.e(61442), __webpack_require__.e(88115), __webpack_require__.e(59795), __webpack_require__.e(21764)]).then(__webpack_require__.bind(__webpack_require__, 9159));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9159)
            ];
        }
    },
    ssr: false
});
var ModalBonds = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(88069), __webpack_require__.e(50299), __webpack_require__.e(92961), __webpack_require__.e(33070), __webpack_require__.e(92077), __webpack_require__.e(76750), __webpack_require__.e(42298), __webpack_require__.e(33082), __webpack_require__.e(80822), __webpack_require__.e(61980), __webpack_require__.e(98294), __webpack_require__.e(48761), __webpack_require__.e(36385), __webpack_require__.e(69733), __webpack_require__.e(54392), __webpack_require__.e(75413), __webpack_require__.e(71682), __webpack_require__.e(91727), __webpack_require__.e(29184), __webpack_require__.e(70536), __webpack_require__.e(33516)]).then(__webpack_require__.bind(__webpack_require__, 14426));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(14426)
            ];
        }
    },
    ssr: false
});
var ModalUnavailable = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(33070), __webpack_require__.e(12438)]).then(__webpack_require__.bind(__webpack_require__, 15994));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(15994)
            ];
        }
    },
    ssr: false
});
var ModalErrorManager = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(33070), __webpack_require__.e(92093)]).then(__webpack_require__.bind(__webpack_require__, 51906));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(51906)
            ];
        }
    },
    ssr: false
});
var MultiPortoModalManager = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(88069), __webpack_require__.e(92961), __webpack_require__.e(33070), __webpack_require__.e(92077), __webpack_require__.e(42298), __webpack_require__.e(98294), __webpack_require__.e(68606), __webpack_require__.e(44975)]).then(__webpack_require__.bind(__webpack_require__, 44975));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(44975)
            ];
        }
    },
    ssr: false
});
var StreamErrorModalManager = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(33070), __webpack_require__.e(61980), __webpack_require__.e(5633), __webpack_require__.e(38305), __webpack_require__.e(40728), __webpack_require__.e(29901)]).then(__webpack_require__.bind(__webpack_require__, 91011));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(91011)
            ];
        }
    },
    ssr: false
});
var DatafeedModalManager = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(33070), __webpack_require__.e(66158)]).then(__webpack_require__.bind(__webpack_require__, 44992));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(44992)
            ];
        }
    },
    ssr: false
});
function MainLayout(param) {
    var children = param.children, isFlexibleWidth = param.isFlexibleWidth, maxWidth = param.maxWidth, background = param.background, width = param.width, _fullPage = param.fullPage, fullPage = _fullPage === void 0 ? false : _fullPage;
    // Library hooks
    var dispatch = (0,es/* useDispatch */.I0)();
    var breakpoints = (0,useBreakpoint/* default */.Z)();
    // Zustand store
    var ref = (0,useGetChatUnreadCount/* useGetChatUnreadCount */.H)(function(s) {
        return {
            fetchChatUnreadCount: s.fetchUnreadCount,
            isChatUnreadCountReset: s.isReset
        };
    }), fetchChatUnreadCount = ref.fetchChatUnreadCount, isChatUnreadCountReset = ref.isChatUnreadCountReset;
    var fetchCommunityInfo = (0,useGetReferralInfo/* useGetReferralInfo */.s)(function(s) {
        return s.fetchCommunityInfo;
    });
    // Redux store
    var isLoggedIn = (0,es/* useSelector */.v9)(credentials/* selectors */.wl).isLoggedIn;
    var ref1 = (0,es/* useSelector */.v9)(MainLayout_slice/* selectors */.wl), isSideWidgetOpen = ref1.isSideWidgetOpen, isHeaderMinimized = ref1.isHeaderMinimized, isMarketOpen = ref1.isMarketOpen;
    // Custom hooks
    var onboardingProgress = hooks_useOnBoarding().onboardingProgress;
    (0,useProfileData/* default */.Z)();
    (0,useNotificationListener/* default */.Z)(isLoggedIn);
    hooks_useChatListenerWsSocialV2(isLoggedIn);
    // Reactive variable
    var isShowOnboarding = onboardingProgress < constants/* ONBOARDING_MAX_STEP */.Rm;
    var props = width ? {
        style: {
            width: width
        }
    } : {};
    (0,react.useEffect)(function() {
        if (!isLoggedIn) {
            return;
        }
        // During route changes or reload:
        // re-fetch unread chat if state is haven't reset
        // or clear chat data if state have reset
        // if (!isChatUnreadCountReset) {
        //   fetchChatUnreadCount();
        // } else {
        //   dispatch(webSocketSlice.actions.clearChat());
        // }
        fetchChatUnreadCount();
        fetchCommunityInfo();
        dispatch(slice/* effects.getNotifications */.Sz.getNotifications());
    }, [
        isLoggedIn
    ]);
    // React render
    if (isShowOnboarding) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(OnBoarding, {
            progress: onboardingProgress
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        "data-cy": DATA_CY_MAIN_LAYOUT,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(provider/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    justify: "space-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* WrapperMainContent */.UI, {
                            isSideWidgetOpen: isSideWidgetOpen,
                            isMarketOpen: isMarketOpen,
                            children: [
                                breakpoints.md ? /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderWeb, {
                                    isSideWidgetOpen: isSideWidgetOpen,
                                    isMarketOpen: isMarketOpen,
                                    isHeaderMinimized: isHeaderMinimized
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderMobile, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Wrapper */.im, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                    background: background,
                                    isSideWidgetOpen: isSideWidgetOpen
                                }, props), {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* default */.ZP, {
                                        id: "main-container",
                                        isFlexibleWidth: isFlexibleWidth,
                                        maxWidth: maxWidth,
                                        isSideWidgetOpen: isSideWidgetOpen,
                                        fullPage: fullPage,
                                        isMarketOpen: isMarketOpen,
                                        children: children
                                    })
                                }))
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SideWidget, {})
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalErrorManager, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalAuthSecurities, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalTransactionSecurities, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalModalManager, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBonds, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalShareTradeManager, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalUnavailable, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MultiPortoModalManager, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StreamErrorModalManager, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DatafeedModalManager, {})
            ]
        })
    });
}
MainLayout.propTypes = {
    children: (prop_types_default()).node.isRequired,
    isFlexibleWidth: (prop_types_default()).bool,
    maxWidth: (prop_types_default()).number,
    background: (prop_types_default()).string,
    width: (prop_types_default()).any
};
MainLayout.defaultProps = {
    isFlexibleWidth: false,
    maxWidth: undefined,
    background: "transparent",
    width: undefined
};
/* harmony default export */ var global_MainLayout = (MainLayout);


/***/ }),

/***/ 73580:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var zustand_vanilla__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59148);



var initialState = {
    errorCode: null,
    errorMessage: "",
    errorType: ""
};
var mainLayoutStore = (0,zustand_vanilla__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(set) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, initialState), {
        setErrorCode: function(code) {
            var message = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", type = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
            set({
                errorCode: code,
                errorMessage: message,
                errorType: type
            });
        },
        resetErrorCode: function() {
            set(initialState);
        }
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (mainLayoutStore);


/***/ }),

/***/ 92589:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RU": function() { return /* binding */ SIDE_WIDGET_OPENED_WIDTH; },
/* harmony export */   "U9": function() { return /* binding */ SIDE_WIDGET_CONTENT_WIDTH; },
/* harmony export */   "UI": function() { return /* binding */ WrapperMainContent; },
/* harmony export */   "Uh": function() { return /* binding */ device; },
/* harmony export */   "im": function() { return /* binding */ Wrapper; },
/* harmony export */   "zX": function() { return /* binding */ SIDE_WIDGET_TOOLBAR_WIDTH; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19521);
/* harmony import */ var _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74575);
/* eslint-disable space-infix-ops */ /* eslint-disable indent */ /* eslint-disable no-confusing-arrow */ 


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      @media ",
        " {\n        width: ",
        ";\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: 40px auto 0 auto;\n  padding: ",
        ";\n  width: 100%;\n  max-width: ",
        ";\n\n  &.chat-expanded {\n    margin: 0 auto 0 auto !important;\n    padding: 0 !important;\n  }\n\n  ",
        "\n\n  @media ",
        " {\n    margin: 100px auto 0;\n    max-width: ",
        ";\n\n    &.chat-expanded {\n      margin: 0px auto 0 auto !important;\n      padding: 20px 37px 0 0 !important;\n    }\n  }\n\n  @media ",
        " {\n    max-width: ",
        ";\n    &:has(#academy-iframe) {\n      position: absolute !important;\n      left: 0;\n      padding-bottom: 0;\n      width: 100% !important;\n      max-width: ",
        ";\n      margin: ",
        ";\n    }\n  }\n\n  @media screen and (min-width: 1500px) {\n    margin: 100px auto 0 auto;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: ",
        ";\n  width: 100%;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


// TODO: Update device dimension to DS
var laptopM = "(min-width:1081px)";
var device = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z), {
    laptopM: laptopM
});
var SIDE_WIDGET_CONTENT_WIDTH = "330px";
var SIDE_WIDGET_TOOLBAR_WIDTH = "35px";
var SIDE_WIDGET_OPENED_WIDTH = "365px";
// prettier-ignore
var Container = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].main.withConfig */ .ZP.main.withConfig({
    componentId: "sc-98894054-0"
})(_templateObject1(), function(props) {
    return props.fullPage ? "0" : "20px 0";
}, function(props) {
    return props.maxWidth ? "".concat(props.maxWidth, "px") : "990px";
}, function(props) {
    return props.isFlexibleWidth && (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject(), device.tablet, props.isMarketOpen ? "calc(100% - 60px)" : "calc(100% - 100px)");
}, device.tablet, function(props) {
    return props.maxWidth ? "".concat(props.maxWidth, "px") : "660px";
}, device.laptopM, function(props) {
    return props.maxWidth ? "".concat(props.maxWidth, "px") : "990px";
}, function(param) {
    var isSideWidgetOpen = param.isSideWidgetOpen, isMarketOpen = param.isMarketOpen;
    return function() {
        if (!isSideWidgetOpen) {
            return "unset";
        }
        if (!isMarketOpen) {
            return "calc(100% - 425px) !important";
        }
        return "calc(100% - 365px) !important";
    }();
}, function(param) {
    var isSideWidgetOpen = param.isSideWidgetOpen;
    return isSideWidgetOpen && "auto !important";
});
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-98894054-1"
})(_templateObject2(), function(props) {
    return props.background ? props.background : "transparent";
});
var WrapperMainContent = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-98894054-2"
})(_templateObject3(), function(param) {
    var isSideWidgetOpen = param.isSideWidgetOpen, isMarketOpen = param.isMarketOpen;
    return function() {
        if (!isSideWidgetOpen) {
            return "calc(100% - ".concat(SIDE_WIDGET_TOOLBAR_WIDTH, ") ");
        }
        if (!isMarketOpen) {
            return "calc(100% - 425px)";
        }
        return "calc(100% - 365px)";
    }();
});
/* harmony default export */ __webpack_exports__["ZP"] = (Container);


/***/ }),

/***/ 54154:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ glossaryMetaTags; },
/* harmony export */   "x": function() { return /* binding */ defaultMetaTags; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69396);


var defaultMetaTags = {
    title: "Stockbit - Investasi Saham Bersama Komunitas Saham Terbesar di Indonesia",
    description: "Aplikasi saham untuk berdiskusi, analisa dan berinvestasi dengan harga real time, berita terkini, riset, data fundamental, charting, dan analytical tools yang lengkap",
    keywords: "stockbit, investasi, saham, pasar modal, pasar saham, harga saham, belajar investasi, belajar saham, nabung saham, rekomendasi saham, belajar trading, virtual trading, komunitas saham, ihsg, berita saham, analisa saham, jual beli saham, bei, bursa saham indonesia, idx, professional tools, tools saham, saham bumi, reksadana, jkse",
    image: "https://stockbit.com/assets/img/stockbit.jpg",
    url: "https://stockbit.com"
};
var glossaryMetaTags = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, defaultMetaTags), {
    title: "Stockbit Glossary | Stockbit - Kamus Investasi Saham",
    url: "https://stockbit.com/glossary"
});
// eslint-disable-next-line import/prefer-default-export



/***/ }),

/***/ 26350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37213);
/* harmony import */ var constants_app__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86123);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54154);







function SEO(param) {
    var title = param.title, description = param.description, keywords = param.keywords, image = param.image, url = param.url, schemaJson = param.schemaJson, customTitle = param.customTitle;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_3___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title !== _constants__WEBPACK_IMPORTED_MODULE_4__/* .defaultMetaTags.title */ .x.title && !schemaJson && !customTitle ? "".concat(title, " | ").concat(_constants__WEBPACK_IMPORTED_MODULE_4__/* .defaultMetaTags.title */ .x.title) : title
            }),
            constants_app__WEBPACK_IMPORTED_MODULE_2__/* .isProduction */ .yv ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: "index, follow"
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: "noindex, nofollow"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "revisit",
                content: "1 days"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "revisit-after",
                content: "1 days"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "resource-type",
                content: "document"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "audience",
                content: "general"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "content-language",
                content: "id-ID"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "web_author",
                content: "Stockbit"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "type",
                content: "website"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "copyright",
                content: "Stockbit"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "google",
                content: "notranslate"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "google-site-verification",
                content: "n9LVcB1gB0We60y2dG78-koFgM8y_mrf9pw1hrKsxFA"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "fb:app_id",
                content: constants_api__WEBPACK_IMPORTED_MODULE_1__/* .FACEBOOK_APP_ID */ .lZ
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: keywords
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: "website"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: url
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: image
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:secure_url",
                content: image
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: "summary_large_image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:url",
                content: url
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: image
            }),
            schemaJson ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(schemaJson)
                }
            }) : null
        ]
    });
}
SEO.defaultProps = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, _constants__WEBPACK_IMPORTED_MODULE_4__/* .defaultMetaTags */ .x), {
    customTitle: false
});
/* harmony default export */ __webpack_exports__["Z"] = (SEO);


/***/ }),

/***/ 91364:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2497);
/* harmony import */ var global_WebSocket_slice__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23985);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var global_Notification__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77667);
/* harmony import */ var lib_entities_notification_useNotificationData__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89790);





var PRICE_ALERT_KEY = "price-alert";
function useNotificationListener() {
    var isUserLogin = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useDispatch */ .I0)();
    var unread = (0,lib_entities_notification_useNotificationData__WEBPACK_IMPORTED_MODULE_4__/* .useNotificationData */ .z)(function(store) {
        return store.unread;
    });
    var setUnread = (0,lib_entities_notification_useNotificationData__WEBPACK_IMPORTED_MODULE_4__/* .useNotificationData */ .z)(function(store) {
        return store.setUnread;
    });
    var notification = (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSelector */ .v9)(global_WebSocket_slice__WEBPACK_IMPORTED_MODULE_1__/* .notifWsSelector */ .i9);
    var notificationListener = function() {
        var notif = notification[notification.length - 1];
        // Update unread notification
        setUnread(unread + 1);
        var onClose = function() {
            return dispatch(global_WebSocket_slice__WEBPACK_IMPORTED_MODULE_1__/* ["default"].actions.resetNotification */ .ZP.actions.resetNotification());
        };
        // Show notification on left bottom side
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        (0,global_Notification__WEBPACK_IMPORTED_MODULE_3__/* .showGeneralNotification */ .uw)(notif, onClose);
    };
    var getPriceAlertFromLocalStorage = function() {
        var alertRaw = localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem(PRICE_ALERT_KEY);
        if (alertRaw) {
            try {
                return JSON.parse(alertRaw);
            } catch (e) {
                return false;
            }
        }
        return false;
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (!isUserLogin) return;
        if ((notification === null || notification === void 0 ? void 0 : notification.length) > 0) {
            notificationListener();
        }
    }, [
        notification === null || notification === void 0 ? void 0 : notification.length,
        isUserLogin
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (!isUserLogin) return;
        var alert = getPriceAlertFromLocalStorage();
        if (alert) {
            dispatch(global_WebSocket_slice__WEBPACK_IMPORTED_MODULE_1__/* ["default"].actions.setAlert */ .ZP.actions.setAlert(alert));
        }
    }, [
        isUserLogin
    ]);
    return null;
}
/* harmony default export */ __webpack_exports__["Z"] = (useNotificationListener);


/***/ }),

/***/ 30995:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2497);
/* harmony import */ var lib_entities_profile__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(333);
/* harmony import */ var utils_auth__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19225);




function useProfileData() {
    // get data from reducer
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
    // get data from profile
    var ref = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(lib_entities_profile__WEBPACK_IMPORTED_MODULE_2__/* .selectors */ .wl), dataProfile = ref.data;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        // check if profile data is available
        var parsedCookie = utils_auth__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getToken */ .Z.getToken();
        if (parsedCookie) {
            var token = parsedCookie.accessToken.token;
            // check if there's token but empty data profile
            if (token && !dataProfile.id) {
                var userAccess = utils_auth__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getUserAccess */ .Z.getUserAccess();
                // @ts-ignore
                var username = userAccess.username;
                // get user data profile
                // @ts-ignore
                dispatch(lib_entities_profile__WEBPACK_IMPORTED_MODULE_2__/* .effects.getUserProfile */ .Sz.getUserProfile(username));
            }
        }
    }, [
        dispatch,
        dataProfile
    ]);
}
/* harmony default export */ __webpack_exports__["Z"] = (useProfileData);


/***/ }),

/***/ 56198:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2497);
/* harmony import */ var lib_entities_credentials__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21671);
/* harmony import */ var utils_auth__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19225);




//  Utils

function useProtectedRoute() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isLoaded = ref[0], setIsLoaded = ref[1];
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
    var isLoggedIn = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(lib_entities_credentials__WEBPACK_IMPORTED_MODULE_3__/* .selectors */ .wl).isLoggedIn;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var ref;
        var token = utils_auth__WEBPACK_IMPORTED_MODULE_4__/* ["default"].getToken */ .Z.getToken();
        if (!isLoggedIn && !(token === null || token === void 0 ? void 0 : (ref = token.accessToken) === null || ref === void 0 ? void 0 : ref.token)) {
            // @ts-ignore
            dispatch(lib_entities_credentials__WEBPACK_IMPORTED_MODULE_3__/* .effects.logout */ .Sz.logout());
            router.push("/login");
            return;
        }
        setIsLoaded(true);
    }, [
        dispatch,
        isLoggedIn,
        router
    ]);
    return {
        isLoaded: isLoaded
    };
}
/* harmony default export */ __webpack_exports__["Z"] = (useProtectedRoute);


/***/ }),

/***/ 89561:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "By": function() { return /* binding */ deleteReferral; },
/* harmony export */   "ER": function() { return /* binding */ getReferralStatus; },
/* harmony export */   "H5": function() { return /* binding */ postApplyReferral; },
/* harmony export */   "KT": function() { return /* binding */ getReferralByCode; },
/* harmony export */   "Qu": function() { return /* binding */ getReferralInfo; },
/* harmony export */   "ve": function() { return /* binding */ getReferralMembers; }
/* harmony export */ });
/* harmony import */ var lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78372);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37213);


var request = lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_0__/* ["default"].defaultInstance */ .Z.defaultInstance;
var requestWithoutAlert = lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_0__/* ["default"].noAlert */ .Z.noAlert;
var getReferralInfo = function() {
    return request.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_SECURITIES_GENERAL_URL */ .kg, "/remisier/info"));
};
var getReferralStatus = function() {
    return requestWithoutAlert.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_SECURITIES_GENERAL_URL */ .kg, "/remisier/referral/status"));
};
var getReferralByCode = function(code) {
    return request.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_SECURITIES_GENERAL_URL */ .kg, "/remisier/referral/").concat(code));
};
var getReferralMembers = function(param) {
    var keyword = param.keyword, status = param.status, startDate = param.startDate, endDate = param.endDate, cursor = param.cursor;
    return request.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_SECURITIES_GENERAL_URL */ .kg, "/remisier/affiliate/members"), {
        params: {
            search: keyword !== "" ? keyword : undefined,
            status: status !== "MEMBER_STATUS_UNSPECIFIED" ? status : undefined,
            start_date: startDate,
            end_date: endDate,
            cursor: cursor
        }
    });
};
var postApplyReferral = function(code) {
    return request.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_SECURITIES_GENERAL_URL */ .kg, "/remisier/referral/apply"), {
        code: code
    });
};
var deleteReferral = function() {
    return request.delete("".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_SECURITIES_GENERAL_URL */ .kg, "/remisier/referral"));
};
var communityAPI = {
    getReferralInfo: getReferralInfo,
    getReferralStatus: getReferralStatus,
    getReferralByCode: getReferralByCode,
    getReferralMembers: getReferralMembers,
    postApplyReferral: postApplyReferral,
    deleteReferral: deleteReferral
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (communityAPI)));


/***/ }),

/***/ 70735:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var config_requestExodus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68425);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37213);


var screenerURL = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_EXODUS_URL */ .q7, "/screener");
var request = (0,config_requestExodus__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
var getScreenerCustom = function() {
    return request.get("".concat(screenerURL, "/templates"));
};
var getScreenerMetrics = function() {
    return request.get("".concat(screenerURL, "/preset"));
};
var getLoadPresetScreener = function(id, type) {
    var queryString = type ? "?type=".concat(type) : "";
    return request.get("".concat(screenerURL, "/templates/").concat(id).concat(queryString));
};
var getScreenerUniverse = function() {
    return request.get("".concat(screenerURL, "/universe"));
};
var postScreenerListResult = function(data) {
    return request.post("".concat(screenerURL, "/templates"), data);
};
var getScreenerFavorites = function() {
    return request.get("".concat(screenerURL, "/favorites"));
};
var addScreenerFavorite = function(screenerid, type) {
    return request.post("".concat(screenerURL, "/favorites"), {
        screenerid: screenerid,
        type: type
    });
};
var removeScreenerFavorite = function(screenerid, type) {
    return request.delete("".concat(screenerURL, "/favorites/").concat(screenerid, "?type=").concat(type));
};
var getScreenerFinancial = function() {
    return request.get("".concat(screenerURL, "/metric"));
};
var removeScreenerCustom = function(screenerID) {
    return request.delete("".concat(screenerURL, "/templates/").concat(screenerID));
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    getScreenerCustom: getScreenerCustom,
    getScreenerMetrics: getScreenerMetrics,
    getLoadPresetScreener: getLoadPresetScreener,
    getScreenerUniverse: getScreenerUniverse,
    postScreenerListResult: postScreenerListResult,
    getScreenerFavorites: getScreenerFavorites,
    addScreenerFavorite: addScreenerFavorite,
    removeScreenerFavorite: removeScreenerFavorite,
    getScreenerFinancial: getScreenerFinancial,
    removeScreenerCustom: removeScreenerCustom
});


/***/ }),

/***/ 89790:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ useNotificationData; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36305);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14671);
/* harmony import */ var zustand_middleware_immer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42435);
/* harmony import */ var lib_api_notification__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99368);
/* harmony import */ var utils_notification__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25178);









var useNotificationData = (0,zustand__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)((0,zustand_middleware_immer__WEBPACK_IMPORTED_MODULE_4__/* .immer */ .n)(function(set) {
    return {
        tab: "notification",
        isPopupOpen: false,
        isConvoOpen: false,
        isReading: false,
        isLoading: false,
        isLoadingPrevious: false,
        contents: {
            notification: {
                list: [],
                lastId: null
            },
            mention: {
                list: [],
                lastId: null
            },
            report: {
                list: [],
                lastId: null
            },
            tipping: {
                list: [],
                lastId: null
            }
        },
        unread: 0,
        // UI Reducers
        changeTab: function changeTab(tab) {
            set(function(draft) {
                draft.tab = tab;
            });
        },
        togglePopup: function togglePopup() {
            set(function(draft) {
                draft.isPopupOpen = !draft.isPopupOpen;
            });
        },
        closePopup: function closePopup() {
            set(function(draft) {
                draft.isPopupOpen = false;
            });
        },
        setConvoOpen: function setConvoOpen(id) {
            var isOpen = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
            set(function(draft) {
                draft.isConvoOpen = isOpen;
                draft.convoId = id;
            });
        },
        closeConvo: function closeConvo() {
            set(function(draft) {
                draft.isConvoOpen = false;
                draft.convoId = undefined;
            });
        },
        setUnread: function setUnread(count) {
            set(function(draft) {
                draft.unread = count;
            });
        },
        getNotification: // Asynchronous actions
        function getNotification1(tab) {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var typeParams, ref, data, status, _data, result, unread;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            set(function(draft) {
                                draft.isLoading = true;
                            });
                            typeParams = utils_notification__WEBPACK_IMPORTED_MODULE_2__/* .notificationTabsAttrs.find */ .jg.find(function(item) {
                                return item.name === tab;
                            });
                            _ctx.next = 5;
                            return (0,lib_api_notification__WEBPACK_IMPORTED_MODULE_1__/* .getNotification */ .v6)(typeParams.typeCodes);
                        case 5:
                            ref = _ctx.sent;
                            data = ref.data;
                            status = ref.status;
                            if (!(status !== 200)) {
                                _ctx.next = 10;
                                break;
                            }
                            throw new Error(data.error || data.error_type);
                        case 10:
                            _data = data.data, result = _data.result, unread = _data.unread;
                            set(function(draft) {
                                draft.unread = unread;
                                draft.contents[tab].list = result;
                                draft.isLoading = false;
                                if (result.length - 1 >= 0) {
                                    draft.contents[tab].lastId = result[result.length - 1].id;
                                }
                            });
                            _ctx.next = 17;
                            break;
                        case 14:
                            _ctx.prev = 14;
                            _ctx.t0 = _ctx["catch"](0);
                            set(function(draft) {
                                draft.errorMessage = _ctx.t0.message;
                                draft.isLoading = false;
                            });
                        case 17:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        14
                    ]
                ]);
            }))();
        },
        getPrevNotification: function getPrevNotification(tab, lastId) {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var typeParams, ref, data, status, _data, result, unread;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            // if previous
                            set(function(draft) {
                                draft.isLoadingPrevious = true;
                            });
                            typeParams = utils_notification__WEBPACK_IMPORTED_MODULE_2__/* .notificationTabsAttrs.find */ .jg.find(function(item) {
                                return item.name === tab;
                            });
                            _ctx.next = 4;
                            return (0,lib_api_notification__WEBPACK_IMPORTED_MODULE_1__/* .getNotification */ .v6)(typeParams.typeCodes, 25, lastId);
                        case 4:
                            ref = _ctx.sent;
                            data = ref.data;
                            status = ref.status;
                            if (!(status !== 200)) {
                                _ctx.next = 9;
                                break;
                            }
                            throw new Error(data.error || data.error_type);
                        case 9:
                            _data = data.data, result = _data.result, unread = _data.unread;
                            set(function(draft) {
                                draft.unread = unread;
                                draft.contents[tab].list = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(draft.contents[tab].list).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(result));
                                draft.isLoadingPrevious = false;
                                if (result.length - 1 >= 0) {
                                    draft.contents[tab].lastId = result[result.length - 1].id;
                                }
                            });
                        case 11:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }))();
        },
        getUnreadCount: function getUnreadCount() {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var ref, data, status, result;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            set(function(draft) {
                                draft.errorMessage = undefined;
                            });
                            _ctx.next = 4;
                            return (0,lib_api_notification__WEBPACK_IMPORTED_MODULE_1__/* .getUnreadNotificationNumber */ .O7)();
                        case 4:
                            ref = _ctx.sent;
                            data = ref.data;
                            status = ref.status;
                            if (!(status !== 200)) {
                                _ctx.next = 9;
                                break;
                            }
                            throw new Error(data.error || data.error_type);
                        case 9:
                            result = data.data;
                            if (!result) {
                                _ctx.next = 14;
                                break;
                            }
                            {
                                set(function(draft) {
                                    draft.unread = result.unread;
                                });
                            }
                            _ctx.next = 15;
                            break;
                        case 14:
                            throw new Error("failed to read notification");
                        case 15:
                            _ctx.next = 20;
                            break;
                        case 17:
                            _ctx.prev = 17;
                            _ctx.t0 = _ctx["catch"](0);
                            set(function(draft) {
                                draft.errorMessage = _ctx.t0.message;
                            });
                        case 20:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        17
                    ]
                ]);
            }))();
        },
        markNotifAsRead: function markNotifAsRead() {
            var tab = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "notification";
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var typeParams, ref, data, status, result;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            set(function(draft) {
                                draft.errorMessage = undefined;
                                draft.isReading = true;
                            });
                            typeParams = utils_notification__WEBPACK_IMPORTED_MODULE_2__/* .notificationTabsAttrs.find */ .jg.find(function(item) {
                                return item.name === tab;
                            });
                            _ctx.next = 5;
                            return (0,lib_api_notification__WEBPACK_IMPORTED_MODULE_1__/* .markAsRead */ .zJ)(typeParams.typeCodes);
                        case 5:
                            ref = _ctx.sent;
                            data = ref.data;
                            status = ref.status;
                            if (!(status !== 200)) {
                                _ctx.next = 10;
                                break;
                            }
                            throw new Error(data.error || data.error_type);
                        case 10:
                            result = data.data;
                            if (!result) {
                                _ctx.next = 15;
                                break;
                            }
                            {
                                set(function(draft) {
                                    draft.unread = 0;
                                    draft.isReading = false;
                                    draft.contents[tab].list = draft.contents[tab].list.map(function(item) {
                                        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, item), {
                                            is_read: true
                                        });
                                    });
                                });
                            }
                            _ctx.next = 16;
                            break;
                        case 15:
                            throw new Error("failed to read notification");
                        case 16:
                            _ctx.next = 21;
                            break;
                        case 18:
                            _ctx.prev = 18;
                            _ctx.t0 = _ctx["catch"](0);
                            set(function(draft) {
                                draft.errorMessage = _ctx.t0.message;
                                draft.isReading = false;
                            });
                        case 21:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        18
                    ]
                ]);
            }))();
        }
    };
}));


/***/ }),

/***/ 7639:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ stores_useUIConfigStore; }
});

// UNUSED EXPORTS: resetRules

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
// EXTERNAL MODULE: ./node_modules/immer/dist/immer.esm.mjs
var immer_esm = __webpack_require__(12902);
// EXTERNAL MODULE: ./node_modules/zustand/esm/middleware.js
var middleware = __webpack_require__(38597);
// EXTERNAL MODULE: ./src/utils/auth.js + 1 modules
var auth = __webpack_require__(19225);
// EXTERNAL MODULE: ./src/typings/auth.ts
var typings_auth = __webpack_require__(97718);
;// CONCATENATED MODULE: ./src/utils/objectOperations.ts

var pickObject = function(obj, keys) {
    var pickedObject = {};
    keys.forEach(function(key) {
        pickedObject[key] = obj === null || obj === void 0 ? void 0 : obj[key];
    });
    return pickedObject;
};
var omitObject = function(obj, keys) {
    var omittedObject = (0,_object_spread/* default */.Z)({}, obj);
    keys.forEach(function(key) {
        return delete omittedObject[key];
    });
    return omittedObject;
};

;// CONCATENATED MODULE: ./src/stores/useUIConfigStore/index.ts









var _obj;
var resetRules = (_obj = {}, // List item that should not deleted on social logout
(0,_define_property/* default */.Z)(_obj, typings_auth/* LoginType.Social */.B.Social, [
    "tradingLimitTooltip",
    "tradingLimitTnc",
    // Day Trade
    "dayTradeTnc",
    "dayTradeTncShown", 
]), // List item that should be deleted on securities logout
(0,_define_property/* default */.Z)(_obj, typings_auth/* LoginType.Securities */.B.Securities, [
    "featureFlags"
]), _obj);
var initialState = {
    userConfig: {}
};
var useUIConfigStore = (0,esm/* default */.ZP)((0,middleware/* persist */.tJ)(function(set, get) {
    var ref, ref1, ref2;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, initialState), {
        setUIValue: function(key, value) {
            var userId = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : (ref = auth/* default.getUserAccess */.Z.getUserAccess()) === null || ref === void 0 ? void 0 : ref.id;
            set((0,immer_esm/* default */.ZP)(function(state) {
                if (!state.userConfig[userId]) state.userConfig[userId] = {};
                if (typeof value === "function") {
                    if (!state.userConfig[userId][key]) {
                        state.userConfig[userId] = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state.userConfig[userId]), (0,_define_property/* default */.Z)({}, key, {}));
                    }
                    value(state.userConfig[userId][key]);
                    return;
                }
                state.userConfig[userId][key] = value;
            }));
        },
        getUIValue: function(key) {
            var userId = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (ref1 = auth/* default.getUserAccess */.Z.getUserAccess()) === null || ref1 === void 0 ? void 0 : ref1.id;
            var ref;
            return (ref = get().userConfig[userId]) === null || ref === void 0 ? void 0 : ref[key];
        },
        resetUIValue: function(loginType) {
            var userId = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (ref2 = auth/* default.getUserAccess */.Z.getUserAccess()) === null || ref2 === void 0 ? void 0 : ref2.id;
            var resetSocial = function() {
                set((0,immer_esm/* default */.ZP)(function(state) {
                    state.userConfig[userId] = pickObject(state.userConfig[userId], resetRules[typings_auth/* LoginType.Social */.B.Social]);
                }));
            };
            var resetSecurities = function() {
                set((0,immer_esm/* default */.ZP)(function(state) {
                    state.userConfig[userId] = omitObject(state.userConfig[userId], resetRules[typings_auth/* LoginType.Securities */.B.Securities]);
                }));
            };
            var _obj;
            var resetActions = (_obj = {}, (0,_define_property/* default */.Z)(_obj, typings_auth/* LoginType.Social */.B.Social, resetSocial), (0,_define_property/* default */.Z)(_obj, typings_auth/* LoginType.Securities */.B.Securities, resetSecurities), _obj);
            resetActions[loginType]();
        }
    });
}, {
    name: "UIConfigStore"
}));
/* harmony default export */ var stores_useUIConfigStore = (useUIConfigStore);


/***/ }),

/***/ 97718:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ LoginType; },
/* harmony export */   "z": function() { return /* binding */ OtpChannel; }
/* harmony export */ });
var LoginType;
(function(LoginType) {
    LoginType["Social"] = "social";
    LoginType["Securities"] = "securities";
})(LoginType || (LoginType = {}));
var OtpChannel;
(function(OtpChannel) {
    OtpChannel["Unspecified"] = "CHANNEL_UNSPECIFIED";
    OtpChannel["Sms"] = "CHANNEL_SMS";
    OtpChannel["WhatsApp"] = "CHANNEL_WHATSAPP";
})(OtpChannel || (OtpChannel = {}));


/***/ }),

/***/ 19225:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ auth; }
});

// EXTERNAL MODULE: ./src/constants/app.js
var app = __webpack_require__(86123);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isAfter/index.js
var isAfter = __webpack_require__(42699);
// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/v4.js + 3 modules
var v4 = __webpack_require__(57632);
;// CONCATENATED MODULE: ./src/constants/cookies.js
var ACCESS_TOKEN_KEY = "access_token";
var ACCESS_TOKEN_KEY_EXP = "access_token_exp";
var REFRESH_TOKEN_KEY = "refresh_token";
var REFRESH_TOKEN_KEY_EXP = "refresh_token_exp";
var ACCESS_USER_KEY = "access_user";
/*  securities/trading related cookies */ var TRADING_ACCESS_TOKEN = "securities_access_token";
var TRADING_REFRESH_TOKEN = "securities_refresh_token";
var TRADE_IS_LOGGED_IN = "trade_is_logged_in";
var TRADING_ACCOUNT_TYPE = "trading_account_type";
var LAST_TRADING_ACCOUNT_TYPE = "last_trading_account_type";
var TRADING_BROKER = "stockbit";
var PLAYER_ID = "player-id";


// EXTERNAL MODULE: ./src/constants/localstorage.js
var localstorage = __webpack_require__(44252);
// EXTERNAL MODULE: ./src/features/orderbook/utils.ts
var utils = __webpack_require__(51346);
// EXTERNAL MODULE: ./src/utils/general.js
var general = __webpack_require__(42227);
;// CONCATENATED MODULE: ./src/utils/auth.js







function getToken() {
    if (!(0,app/* isClient */.C5)()) {
        return {
            accessToken: {
                token: null,
                expiry: null,
                isValid: null
            },
            refresh: {
                token: null,
                expiry: null,
                isValid: null
            }
        };
    }
    var ls = localStorage;
    // set cookies
    // format date from backend is still in seconds, while
    // JS' date is in miliseconds format, thus multiply the date by 1000
    var accessToken = ls[localstorage/* ACCESS_TOKEN_KEY */.Wx] ? (0,general/* decodeBase64ToJS */.OB)(ls[localstorage/* ACCESS_TOKEN_KEY */.Wx]) : null;
    var accessTokenExp = ls[localstorage/* ACCESS_TOKEN_KEY_EXP */.z0] ? parseInt((0,general/* decodeBase64ToJS */.OB)(ls[localstorage/* ACCESS_TOKEN_KEY_EXP */.z0]), 10) : null;
    var refreshToken = ls[localstorage/* REFRESH_TOKEN_KEY */.w4] ? (0,general/* decodeBase64ToJS */.OB)(ls[localstorage/* REFRESH_TOKEN_KEY */.w4]) : null;
    var refreshTokenExp = ls[localstorage/* REFRESH_TOKEN_KEY_EXP */.Nv] ? parseInt((0,general/* decodeBase64ToJS */.OB)(ls[localstorage/* REFRESH_TOKEN_KEY_EXP */.Nv]), 10) : null;
    // check expiry
    var currentTime = Date.now();
    var isAccessTokenValid = (0,isAfter/* default */.Z)(accessTokenExp, currentTime);
    var isRefreshTokenValid = (0,isAfter/* default */.Z)(refreshTokenExp, currentTime);
    return {
        accessToken: {
            token: accessToken,
            expiry: accessTokenExp,
            isValid: isAccessTokenValid
        },
        refresh: {
            token: refreshToken,
            expiry: refreshTokenExp,
            isValid: isRefreshTokenValid
        }
    };
}
function saveToken(param) {
    var accessToken = param.accessToken, accessTokenExp = param.accessTokenExp, refreshToken = param.refreshToken, refreshTokenExp = param.refreshTokenExp, accessUser = param.accessUser;
    if (!(0,app/* isClient */.C5)()) {
        return;
    }
    if (accessUser) {
        localStorage[localstorage/* ACCESS_USER_KEY */.ns] = (0,general/* encodeBase64FromJS */.me)(accessUser);
    }
    localStorage[localstorage/* ACCESS_TOKEN_KEY */.Wx] = (0,general/* encodeBase64FromJS */.me)(accessToken);
    localStorage[localstorage/* ACCESS_TOKEN_KEY_EXP */.z0] = (0,general/* encodeBase64FromJS */.me)(accessTokenExp.toString());
    localStorage[localstorage/* REFRESH_TOKEN_KEY */.w4] = (0,general/* encodeBase64FromJS */.me)(refreshToken);
    localStorage[localstorage/* REFRESH_TOKEN_KEY_EXP */.Nv] = (0,general/* encodeBase64FromJS */.me)(refreshTokenExp.toString());
}
function updateAccessUser(accessUser) {
    if ((0,app/* isClient */.C5)()) {
        localStorage[localstorage/* ACCESS_USER_KEY */.ns] = (0,general/* encodeBase64FromJS */.me)(accessUser);
    }
}
function destroyToken() {
    if ((0,app/* isClient */.C5)()) {
        localStorage.removeItem(localstorage/* ACCESS_USER_KEY */.ns);
        localStorage.removeItem(localstorage/* ACCESS_TOKEN_KEY */.Wx);
        localStorage.removeItem(localstorage/* ACCESS_TOKEN_KEY_EXP */.z0);
        localStorage.removeItem(localstorage/* REFRESH_TOKEN_KEY */.w4);
        localStorage.removeItem(localstorage/* REFRESH_TOKEN_KEY_EXP */.Nv);
        localStorage.removeItem("stbx-active-indexwatchlist");
        localStorage.removeItem("stbx-active-watchlist");
        localStorage.removeItem("stbx-active-widget");
        localStorage.removeItem("stbx-active-stream-header");
        localStorage.removeItem("stbx-active-stream");
        localStorage.removeItem("trade-orderbook-show-confirmation");
        localStorage.removeItem("tradeIsLogin");
        localStorage.removeItem("tradingVersion");
        localStorage.removeItem("tradingAccountType");
        localStorage.removeItem("taps");
        localStorage.removeItem("tradingBroker");
        localStorage.removeItem("lastTradingAccountType");
        localStorage.removeItem("register_trading_useractive_sinarmas");
        localStorage.removeItem("register_trading_sinarmas");
        localStorage.removeItem("register_trading_useractive");
        localStorage.removeItem("tradingBrokerList");
        localStorage.removeItem("financials-panel-amount");
        localStorage.removeItem("financials-panel-currency");
        localStorage.removeItem("financials-panel-datatype");
        localStorage.removeItem("financials-panel-lang");
        localStorage.removeItem("financials-panel-ordertype");
        localStorage.removeItem("financials-panel-reportype");
        localStorage.removeItem("financials-panel-rounding-count");
        localStorage.removeItem("financials-panel-rounding-symbol");
        localStorage.removeItem("financials-panel-statetype");
        localStorage.removeItem("crisp");
        localStorage.removeItem("formula");
        localStorage.removeItem("stbx-active-trending-date");
        localStorage.removeItem("ws");
        utils/* localStorageOrderbookHandler.remove */.Ku.remove();
        localStorage.removeItem("orderbooklistID");
        localStorage.removeItem("orderbooklistName");
    }
}
/**
 * getUserAccess
 * to get user data from auth login
 * @param {*} ctx
 */ function getUserAccess() {
    return (0,app/* isClient */.C5)() && localStorage && localStorage[localstorage/* ACCESS_USER_KEY */.ns] ? (0,general/* decodeBase64ToJS */.OB)(localStorage[localstorage/* ACCESS_USER_KEY */.ns]) : {};
}
var setLocalCrispSettings = function(crisp) {
    localStorage.location = window.location.origin;
    localStorage.crisp = (0,general/* encodeBase64FromJS */.me)(crisp);
};
var setLocalIntercomSettings = function(intercom) {
    localStorage.location = window.location.origin;
    localStorage.intercom = (0,general/* encodeBase64FromJS */.me)(intercom);
};
var isLoggedIn = function() {
    return (0,app/* isClient */.C5)() && Boolean(localStorage === null || localStorage === void 0 ? void 0 : localStorage.at);
};
var getPlayerId = function(req) {
    var playerId = (req === null || req === void 0 ? void 0 : req.cookies[PLAYER_ID]) || (0,v4/* default */.Z)();
    return playerId;
};
/* harmony default export */ var auth = ({
    isLoggedIn: isLoggedIn,
    getToken: getToken,
    saveToken: saveToken,
    destroyToken: destroyToken,
    getUserAccess: getUserAccess,
    updateAccessUser: updateAccessUser,
    setLocalCrispSettings: setLocalCrispSettings,
    setLocalIntercomSettings: setLocalIntercomSettings,
    getPlayerId: getPlayerId
});


/***/ }),

/***/ 42227:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BF": function() { return /* binding */ isMobileVersion; },
/* harmony export */   "C9": function() { return /* binding */ getLastSlashURL; },
/* harmony export */   "Ex": function() { return /* binding */ saveObject; },
/* harmony export */   "FD": function() { return /* binding */ emptyObject; },
/* harmony export */   "GD": function() { return /* binding */ convertToEventValue; },
/* harmony export */   "Gf": function() { return /* binding */ sanitizeHTMLTags; },
/* harmony export */   "OB": function() { return /* binding */ decodeBase64ToJS; },
/* harmony export */   "St": function() { return /* binding */ parseCountAbbrv2; },
/* harmony export */   "TE": function() { return /* binding */ copyTextToClipboard; },
/* harmony export */   "Tk": function() { return /* binding */ handleErrorAvatar; },
/* harmony export */   "fm": function() { return /* binding */ capitalizeFirstLetter; },
/* harmony export */   "hB": function() { return /* binding */ popupWindowToCenter; },
/* harmony export */   "hr": function() { return /* binding */ escapeRegExp; },
/* harmony export */   "k6": function() { return /* binding */ convertToSlug; },
/* harmony export */   "ko": function() { return /* binding */ replaceAll; },
/* harmony export */   "lz": function() { return /* binding */ sanitizeURL; },
/* harmony export */   "me": function() { return /* binding */ encodeBase64FromJS; },
/* harmony export */   "pV": function() { return /* binding */ getColorBasedOnNumber; },
/* harmony export */   "r$": function() { return /* binding */ capitalizer; },
/* harmony export */   "rK": function() { return /* binding */ transformAvatarUrl; }
/* harmony export */ });
/* unused harmony exports sortAlpha, setCharAt, newlineToBr, getPathFromUrl, trimText */
/* harmony import */ var js_base64__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52300);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37213);
/* harmony import */ var constants_successMessage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41208);
/* harmony import */ var global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25516);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22147);
/* eslint-disable no-restricted-syntax */ /* eslint-disable indent */ /* eslint-disable no-param-reassign */ /* eslint-disable no-useless-escape */ /* eslint-disable no-restricted-globals */ /* eslint-disable no-nested-ternary */ /* eslint-disable wrap-iife */ 




/* eslint-disable import/prefer-default-export */ var copyTextToClipboard = function(text) {
    var customAlert = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    var input = document.createElement("input");
    input.setAttribute("type", "text");
    var body = document.querySelector("body");
    input.value = text;
    body.appendChild(input);
    input.select();
    document.execCommand("copy");
    body.removeChild(input);
    if (customAlert) {
        customAlert();
    } else {
        (0,global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("Link copied", constants_successMessage__WEBPACK_IMPORTED_MODULE_2__/* ["default"].ALERT_GREEN */ .Z.ALERT_GREEN);
    }
};
function isMobileVersion() {
    var check = false;
    // eslint-disable-next-line func-names
    (function(a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) {
            check = true;
        }
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
}
function popupWindowToCenter(url, title, w, h) {
    // Fixes dual-screen position                         Most browsers      Firefox
    var dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : screen.left;
    var dualScreenTop = window.screenTop !== undefined ? window.screenTop : screen.top;
    var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
    var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;
    var left = width / 2 - w / 2 + dualScreenLeft;
    var top = height / 2 - h / 2 + dualScreenTop;
    var newWindow = window.open(url, title, "scrollbars=yes, width=".concat(w, ", height=").concat(h, ", top=").concat(top, ", left=").concat(left));
    // Puts focus on the newWindow
    if (window.focus) {
        newWindow.focus();
    }
}
function getLastSlashURL(url) {
    return url.substr(url.lastIndexOf("/") + 1);
}
function handleErrorAvatar(e, paramUsername) {
    var fallbackUrl = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .SITE_URL */ ._O, "/images/avatar.png");
    e.target.onerror = null;
    e.target.src = fallbackUrl;
}
function parsePureValueSep(pv) {
    if (typeof pv !== "number") pv = parseFloat(pv);
    return parseFloat(pv.toFixed(2)).toLocaleString("en-US");
}
var parseCountAbbrv2 = function(number, decPlaces) {
    var thoSep = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ",";
    var result = 0;
    if (typeof decPlaces !== "number") decPlaces = 3;
    // 2 decimal places => 100, 3 => 1000, etc
    decPlaces = Math.pow(10, decPlaces);
    // Enumerate number abbreviations
    var abbrev = [
        "K",
        "M",
        "B"
    ];
    var oldNumber = number;
    // Go through the array backwards, so we do the largest first
    for(var i = abbrev.length - 1; i >= 0; i -= 1){
        // Convert array index to "1000", "1000000", etc
        var size = Math.pow(10, (i + 1) * 3);
        // If the number is bigger or equal do the abbreviation
        if (size <= number) {
            // Here, we multiply by decPlaces, round, and then divide by decPlaces.
            // This gives us nice rounding to a particular decimal place.
            number = Math.round(number * decPlaces / size) / decPlaces;
            // Handle special case where we round up to the next abbreviation
            if (number === 1000 && i < abbrev.length - 1) {
                number = 1;
                i += 1;
            }
            // Add the letter for the abbreviation
            number += " ".concat(abbrev[i]);
            break;
        }
    }
    var raw = [];
    if (number) {
        number = number.toString();
        raw = number.split(" ");
        if (raw[0] && raw[1]) {
            result = parsePureValueSep(raw[0]);
            result = raw[1] && raw[1] !== "K" ? "".concat(result, " ").concat(raw[1]) : result;
            if (raw[1] === "K") {
                result = parseFloat(oldNumber);
                result = parsePureValueSep(result);
            }
        } else {
            result = number;
        }
    }
    return result;
};
function sortAlpha(a, b) {
    var ax = a.toLowerCase();
    var bx = b.toLowerCase();
    return ax < bx ? -1 : ax > bx ? 1 : 0;
}
/**
 * Convert data to event change data to be used in `useForm` hooks
 * @param {*} val
 * @returns {Object}
 */ var convertToEventValue = function(val) {
    var data = {
        target: {
            value: val
        }
    };
    return data;
};
/**
 * Convert text to slug
 * @param {string} text
 * @return {string}
 */ function convertToSlug(text) {
    if (!text) return text;
    return text.toString().toLowerCase().replace(/\s+/g, "-") // Replace spaces with -
    .replace(/[^\w\-]+/g, "") // Remove all non-word chars
    .replace(/\-\-+/g, "-") // Replace multiple - with single -
    .replace(/^-+/, "") // Trim - from start of text
    .replace(/-$/, ""); // Trim - from end of text
}
/**
 * Capitalize
 * @param {string} string
 * @return {string}
 */ function capitalizeFirstLetter(string) {
    if (!string) return string;
    var newString = string.toLowerCase();
    return newString.charAt(0).toUpperCase() + newString.slice(1);
}
function setCharAt(str, index, chr) {
    if (index > str.length - 1) return str;
    return str.substring(0, index) + chr + str.substring(index + 1);
}
/**
 * Capitalizer
 * @param {string} string
 * @param {number} at
 * @return {string}
 */ function capitalizer(string) {
    var at = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    if (!string) return string;
    var upperCasedLetter = string.charAt(at).toUpperCase();
    return setCharAt(string, at, upperCasedLetter);
}
// helpers
var encodeBase64FromJS = function(object) {
    var result = object;
    if (typeof object === "object") {
        result = JSON.stringify(object);
    }
    return js_base64__WEBPACK_IMPORTED_MODULE_0__/* .Base64.encode */ .DS.encode(result);
};
var decodeBase64ToJS = function(base64) {
    var decoded = js_base64__WEBPACK_IMPORTED_MODULE_0__/* .Base64.decode */ .DS.decode(base64);
    var result = decoded;
    try {
        result = JSON.parse(decoded);
    } catch (e) {
        result = decoded;
    }
    return result;
};
// local storage utils
var saveObject = function(key, object) {
    window.localStorage.setItem("location", window.location.origin);
    window.localStorage.setItem(key, encodeBase64FromJS(object));
};
/**
 * Turn newline into <br/>
 * @param {string} str
 * @param {string=} isXhtml
 * @returns {string}
 */ function newlineToBr(str, isXhtml) {
    var breakTag = isXhtml || typeof isXhtml === "undefined" ? "<br />" : "<br>";
    return "".concat(str).replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, "$1".concat(breakTag, "$2"));
}
function emptyObject(obj) {
    return obj && Object.keys(obj).length === 0 && obj.constructor === Object;
}
function escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // $& means the whole matched string
}
/**
 * @deprecated - do not use for user input manipulation
 * @param {} str
 * @param {*} match
 * @param {*} replacement
 * @returns str
 */ function replaceAll(str, match, replacement) {
    return str.replace(new RegExp(escapeRegExp(match), "g"), function() {
        return replacement;
    });
}
var getColorBasedOnNumber = function(number) {
    if (Number(number) > 0) return _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].primary */ .Z.primary;
    if (Number(number) < 0) return _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].sunsetOrange */ .Z.sunsetOrange;
    return _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].highempahis */ .Z.highempahis;
};
function getPathFromUrl(url) {
    return url.split("?")[0];
}
function trimText(description, maxLength) {
    var trimmedString = description.substr(0, maxLength);
    var lastStringIndex = Math.min(trimmedString.length, trimmedString.lastIndexOf(" "));
    trimmedString = trimmedString.substr(0, lastStringIndex);
    if (description.length > maxLength) {
        trimmedString += "...";
    }
    return trimmedString;
}
var transformAvatarUrl = function() {
    var avatarUrl = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    if (avatarUrl.startsWith("http")) {
        return avatarUrl;
    }
    return "".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .AVATAR_URL */ .q$, "/").concat(avatarUrl);
};
/**
 * sanitizeHTMLTags
 * Remove Curve Brackets from string
 * to prevent xss, security issues
 *
 * This function is created because regex "/(<([^>]+)>)/gi" that already
 * used in v2 is not accepted in sonar-scan v3.
 * This function already have unit test
 * to makesure the result same as the previous regex implementation.
 * @param {String} originalString
 * @returns
 */ var sanitizeHTMLTags = function() {
    var originalString = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var result = "";
    var start = 0;
    while(true){
        var startBracket = originalString.indexOf("<", start);
        if (startBracket === -1) break;
        var endBracket = originalString.indexOf(">", startBracket);
        if (endBracket === -1) break;
        if (endBracket - startBracket === 1) {
            result += originalString.substring(startBracket - (startBracket - start), endBracket + 1);
        } else {
            result += originalString.substring(start, startBracket);
        }
        start = endBracket + 1;
    }
    result += originalString.substring(start);
    return result;
};
function sanitizeURL() {
    var urlToCheck = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "/";
    if (urlToCheck[0] === "/") {
        return urlToCheck;
    }
    try {
        var safeProtocol = [
            "https",
            "http"
        ];
        var safeHost = [
            "stockbit.com",
            "ui.lab.stockbit.com",
            "itunes.apple.com",
            "play.google.com", 
        ];
        var url = new URL(urlToCheck);
        if (safeProtocol.indexOf(url === null || url === void 0 ? void 0 : url.protocol) < 0) {
            throw Error("Not safe protocol: ".concat(url === null || url === void 0 ? void 0 : url.protocol));
        }
        if (safeHost.indexOf(url === null || url === void 0 ? void 0 : url.host) < 0) {
            throw Error("Not safe host: ".concat(url === null || url === void 0 ? void 0 : url.host));
        }
        return urlToCheck;
    } catch (err) {
        ;
        return constants_api__WEBPACK_IMPORTED_MODULE_1__/* .SITE_URL */ ._O;
    }
}



/***/ }),

/***/ 91635:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Iv": function() { return /* binding */ setUserId; },
/* harmony export */   "Kp": function() { return /* binding */ sentrySetUser; },
/* harmony export */   "gB": function() { return /* binding */ sentryLog; }
/* harmony export */ });
/* unused harmony export noticeError */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82670);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64487);
/* harmony import */ var _auth__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19225);
/* harmony import */ var _general__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42227);







var setUserId = function(userId) {
    if (false) {}
    var logger = window === null || window === void 0 ? void 0 : window.NREUM;
    if (!logger || !(logger === null || logger === void 0 ? void 0 : logger.setUserId)) return;
    if (userId !== null) logger === null || logger === void 0 ? void 0 : logger.setUserId(userId.toString());
};
var noticeError = function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
err, customAttr) {
    if (false) {}
    var logger = window === null || window === void 0 ? void 0 : window.NREUM;
    if (!logger) return;
    // Get User Id from localStorage
    var ref = _auth__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getUserAccess */ .Z.getUserAccess() || {}, userId = ref.id;
    // Set New Relic User Id
    if (err) {
        setUserId(userId || null);
        var mappedCustomAttr;
        try {
            mappedCustomAttr = Object.keys(customAttr).reduce(function(a, key) {
                var newKey = key.startsWith("sb") ? (0,_general__WEBPACK_IMPORTED_MODULE_1__/* .capitalizer */ .r$)(key, 2) : "sb".concat((0,_general__WEBPACK_IMPORTED_MODULE_1__/* .capitalizer */ .r$)(key, 0));
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, a), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, newKey, customAttr[key]));
            }, {});
        } catch (error) {
            mappedCustomAttr = customAttr;
        }
        logger.noticeError(err, mappedCustomAttr);
    }
};
/* harmony default export */ __webpack_exports__["ZP"] = (noticeError);
var sentryLog = function(options) {
    var error = options.error, scopeName = options.scope, level = options.level, username = options.username, httpStatusCode = options.httpStatusCode, tags = options.tags;
    _sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__/* .withScope */ .$e(function(scope) {
        scope.setTag("scope", scopeName);
        scope.setLevel(level);
        if (httpStatusCode) {
            scope.setTag("http-status-code", httpStatusCode);
        }
        if (Array.isArray(tags) && tags.length > 0) {
            tags.forEach(function(item) {
                scope.setTag(item.title, item.value);
            });
        }
        if (username) {
            scope.setUser({
                username: username
            });
        }
        if (typeof error === "string") {
            _sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__/* .captureMessage */ .uT(error);
        }
        if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(error, Error)) {
            _sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__/* .captureException */ .Tb(error);
        }
    });
};
var sentrySetUser = function(isLoggedIn) {
    if (!isLoggedIn) {
        return;
    }
    var userData = _auth__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getUserAccess */ .Z.getUserAccess();
    _sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__/* .setUser */ .av({
        username: userData === null || userData === void 0 ? void 0 : userData.username,
        id: userData === null || userData === void 0 ? void 0 : userData.id
    });
};


/***/ }),

/***/ 62974:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q7": function() { return /* binding */ isFloat; },
/* harmony export */   "QV": function() { return /* binding */ roundNumber; },
/* harmony export */   "St": function() { return /* binding */ parseCountAbbrv2; },
/* harmony export */   "YA": function() { return /* binding */ parseNumberAbbrvNum; },
/* harmony export */   "rl": function() { return /* binding */ formatPercentage; },
/* harmony export */   "uf": function() { return /* binding */ formatNumber; },
/* harmony export */   "ym": function() { return /* binding */ parseCountThousand; }
/* harmony export */ });
/* unused harmony exports kNumberFormatter, bNumberFormatter, decideNumberFormatter, parseCountAbbrv3, parseCountThousandWithDecimalPlace, parsePureValueSep */
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92077);
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(numeral__WEBPACK_IMPORTED_MODULE_0__);
/* eslint-disable no-param-reassign */ /* eslint-disable arrow-body-style */ /* eslint-disable radix */ 
/*
  Count length of given decimal
*/ function countLengthDecimal(num) {
    var match = "".concat(num).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
    if (!match) {
        return 0;
    }
    return Math.max(0, // Number of digits right of decimal point.
    (match[1] ? match[1].length : 0) - // Adjust for scientific notation.
    (match[2] ? +match[2] : 0));
}
/*
  Get random integer from in range of min to max value
*/ function getRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}
/**
 * Get total digit of a number
 * @param {number} num
 */ function getNumberDigit(num) {
    var netral = Math.abs(num);
    return netral.toString().length;
}
/**
 * Shorten thousands number
 * @param {number} num
 * @param {number} fixed
 * @param {boolean} symbol
 */ function kNumberFormatter(num) {
    var fixed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2, symbol = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, withComa = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var number;
    var nd = getNumberDigit(num);
    if (nd > 3) {
        number = (num / (nd > 5 ? 100000 : 1000)).toFixed(fixed);
        if (!withComa) {
            number = numeral__WEBPACK_IMPORTED_MODULE_0___default()(number).format("0,0");
        } else if (withComa) {
            number = numeral__WEBPACK_IMPORTED_MODULE_0___default()(number).format(typeof withComa === "string" ? withComa : "0,0.00");
        }
        if (symbol) {
            number += "K";
        }
    } else {
        number = num;
    }
    return number;
}
/**
 * Shorten long number and add suffix M
 * @param {number} num - Long number
 * @param {number} fixed - Decimal
 * @param {boolean} symbol - Flag to add symbol suffix
 */ function mNumberFormatter(num) {
    var fixed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2, symbol = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var number;
    var decide = false; // is decide need number
    if (getNumberDigit(num) > 6) decide = true;
    if (decide) {
        number = (num / 1000000).toFixed(fixed);
        if (symbol) {
            number += "M";
        }
    } else {
        number = num;
    }
    return number;
}
/**
 * Shorten long number and add suffix B
 * @param {number} num - Long number
 * @param {number} fixed - Decimal number
 * @param {boolean} symbol - Flag to add symbol suffix
 */ function bNumberFormatter(num) {
    var fixed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2, symbol = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, formatDot = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var number = (num / 1000000000).toFixed(fixed);
    if (symbol) {
        if (formatDot) {
            number = numeral__WEBPACK_IMPORTED_MODULE_0___default()(number).format("0.0");
        } else {
            number = numeral__WEBPACK_IMPORTED_MODULE_0___default()(number).format("0,0[.]0");
        }
        number += "B";
    }
    return number;
}
function tNumberFormatter(num) {
    var fixed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2, symbol = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var number = (num / 1000000000000).toFixed(fixed);
    if (symbol) {
        number = numeral__WEBPACK_IMPORTED_MODULE_0___default()(number).format("0.0");
        number += "T";
    }
    return number;
}
/**
 * Function to decide which number formatter should be used based on
 * the number length
 * @param {number} num
 * @param {boolean} withThousands
 * @param {boolean} formatDot
 */ function decideNumberFormatter(num, withThousands, formatDot) {
    var numberDigit = getNumberDigit(num);
    if (numberDigit > 12 && formatDot) return tNumberFormatter;
    if (numberDigit > 9) return bNumberFormatter;
    if (withThousands) {
        if (numberDigit > 6) return mNumberFormatter;
        return kNumberFormatter;
    }
    return mNumberFormatter;
}
/**
 * Number formatter wrapper
 * @param {Object} params
 * @param {*} params.num - Number to be formatted
 * @param {number} params.fixed - Decimal place
 * @param {boolean=} params.symbol - If formatted number has symbol suffix
 * @param {boolean=} params.withThousands - If decided to format thousands number
 * @param {*=} params.formatDot - Using dot in formatting
 * @returns {string | number} -formatted number
 */ function numberFormatter(param) {
    var num = param.num, fixed = param.fixed, _symbol = param.symbol, symbol = _symbol === void 0 ? true : _symbol, _withThousands = param.withThousands, withThousands = _withThousands === void 0 ? false : _withThousands, _formatDot = param.formatDot, formatDot = _formatDot === void 0 ? false : _formatDot;
    var formatter = decideNumberFormatter(num, withThousands, Boolean(formatDot));
    return formatter(num, fixed, symbol, formatDot);
}
var char_count = function(str, letter) {
    var letter_Count = 0;
    for(var position = 0; position < str.length; position += 1){
        if (str.charAt(position) === letter) {
            letter_Count += 1;
        }
    }
    return letter_Count;
};
var roundNumber = function(number, format) {
    var nFormat = format.split(".");
    var multiplier = 1;
    if (nFormat.length > 1) {
        var getDecimal = nFormat.pop();
        var decimal = char_count(getDecimal, "0");
        multiplier = Math.pow(10, decimal);
    }
    var nNumber = (number >= 0 ? Math.floor : Math.ceil)(number * multiplier) / multiplier;
    return nNumber;
};
var isFloat = function(n1) {
    return Number(n1) % 1 !== 0;
};
var processNumber = function(number, format, showTrailingZero) {
    var formattedNumber = numeral__WEBPACK_IMPORTED_MODULE_0___default()(number).format(format);
    var roundingNumber = formattedNumber;
    var splitNumber = formattedNumber.split(".");
    var isDecimal = splitNumber.length > 1;
    if (!showTrailingZero) {
        if (isDecimal) {
            roundingNumber = formattedNumber.replace(/(\.0+|0+)$/, "");
        } else if (splitNumber.length) {
            // eslint-disable-next-line prefer-destructuring
            roundingNumber = splitNumber[0];
        }
    }
    return roundingNumber;
};
var formatNumber = function(number) {
    var rounding = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, format = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "0,0", showTrailingZero = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var roundingNumber = rounding ? roundNumber(number, format) : number;
    var newNumber = processNumber(roundingNumber, format, showTrailingZero);
    return newNumber;
};
var formatPercentage = function(number) {
    var rounding = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, format = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "0.00", showTrailingZero = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    if (number === Infinity) number = 0;
    var roundingNumber = rounding ? roundNumber(number, format) : number;
    var newNumber = processNumber(roundingNumber, format, showTrailingZero);
    return "".concat(newNumber, "%");
};
var parseLot = function(lot) {
    return Math.round(lot / 100);
};
var parseCountAbbrv3 = function(number, decPlaces) {
    var abbreviation = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, withDecimal = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, withMinusSymbol = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
    var result = 0;
    var minus = false;
    var newNumber = number;
    // eslint-disable-next-line eqeqeq
    if (newNumber && newNumber.toString().indexOf("-") == 0) {
        minus = true;
    }
    newNumber = Math.ceil(newNumber);
    if (!decPlaces) decPlaces = 3;
    // 2 decimal places => 100, 3 => 1000, etc
    decPlaces = Math.pow(10, decPlaces);
    var abbrev;
    // Enumerate number abbreviations
    // eslint-disable-next-line default-case
    switch(abbreviation){
        case 1:
            // Enumerate number abbreviations
            abbrev = [
                "K",
                "M",
                "B",
                "T"
            ];
            break;
        case 2:
            // Enumerate number abbreviations
            abbrev = [
                "K",
                "M",
                "B"
            ];
            break;
        case 3:
            // Enumerate number abbreviations
            abbrev = [
                "K",
                "M"
            ];
            break;
        case 4:
            // Enumerate number abbreviations
            abbrev = [
                "K"
            ];
            break;
    }
    // Go through the array backwards, so we do the largest first
    // eslint-disable-next-line no-plusplus
    for(var i = abbrev.length - 1; i >= 0; i--){
        // Convert array index to "1000", "1000000", etc
        var size = Math.pow(10, (i + 1) * 3);
        // If the number is bigger or equal do the abbreviation
        if (size <= newNumber) {
            // Here, we multiply by decPlaces, round, and then divide by decPlaces.
            // This gives us nice rounding to a particular decimal place.
            newNumber = Math.round(newNumber * decPlaces / size) / decPlaces;
            // Handle special case where we round up to the next abbreviation
            if (newNumber === 1000 && i < abbrev.length - 1) {
                newNumber = 1;
                // eslint-disable-next-line no-plusplus
                i++;
            }
            var format = withDecimal ? "0,0[.]0" : "0,0";
            newNumber = numeral__WEBPACK_IMPORTED_MODULE_0___default()(newNumber).format(format);
            if (minus) {
                newNumber = withMinusSymbol ? "-".concat(newNumber) : "(".concat(newNumber, ")");
            }
            // Add the letter for the abbreviation
            newNumber += "".concat(abbrev[i]);
            break;
        }
    }
    if (number) {
        var numString = newNumber.toString();
        result = numString;
    }
    return result;
};
var isNum = function(n1) {
    return !Number.isNaN(parseFloat(n1)) && Number.isFinite(n1);
};
var addPlusOrMinus2 = function(value) {
    if (!isNum(value)) {
        return value;
    }
    var formattedValue = numeral__WEBPACK_IMPORTED_MODULE_0___default()(value).value();
    var newValue = parseFloat(formattedValue);
    if (formattedValue !== 0) {
        newValue = formattedValue < 0 ? numeral__WEBPACK_IMPORTED_MODULE_0___default()(newValue).format("0,0") : "+".concat(numeral__WEBPACK_IMPORTED_MODULE_0___default()(newValue).format("0,0"));
    }
    return typeof newValue !== "string" ? String(newValue) : newValue;
};
var parseCountThousand = function(num, withdot) {
    var separator = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ",";
    // let sep = ','
    try {
        if (withdot) {
            return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator);
        }
        return removeCountDotThousand(num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator));
    } catch (e) {
        return num;
    }
};
var parseCountThousandWithDecimalPlace = function(num) {
    var decimalPlace = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    // let sep = ','
    try {
        return removeCountDotThousand(num.toLocaleString());
    } catch (e) {
        return num;
    }
};
function parsePureValueSep(pv) {
    var thoSep = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ",";
    // console.log('::-- parsePureValue ', {pv, thoSep})
    if (typeof pv !== "number") pv = parseFloat(pv);
    return parseFloat(pv.toFixed(2)).toLocaleString("en-US");
}
var parseCountAbbrv2 = function(number, decPlaces) {
    var thoSep = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ",", enableK = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var result = 0;
    if (typeof decPlaces !== "number") decPlaces = 3;
    // 2 decimal places => 100, 3 => 1000, etc
    decPlaces = Math.pow(10, decPlaces);
    // Enumerate number abbreviations
    var abbrev = [
        "K",
        "M",
        "B"
    ];
    var oldNumber = number;
    // Go through the array backwards, so we do the largest first
    for(var i = abbrev.length - 1; i >= 0; i--){
        // Convert array index to "1000", "1000000", etc
        var size = Math.pow(10, (i + 1) * 3);
        // If the number is bigger or equal do the abbreviation
        if (size <= number) {
            // Here, we multiply by decPlaces, round, and then divide by decPlaces.
            // This gives us nice rounding to a particular decimal place.
            number = Math.round(number * decPlaces / size) / decPlaces;
            // Handle special case where we round up to the next abbreviation
            if (number == 1000 && i < abbrev.length - 1) {
                number = 1;
                i++;
            }
            // Add the letter for the abbreviation
            number += "".concat(abbrev[i]);
            break;
        }
    }
    var raw = [];
    if (number) {
        number = number.toString();
        raw = number.split(" ");
        if (raw[0] && raw[1]) {
            // console.log('::-- row raw ', parsePureValueSep(raw[0], thoSep));
            result = parsePureValueSep(raw[0], thoSep);
            if (raw[1] === "K" && !enableK) {
                result = parseFloat(oldNumber);
                result = parsePureValueSep(result, thoSep);
            } else {
                result = "".concat(result, " ").concat(raw[1]);
            }
        } else {
            result = number;
        }
    }
    //   if(number) {
    // result = number.replace('.', ',')
    //   }
    return result;
};
function parseNumberAbbrvNum(val, format) {
    var number = numeral__WEBPACK_IMPORTED_MODULE_0___default()(val);
    var formatted = number.format(format);
    return formatted;
}
var parseCountAbbrv4 = function(param) {
    var value = param.value, decPlaces = param.decPlaces, _abbreviation = param.abbreviation, abbreviation = _abbreviation === void 0 ? 1 : _abbreviation, _withDecimal = param.withDecimal, withDecimal = _withDecimal === void 0 ? false : _withDecimal, _withMinusSymbol = param.withMinusSymbol, withMinusSymbol = _withMinusSymbol === void 0 ? false : _withMinusSymbol;
    return parseCountAbbrv3(value, decPlaces, abbreviation, withDecimal, withMinusSymbol);
};
/**
 * Shorten thousands number
 * @param {number} num
 * @param {number} fixed
 * @param {boolean} symbol
 * @param {boolean} withComma
 */ function kNumberFormatterV2(num) {
    var fixed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2, symbol = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, withComma = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var number;
    var nd = getNumberDigit(num);
    if (nd > 3) {
        number = (num / 1000).toFixed(fixed);
        if (!withComma) {
            number = numeral__WEBPACK_IMPORTED_MODULE_0___default()(number).format("0,0");
        } else {
            number = numeral__WEBPACK_IMPORTED_MODULE_0___default()(number).format(typeof withComma === "string" ? withComma : "0,0.0");
        }
        if (symbol) {
            number += "K";
        }
    } else {
        number = num;
    }
    return number;
}
var numberFormat = function(param) {
    var value = param.value, decimals = param.decimals, _decimalPoint = param.decimalPoint, decimalPoint = _decimalPoint === void 0 ? "." : _decimalPoint, _thousandSeparator = param.thousandSeparator, thousandSeparator = _thousandSeparator === void 0 ? "," : _thousandSeparator;
    //  discuss at: http://phpjs.org/functions/number_format/
    // original by: Jonas Raoni Soares Silva (http://www.jsfromhell.com)
    // improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // improved by: davook
    // improved by: Brett Zamir (http://brett-zamir.me)
    // improved by: Brett Zamir (http://brett-zamir.me)
    // improved by: Theriault
    // improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // bugfixed by: Michael White (http://getsprink.com)
    // bugfixed by: Benjamin Lupton
    // bugfixed by: Allan Jensen (http://www.winternet.no)
    // bugfixed by: Howard Yeend
    // bugfixed by: Diogo Resende
    // bugfixed by: Rival
    // bugfixed by: Brett Zamir (http://brett-zamir.me)
    //  revised by: Jonas Raoni Soares Silva (http://www.jsfromhell.com)
    //  revised by: Luke Smith (http://lucassmith.name)
    //    input by: Kheang Hok Chin (http://www.distantia.ca/)
    //    input by: Jay Klehr
    //    input by: Amir Habibi (http://www.residence-mixte.com/)
    //    input by: Amirouche
    //   example 1: number_format(1234.56);
    //   returns 1: '1,235'
    //   example 2: number_format(1234.56, 2, ',', ' ');
    //   returns 2: '1 234,56'
    //   example 3: number_format(1234.5678, 2, '.', '');
    //   returns 3: '1234.57'
    //   example 4: number_format(67, 2, ',', '.');
    //   returns 4: '67,00'
    //   example 5: number_format(1000);
    //   returns 5: '1,000'
    //   example 6: number_format(67.311, 2);
    //   returns 6: '67.31'
    //   example 7: number_format(1000.55, 1);
    //   returns 7: '1,000.6'
    //   example 8: number_format(67000, 5, ',', '.');
    //   returns 8: '67.000,00000'
    //   example 9: number_format(0.9, 0);
    //   returns 9: '1'
    //  example 10: number_format('1.20', 2);
    //  returns 10: '1.20'
    //  example 11: number_format('1.20', 4);
    //  returns 11: '1.2000'
    //  example 12: number_format('1.2000', 3);
    //  returns 12: '1.200'
    //  example 13: number_format('1 000,50', 2, '.', ' ');
    //  returns 13: '100 050.00'
    //  example 14: number_format(1e-8, 8, '.', '');
    //  returns 14: '0.00000001'
    var newNumber = value;
    var newDecimals = decimals;
    newNumber = "".concat(newNumber).replace(/[^0-9+\-Ee.]/g, "");
    var number = !isFinite(+newNumber) ? 0 : +newNumber;
    var prec = !isFinite(+newDecimals) ? 0 : Math.abs(newDecimals);
    var sep = thousandSeparator;
    var dec = decimalPoint;
    var sum = "";
    var toFixedFix = function toFixedFix(num, precision) {
        var power = Math.pow(10, precision);
        return "".concat((Math.round(num * power) / power).toFixed(precision));
    };
    // Fix for IE parseFloat(0.55).toFixed(0) = 0;
    sum = (prec ? toFixedFix(number, prec) : "".concat(Math.round(n))).split(".");
    if (sum[0].length > 3) {
        sum[0] = sum[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((sum[1] || "").length < prec) {
        sum[1] = sum[1] || "";
        sum[1] += new Array(prec - sum[1].length + 1).join("0");
    }
    return sum.join(dec);
};
var removeCountDotThousand = function(num) {
    if (!num.includes(".")) return num;
    num = numberFormat({
        value: num,
        decimals: 2
    });
    // pembulatan next index
    return num;
};
var isDecimal = function(result) {
    if (result > Math.floor(result)) {
        return true;
    }
    return false;
};
/* harmony default export */ __webpack_exports__["ZP"] = ({
    countLengthDecimal: countLengthDecimal,
    getRandomInt: getRandomInt,
    decideNumberFormatter: decideNumberFormatter,
    numberFormatter: numberFormatter,
    bNumberFormatter: bNumberFormatter,
    mNumberFormatter: mNumberFormatter,
    kNumberFormatter: kNumberFormatter,
    parseCountAbbrv3: parseCountAbbrv3,
    parseLot: parseLot,
    addPlusOrMinus2: addPlusOrMinus2,
    parseCountAbbrv4: parseCountAbbrv4,
    kNumberFormatterV2: kNumberFormatterV2,
    numberFormat: numberFormat,
    isDecimal: isDecimal,
    parseCountAbbrv2: parseCountAbbrv2
});


/***/ }),

/***/ 20:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://storage.stockbit.com/backpack/1.0.0/static/remoteEntry.js");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if(!window.remoteLoading) {
        window.remoteLoading = {};
    };

    if(window.remoteLoading["backpack"]) {
      return resolve(window.remoteLoading["backpack"])
    }

    var res, rej;
    window.remoteLoading["backpack"] = new Promise(function(rs,rj){
      res = rs;
      rej = rj;
    })

    if (typeof window["backpack"] !== 'undefined') {
      res(window["backpack"]);
      return resolve(window["backpack"]);
    }

     __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof window["backpack"] !== 'undefined') {
          res(window["backpack"]);
          return resolve(window["backpack"]);
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        rej(__webpack_error__);
        reject(__webpack_error__);
      },
      "backpack"
    );
  }).then(function () {
    const proxy = {
      get: backpack.get,
      init: function(shareScope, initToken) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          backpack.init(new Proxy(shareScope, handler), initToken)
        } catch (e) {

        }
        backpack.__initialized = true
      }
    }
    if (!backpack.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });

/***/ }),

/***/ 92064:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://storage.stockbit.com/buy-sell/1.5.8/static/remoteEntry.js");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if(!window.remoteLoading) {
        window.remoteLoading = {};
    };

    if(window.remoteLoading["buysell"]) {
      return resolve(window.remoteLoading["buysell"])
    }

    var res, rej;
    window.remoteLoading["buysell"] = new Promise(function(rs,rj){
      res = rs;
      rej = rj;
    })

    if (typeof window["buysell"] !== 'undefined') {
      res(window["buysell"]);
      return resolve(window["buysell"]);
    }

     __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof window["buysell"] !== 'undefined') {
          res(window["buysell"]);
          return resolve(window["buysell"]);
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        rej(__webpack_error__);
        reject(__webpack_error__);
      },
      "buysell"
    );
  }).then(function () {
    const proxy = {
      get: buysell.get,
      init: function(shareScope, initToken) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          buysell.init(new Proxy(shareScope, handler), initToken)
        } catch (e) {

        }
        buysell.__initialized = true
      }
    }
    if (!buysell.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });

/***/ }),

/***/ 94673:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://storage.stockbit.com/fast-trade/1.1.6/static/remoteEntry.js");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if(!window.remoteLoading) {
        window.remoteLoading = {};
    };

    if(window.remoteLoading["fasttrade"]) {
      return resolve(window.remoteLoading["fasttrade"])
    }

    var res, rej;
    window.remoteLoading["fasttrade"] = new Promise(function(rs,rj){
      res = rs;
      rej = rj;
    })

    if (typeof window["fasttrade"] !== 'undefined') {
      res(window["fasttrade"]);
      return resolve(window["fasttrade"]);
    }

     __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof window["fasttrade"] !== 'undefined') {
          res(window["fasttrade"]);
          return resolve(window["fasttrade"]);
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        rej(__webpack_error__);
        reject(__webpack_error__);
      },
      "fasttrade"
    );
  }).then(function () {
    const proxy = {
      get: fasttrade.get,
      init: function(shareScope, initToken) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          fasttrade.init(new Proxy(shareScope, handler), initToken)
        } catch (e) {

        }
        fasttrade.__initialized = true
      }
    }
    if (!fasttrade.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });

/***/ }),

/***/ 2680:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://storage.stockbit.com/movers/1.0.2/static/remoteEntry.js");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if(!window.remoteLoading) {
        window.remoteLoading = {};
    };

    if(window.remoteLoading["movers"]) {
      return resolve(window.remoteLoading["movers"])
    }

    var res, rej;
    window.remoteLoading["movers"] = new Promise(function(rs,rj){
      res = rs;
      rej = rj;
    })

    if (typeof window["movers"] !== 'undefined') {
      res(window["movers"]);
      return resolve(window["movers"]);
    }

     __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof window["movers"] !== 'undefined') {
          res(window["movers"]);
          return resolve(window["movers"]);
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        rej(__webpack_error__);
        reject(__webpack_error__);
      },
      "movers"
    );
  }).then(function () {
    const proxy = {
      get: movers.get,
      init: function(shareScope, initToken) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          movers.init(new Proxy(shareScope, handler), initToken)
        } catch (e) {

        }
        movers.__initialized = true
      }
    }
    if (!movers.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });

/***/ }),

/***/ 85611:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://storage.stockbit.com/top-stocks/1.0.1/static/remoteEntry.js");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if(!window.remoteLoading) {
        window.remoteLoading = {};
    };

    if(window.remoteLoading["topstocks"]) {
      return resolve(window.remoteLoading["topstocks"])
    }

    var res, rej;
    window.remoteLoading["topstocks"] = new Promise(function(rs,rj){
      res = rs;
      rej = rj;
    })

    if (typeof window["topstocks"] !== 'undefined') {
      res(window["topstocks"]);
      return resolve(window["topstocks"]);
    }

     __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof window["topstocks"] !== 'undefined') {
          res(window["topstocks"]);
          return resolve(window["topstocks"]);
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        rej(__webpack_error__);
        reject(__webpack_error__);
      },
      "topstocks"
    );
  }).then(function () {
    const proxy = {
      get: topstocks.get,
      init: function(shareScope, initToken) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          topstocks.init(new Proxy(shareScope, handler), initToken)
        } catch (e) {

        }
        topstocks.__initialized = true
      }
    }
    if (!topstocks.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });

/***/ }),

/***/ 22868:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 14777:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 99830:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 70209:
/***/ (function() {

/* (ignored) */

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [74885,63332,25287,94119,78656,71577,75819,88069,46819,7648,25935,51225,80129,40142,80737,50299,77549,92961,54253,54005,91036,33070,58928,92077,79931,54663,64019,44912,62571,21671,74768,40927,77284,74673,49774,92888,40179], function() { return __webpack_exec__(274); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);